(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["app-features"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-app-features]');
    if (!root) return;

    const eyebrowEl       = root.querySelector('[data-app-features-eyebrow]');
    const titleEl         = root.querySelector('[data-app-features-title]');
    const descEl          = root.querySelector('[data-app-features-description]');
    const featuredEl      = root.querySelector('[data-app-features-featured]');
    const featuredImageEl = root.querySelector('[data-app-features-featured-image]');
    const featuredVideoEl = root.querySelector('[data-app-features-featured-video]');
    const carouselEl      = root.querySelector('[data-carousel]');
    const slidesEl        = root.querySelector('[data-app-features-slides]');

    const VIDEO_EXT = /\.(mp4|webm|ogg|ogv|mov|m4v)(\?.*)?$/i;
    const isVideoUrl = (url) => typeof url === 'string' && VIDEO_EXT.test(url);
    const isEuMarket = root.hasAttribute('data-eu-market');
    const featuredBadgeEl = root.querySelector('[data-app-features-featured-badge]');
    let comingSoonText = 'coming-soon';

    const appendComingSoonBadge = (mediaEl) => {
      if (!isEuMarket || !mediaEl) return;
      if (mediaEl.querySelector('.app-features__badge')) return;
      const badge = document.createElement('span');
      badge.className = 'app-features__badge';
      badge.textContent = comingSoonText;
      mediaEl.appendChild(badge);
    };

    // Slides arrive with index-prefixed keys (slide-0-title, slide-1-img, …).
    // Strip the prefix so the rest of the code can read plain title/description/img;
    // unprefixed keys pass through untouched.
    const normalizeSlide = (slide) => {
      const out = {};
      Object.keys(slide).forEach((key) => {
        const match = key.match(/^slide-\d+-(.+)$/);
        out[match ? match[1] : key] = slide[key];
      });
      return out;
    };

    // Resolve AEM /content/dam/... paths against the publish origin.
    const resolveAssetUrl = (url) => {
      if (typeof url !== 'string' || !url) return '';
      if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:')) return url;
      const base = window.AEM_PUBLISHING_URL || '';
      return base.replace(/\/$/, '') + (url.startsWith('/') ? url : '/' + url);
    };

    const buildSlide = (slide) => {
      const slideEl = document.createElement('div');
      slideEl.className = 'swiper-slide';

      const card = document.createElement('div');
      card.className = 'app-features__card';

      const media = document.createElement('div');
      media.className = 'app-features__card-media';
      if (slide.img) {
        const img = document.createElement('img');
        img.className = 'app-features__card-image';
        window.setAemImage(img, resolveAssetUrl(slide.img), 'general');
        img.alt = typeof slide.label === 'string' ? slide.label : '';
        img.loading = 'lazy';
        media.appendChild(img);
        appendComingSoonBadge(media);
      }
      card.appendChild(media);

      const content = document.createElement('div');
      content.className = 'app-features__card-content';
      const cardTitle = slide.title || slide.label;
      if (typeof cardTitle === 'string' && cardTitle) {
        const h3 = document.createElement('h3');
        h3.className = 'app-features__card-title';
        h3.textContent = cardTitle;
        content.appendChild(h3);
      }
      if (typeof slide.description === 'string' && slide.description) {
        const p = document.createElement('p');
        p.className = 'app-features__card-description';
        p.textContent = slide.description;
        content.appendChild(p);
      }
      card.appendChild(content);

      slideEl.appendChild(card);
      return slideEl;
    };

    const apply = (aem) => {
      const node = aem && aem['shopify/offers'];
      if (!node) return false;

      const bioniqNode = aem && aem['bioniq/personalization'];
      if (!bioniqNode) return false;

      const eyebrow  = node['personalize-unlock'];
      const title    = node['personalize-title'];
      const descHtml = node['personalize-description'];
      const img      = bioniqNode['static-img'];
      const slides   = bioniqNode['slides'];

      if (typeof bioniqNode['coming-soon'] === 'string' && bioniqNode['coming-soon']) {
        comingSoonText = bioniqNode['coming-soon'];
        if (featuredBadgeEl) featuredBadgeEl.textContent = comingSoonText;
      }

      let hasContent = false;

      if (eyebrowEl) {
        eyebrowEl.textContent = (typeof eyebrow === 'string' && eyebrow) ? eyebrow : 'personalize-unlock';
        eyebrowEl.hidden = false;
        hasContent = true;
      }

      if (titleEl) {
        titleEl.textContent = (typeof title === 'string' && title) ? title : 'personalize-title';
        titleEl.hidden = false;
        hasContent = true;
      }

      if (descEl && typeof descHtml === 'string' && descHtml) {
        descEl.innerHTML = descHtml;
        descEl.hidden = false;
        hasContent = true;
      }

      if (featuredEl && typeof img === 'string' && img) {
        const url = resolveAssetUrl(img);
        if (isVideoUrl(img) && featuredVideoEl) {
          featuredVideoEl.src = url;
          featuredVideoEl.hidden = false;
          if (featuredImageEl) featuredImageEl.hidden = true;
          if (featuredBadgeEl) featuredBadgeEl.hidden = true;
        } else if (featuredImageEl) {
          window.setAemImage(featuredImageEl, url, 'general');
          if (typeof title === 'string') featuredImageEl.alt = title;
          featuredImageEl.hidden = false;
          if (featuredVideoEl) featuredVideoEl.hidden = true;
          if (featuredBadgeEl) featuredBadgeEl.hidden = false;
        }
        hasContent = true;
      }

      if (slidesEl && Array.isArray(slides) && slides.length > 0) {
        slidesEl.replaceChildren();
        slides.forEach((s) => {
          if (s && typeof s === 'object') slidesEl.appendChild(buildSlide(normalizeSlide(s)));
        });
        // Slides were injected after the initial carousel init — rebuild Swiper.
        if (carouselEl && typeof window.reinitializeCarousel === 'function') {
          window.reinitializeCarousel(carouselEl);
        }
        hasContent = true;
      }

      return hasContent;
    };

    if (typeof window.attachSectionLoading === 'function') {
      window.attachSectionLoading({ root, source: 'aem', apply, label: 'app-features', timeoutMs: 60000 });
    } else if (window.dataAEM) {
      apply(window.dataAEM);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["app-only-get-the-app"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-app-only-get-app]');
    if (!root) return;

    const isEuMarket = root.hasAttribute('data-eu-market');

    const resolveAssetUrl = (url) => {
      if (typeof url !== 'string' || !url) return '';
      if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:')) return url;
      const base = window.AEM_PUBLISHING_URL || '';
      return base.replace(/\/$/, '') + (url.startsWith('/') ? url : '/' + url);
    };

    const setText = (sel, value) => {
      const el = root.querySelector(sel);
      if (el && typeof value === 'string' && value) { el.textContent = value; el.hidden = false; }
    };

    const setHtml = (sel, value) => {
      const el = root.querySelector(sel);
      if (el && typeof value === 'string' && value) { el.innerHTML = value; el.hidden = false; }
    };

    const setImage = (sel, value) => {
      const el = root.querySelector(sel);
      if (el) { window.setAemImage(el, resolveAssetUrl(value), 'general'); el.hidden = false; }
    };

    const apply = (aem) => {
      const node = aem && aem['shopify/get-pro2col'];
      if (!node) return false;
      
      const input = root.querySelector('[data-gta-acct-input]');
      if (input && node['create-acct-placeholder']) input.placeholder = node['create-acct-placeholder'];

      setImage('[data-gta-image]', node['image']);
      setImage('[data-gta-badge-google-img]', node['badge-google-img']);
      setImage('[data-gta-badge-apple-img]', node['badge-apple-img']);

      if (!isEuMarket) {
        setText('[data-gta-title]', node['title'] || 'title');
        setHtml('[data-gta-description]', node['description']);
        setHtml('[data-gta-questions]', node['btn-questions']);
        // AEM rewrites the anchor href, so re-point it at #faqs to open the FAQs modal
        root.querySelectorAll('[data-gta-questions] a').forEach((a) => a.setAttribute('href', '#faqs'));
        setText('[data-gta-acct-label]', node['create-acct-label'] || 'create-acct-label');
        setText('[data-gta-acct-btn]', node['create-acct-btn'] || 'create-acct-btn');
        setText('[data-gta-helper]', node['helper-text'] || 'helper-text');
      } else {
        setText('[data-gta-title]', node['title-soon'] || 'title-soon');
        setHtml('[data-gta-description]', node['description-soon']);
        setText('[data-gta-badge]', node['coming-soon-badge'] || 'coming-soon-badge');
      }
      
      const gBtn = root.querySelector('[data-gta-badge-google]');
      if (gBtn && node['badge-google-link']) gBtn.setAttribute('data-store-url', node['badge-google-link']);
      const aBtn = root.querySelector('[data-gta-badge-apple]');
      if (aBtn && node['badge-apple-link']) aBtn.setAttribute('data-store-url', node['badge-apple-link']);

      return true;
    };

    if (typeof window.attachSectionLoading === 'function') {
      window.attachSectionLoading({ root, source: 'aem', apply, label: 'app-only-get-the-app', timeoutMs: 60000 });
    } else if (window.dataAEM) {
      apply(window.dataAEM);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["app-only-hero2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-app-only-hero2]');
    if (!root) return;

    const titleEl = root.querySelector('[data-hero2-title]');
    const descEl  = root.querySelector('[data-hero2-description]');
    const mediaEl = root.querySelector('[data-hero2-media]');
    const imageEl = root.querySelector('[data-hero2-image]');
    const videoEl = root.querySelector('[data-hero2-video]');
    const ctaEl   = root.querySelector('[data-hero2-cta]');
    const ctaLabelEl = root.querySelector('[data-hero2-cta-label]');

    const VIDEO_EXT = /\.(mp4|webm|ogg|ogv|mov|m4v)(\?.*)?$/i;
    const isVideoUrl = (url) => typeof url === 'string' && VIDEO_EXT.test(url);

    // Fixed hero videos for the US locales — these ALWAYS win over whatever
    // assetUrl the DMO sends. Other locales keep the DMO-provided media.
    const HERO_VIDEO_OVERRIDES = {
      'en-us': 'https://cdn.shopify.com/videos/c/o/v/85aba6725cb044a8986b9ce2e70d51b6.mp4',
      'es-us': 'https://cdn.shopify.com/videos/c/o/v/74400d970d9c4d20afb636e4ed79f450.mp4'
    };
    const pageLocale = (() => {
      const m = window.location.pathname.match(/^\/([a-z]{2}-[a-z]{2})(?=\/|$)/i);
      return m ? m[1].toLowerCase() : 'en-us';
    })();
    const heroVideoOverride = HERO_VIDEO_OVERRIDES[pageLocale] || '';

    // Mirrors the find-your-age URL builder (see banner-with-card / external-links).
    const buildFindYourAgeUrl = () => {
      const baseUrl = (window.externalLinks && window.externalLinks.findYourAgeUrl) || '';
      if (!baseUrl) return '';
      const cleanBase = baseUrl.replace(/\/$/, '');
      const firstSegment = window.location.pathname.split('/').filter(Boolean)[0] || '';
      const locale = /^[a-z]{2}(-[a-z]{2})?$/i.test(firstSegment) ? firstSegment : '';
      const path = locale ? '/' + locale + '/Intro' : '/Intro';
      // Preserve the current query string AND guarantee the site identifier is
      // present: `site` often lives only in storage (the redirect helper keeps
      // it there), so window.location.search alone drops it. Mirror
      // theme-redirects.js by falling back to shopify_site_identifier.
      const search = new URLSearchParams(window.location.search);
      if (!search.get('site')) {
        const storedSite = (sessionStorage.getItem('shopify_site_identifier') || localStorage.getItem('shopify_site_identifier') || '').trim();
        if (storedSite) search.set('site', storedSite);
      }
      const qs = search.toString();
      return cleanBase + path + (qs ? '?' + qs : '');
    };

    const playVideo = () => {
      if (!videoEl) return;
      videoEl.muted = true;
      videoEl.setAttribute('playsinline', '');
      videoEl.play().catch(function () {});
    };

    const apply = (data) => {
      const hero = data && data.theme && data.theme.hero;
      if (!hero) return false;

      if (titleEl && hero.title) { titleEl.textContent = hero.title; titleEl.hidden = false; }

      if (descEl && hero.showBody && hero.body) {
        descEl.textContent = hero.body;
        descEl.hidden = false;
      }

      const assetUrl = heroVideoOverride || hero.assetUrl;
      if (mediaEl && assetUrl) {
        if (isVideoUrl(assetUrl) && videoEl) {
          videoEl.src = assetUrl;
          videoEl.hidden = false;
          playVideo();
        } else if (imageEl) {
          imageEl.src = assetUrl;
          if (hero.title) imageEl.alt = hero.title;
          imageEl.hidden = false;
        }
      }

      // Wire the assessment button for either BEFORE_ASSESSMENT (user hasn't
      // taken it yet) or AFTER_ASSESSMENT — both point at the find-your-age quiz.
      // Sites with pro2colDownloadDisabled === true do not offer the quiz at
      // all, so the CTA stays hidden whatever the backend says. Absent flag
      // means enabled (see DMO/assessment-availability.ts).
      const assessmentEnabled = !(data && data.pro2colDownloadDisabled === true);
      if (ctaEl && assessmentEnabled && (hero.cta === 'BEFORE_ASSESSMENT' || hero.cta === 'AFTER_ASSESSMENT')) {
        const url = buildFindYourAgeUrl();
        if (url) ctaEl.href = url;
        ctaEl.hidden = false;
      }


      return true;
    };

    const applyAemLabel = (aem) => {
      if (!ctaLabelEl) return false;
      const home = aem && aem['shopify/shopify-homepage'];
      const label = home && home['banner-with-card-cta'];
      if (typeof label === 'string' && label) ctaLabelEl.textContent = label;
      return true;
    };

    if (typeof window.attachSectionLoading === 'function') {
      window.attachSectionLoading({ root, source: 'dmo', apply, label: 'app-only-hero2' });
    } else if (window.data) {
      apply(window.data);
    }

    // AEM label is non-critical — never block rendering on it, no timeout.
    if (window.dataAEM) {
      applyAemLabel(window.dataAEM);
    } else {
      document.addEventListener('aem:data:loaded', (e) => applyAemLabel(e.detail || window.dataAEM), { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["app-only-reveal-your-health"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(section) {
      var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-reveal-tab]'));
      var panels = section.querySelectorAll('[data-reveal-panel]');
      var progressBar = section.querySelector('[data-reveal-progress]');
      var prevBtn = section.querySelector('[data-reveal-prev]');
      var nextBtn = section.querySelector('[data-reveal-next]');

      if (!tabs.length || !panels.length) return;

      var columnIndex = 0;
      var columnCount = 2;

      function getActivePanel() {
        return section.querySelector('[data-reveal-panel].is-active');
      }

      function setPanelColumn(panel, index) {
        if (!panel) return;
        panel.classList.toggle('is-reveal-step-right', index === 1);
      }

      function updateNav(stepIndex) {
        if (!progressBar || !prevBtn || !nextBtn) return;

        var segmentWidth = 100 / columnCount;

        progressBar.style.width = segmentWidth + '%';
        progressBar.style.transform = 'translateX(' + stepIndex * 100 + '%)';

        prevBtn.disabled = stepIndex <= 0;
        nextBtn.disabled = stepIndex >= columnCount - 1;
      }

      function setColumn(index) {
        if (index < 0 || index >= columnCount) return;

        columnIndex = index;
        setPanelColumn(getActivePanel(), index);
        updateNav(index);
      }

      function activateTab(index) {
        if (index < 0 || index >= tabs.length) return;

        var tab = tabs[index];
        var target = tab.getAttribute('data-reveal-tab');

        tabs.forEach(function (t) {
          var isActive = t === tab;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var isActive = panel.getAttribute('data-reveal-panel') === target;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
          panel.classList.remove('is-reveal-step-right');
        });

        columnIndex = 0;

        if (window.matchMedia('(max-width: 768px)').matches) {
          tab.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
        }

        updateNav(0);
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activateTab(index);
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          setColumn(columnIndex - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          setColumn(columnIndex + 1);
        });
      }

      setPanelColumn(getActivePanel(), 0);
      updateNav(0);
    }

    var root = document.querySelector('[data-app-only-reveal]');
    if (!root) return;

    function resolveAssetUrl(url) {
      if (typeof url !== 'string' || !url) return '';
      if (/^(https?:)?\/\//i.test(url) || url.indexOf('data:') === 0) return url;
      var base = window.AEM_PUBLISHING_URL || '';
      return base.replace(/\/$/, '') + (url.charAt(0) === '/' ? url : '/' + url);
    }

    // Load eagerly, then fade in only once fully decoded — avoids the
    // progressive "paints in chunks" look while the AEM-hosted image streams in.
    function revealImage(img, url, eager) {
      img.classList.remove('is-loaded');
      img.setAttribute('fetchpriority', eager ? 'high' : 'low');
      window.setAemImage(img, url, 'general');
      img.hidden = false;
      var show = function () { img.classList.add('is-loaded'); };
      if (img.decode) {
        img.decode().then(show).catch(show);
      } else if (img.complete) {
        show();
      } else {
        img.addEventListener('load', show, { once: true });
        img.addEventListener('error', show, { once: true });
      }
    }

    function applyAem(aem) {
      var node = aem && aem['shopify/full-picture'];
      if (!node) return false;

      var titleEl = root.querySelector('[data-reveal-title]');
      if (titleEl) { titleEl.textContent = (typeof node.title === 'string' && node.title) ? node.title : 'title'; titleEl.hidden = false; }

      var tabsData = Array.isArray(node.tabs) ? node.tabs : [];
      var tabBtns = root.querySelectorAll('[data-reveal-tab]');
      var panels = root.querySelectorAll('[data-reveal-panel]');

      tabsData.forEach(function (t, i) {
        if (!t || typeof t !== 'object') return;
        if (tabBtns[i] && t.title) tabBtns[i].textContent = t.title;
        var panel = panels[i];
        if (!panel) return;
        var h = panel.querySelector('[data-reveal-heading]');
        if (h && t.title) h.textContent = t.title;
        var p = panel.querySelector('[data-reveal-text]');
        if (p && t.description) p.innerHTML = t.description;
        var lvideo = panel.querySelector('[data-reveal-left-video]');
        if (lvideo && t['img-0']) {
          lvideo.src = resolveAssetUrl(t['img-0']);
          lvideo.hidden = false;
          lvideo.play().catch(function () {});
        }
        var rimg = panel.querySelector('[data-reveal-right-img]');
        if (rimg && t['img-1']) { revealImage(rimg, resolveAssetUrl(t['img-1']), i === 0); }
      });

      var hasContent = !!node.title || tabsData.length > 0;
      if (hasContent) initSection(root);
      return hasContent;
    }

    if (typeof window.attachSectionLoading === 'function') {
      window.attachSectionLoading({ root: root, source: 'aem', apply: applyAem, label: 'app-only-reveal-your-health', timeoutMs: 60000 });
    } else if (window.dataAEM) {
      applyAem(window.dataAEM);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["app-only-wellness-journey"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-app-only-wj]');
    if (!root) return;

    const titleEl = root.querySelector('[data-wj-title]');
    const descEl  = root.querySelector('[data-wj-description]');
    const mediaEl = root.querySelector('[data-wj-media]');
    const imageEl = root.querySelector('[data-wj-image]');
    const videoEl = root.querySelector('[data-wj-video]');
    const logoWrap = root.querySelector('[data-wj-logo-wrap]');
    const logoImg = root.querySelector('[data-wj-logo]');

    const VIDEO_EXT = /\.(mp4|webm|ogg|ogv|mov|m4v)(\?.*)?$/i;
    const isVideoUrl = (url) => typeof url === 'string' && VIDEO_EXT.test(url);

    const resolveAssetUrl = (url) => {
      if (typeof url !== 'string' || !url) return '';
      if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:')) return url;
      const base = window.AEM_PUBLISHING_URL || '';
      return base.replace(/\/$/, '') + (url.startsWith('/') ? url : '/' + url);
    };

    // Main content from DMO bannerFooter.
    const apply = (data) => {
      const banner = data && data.theme && data.theme.bannerFooter;
      if (!banner) return false;

      if (titleEl && banner.title) { titleEl.textContent = banner.title; titleEl.hidden = false; }

      if (descEl && banner.descriptionEnabled && banner.description) {
        descEl.textContent = banner.description;
        descEl.hidden = false;
      }

      if (mediaEl && banner.photoUrl) {
        if (isVideoUrl(banner.photoUrl) && videoEl) {
          videoEl.src = banner.photoUrl;
          videoEl.hidden = false;
        } else if (imageEl) {
          imageEl.src = banner.photoUrl;
          if (banner.title) imageEl.alt = banner.title;
          imageEl.hidden = false;
        }
      }

      return true;
    };

    // Logo from AEM full-picture (non-critical; never blocks reveal).
    const applyLogo = (aem) => {
      const node = aem && aem['shopify/full-picture'];
      const logo = node && node['pro2col-logo'];
      if (logoImg && logoWrap && typeof logo === 'string' && logo) {
        window.setAemImage(logoImg, resolveAssetUrl(logo), 'general');
        logoWrap.hidden = false;
      }
    };

    if (typeof window.attachSectionLoading === 'function') {
      window.attachSectionLoading({ root, source: 'dmo', apply, label: 'app-only-wellness-journey' });
    } else if (window.data) {
      apply(window.data);
    }

    if (window.dataAEM) {
      applyLogo(window.dataAEM);
    } else {
      document.addEventListener('aem:data:loaded', (e) => applyLogo(e.detail || window.dataAEM), { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-with-card"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-banner-with-card]');
    if (!root) return;

    const titleEl    = root.querySelector('[data-banner-with-card-title]');
    const descEl     = root.querySelector('[data-banner-with-card-description]');
    const mediaEl    = root.querySelector('[data-banner-with-card-media]');
    const imageEl    = root.querySelector('[data-banner-with-card-image]');
    const videoEl    = root.querySelector('[data-banner-with-card-video]');
    const ctaEl      = root.querySelector('[data-banner-with-card-cta]');
    const ctaLabelEl = root.querySelector('[data-banner-with-card-cta-label]');

    const VIDEO_EXT = /\.(mp4|webm|ogg|ogv|mov|m4v)(\?.*)?$/i;
    const isVideoUrl = (url) => typeof url === 'string' && VIDEO_EXT.test(url);

    // Mirrors the find-your-age URL builder that used to live in
    // src/scripts/DMO/external-links.ts (currently deleted on new-store-qa).
    // Inlined here so the assessment CTA still works on this branch.
    const buildFindYourAgeUrl = () => {
      const baseUrl = (window.externalLinks && window.externalLinks.findYourAgeUrl) || '';
      if (!baseUrl) return '';
      const cleanBase = baseUrl.replace(/\/$/, '');
      const firstSegment = window.location.pathname.split('/').filter(Boolean)[0] || '';
      const localePattern = /^[a-z]{2}(-[a-z]{2})?$/i;
      const locale = localePattern.test(firstSegment) ? firstSegment : '';
      const path = locale ? '/' + locale + '/Intro' : '/Intro';
      // Preserve the current query string AND guarantee the site identifier is
      // present: `site` often lives only in storage (the redirect helper keeps
      // it there), so window.location.search alone drops it. Mirror
      // theme-redirects.js by falling back to shopify_site_identifier.
      const search = new URLSearchParams(window.location.search);
      if (!search.get('site')) {
        const storedSite = (sessionStorage.getItem('shopify_site_identifier') || localStorage.getItem('shopify_site_identifier') || '').trim();
        if (storedSite) search.set('site', storedSite);
      }
      const qs = search.toString();
      return cleanBase + path + (qs ? '?' + qs : '');
    };

    const applyDmo = (data) => {
      const hero = data && data.theme && (data.theme.bannerWithCard || data.theme.hero);
      if (!hero) return false;

      if (titleEl && hero.title) titleEl.textContent = hero.title;

      if (descEl && hero.showBody && hero.body) {
        descEl.textContent = hero.body;
        descEl.hidden = false;
      }

      if (mediaEl && hero.assetUrl) {
        // The preview re-injects data on every theme change, so reset the
        // unused element each time — otherwise switching media type (e.g.
        // General's image → Nutritional Club's video) reveals the new element
        // while the previously-revealed one stays visible, stacking both.
        if (isVideoUrl(hero.assetUrl) && videoEl) {
          videoEl.src = hero.assetUrl;
          videoEl.hidden = false;
          if (imageEl) {
            imageEl.hidden = true;
            imageEl.removeAttribute('src');
          }
        } else if (imageEl) {
          imageEl.src = hero.assetUrl;
          if (hero.title) imageEl.alt = hero.title;
          imageEl.hidden = false;
          if (videoEl) {
            videoEl.hidden = true;
            videoEl.pause();
            videoEl.removeAttribute('src');
            videoEl.load();
          }
        }
        mediaEl.hidden = false;
      }

      // The backend signals the assessment CTA with either BEFORE_ASSESSMENT
      // (user hasn't taken it yet — the common homepage case) or
      // AFTER_ASSESSMENT. Both wire the "Take the Wellness Assessment" button to
      // the find-your-age quiz. Previously only AFTER_ASSESSMENT was handled, so
      // on US (which returns BEFORE_ASSESSMENT) the button kept its empty href
      // and a click just reloaded the homepage.
      // Sites with pro2colDownloadDisabled === true do not offer the quiz at
      // all, so the CTA stays hidden whatever the backend says. Absent flag
      // means enabled (see DMO/assessment-availability.ts).
      const assessmentEnabled = !(data && data.pro2colDownloadDisabled === true);
      if (ctaEl && assessmentEnabled && (hero.cta === 'BEFORE_ASSESSMENT' || hero.cta === 'AFTER_ASSESSMENT')) {
        const url = buildFindYourAgeUrl();
        if (url) ctaEl.href = url;
        ctaEl.hidden = false;
      }

      return true;
    };

    const applyAemLabel = (aem) => {
      if (!ctaLabelEl) return false;
      const home = aem && aem['shopify/shopify-homepage'];
      const label = home && home['banner-with-card-cta'];
      ctaLabelEl.textContent = (typeof label === 'string' && label) ? label : 'banner-with-card-cta';
      return true;
    };

    if (typeof window.attachSectionLoading === 'function') {
      window.attachSectionLoading({ root, source: 'dmo', apply: applyDmo, label: 'banner-with-card' });
    } else if (window.data) {
      applyDmo(window.data);
    }

    // AEM label is non-critical — never block rendering on it, no timeout.
    if (window.dataAEM) {
      applyAemLabel(window.dataAEM);
    } else {
      document.addEventListener('aem:data:loaded', (e) => applyAemLabel(e.detail || window.dataAEM), { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biomarkers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-biomarkers]');
    if (!root) return;

    const titleEl = root.querySelector('[data-biomarkers-title]');
    const descEl  = root.querySelector('[data-biomarkers-description]');
    const tabsEl  = root.querySelector('[data-biomarkers-tabs]');
    const cardsEl = root.querySelector('[data-biomarkers-cards]');
    const template = document.querySelector('[data-biomarkers-card-template]');

    const resolveAssetUrl = (url) => {
      if (typeof url !== 'string' || !url) return '';
      if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:')) return url;
      const base = window.AEM_PUBLISHING_URL || '';
      return base.replace(/\/$/, '') + (url.startsWith('/') ? url : '/' + url);
    };

    const slugify = (s) =>
      String(s || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '') || 'tab';

    // AEM tab shape is irregular. Cards live as flat keys: card-N-title,
    // card-N-img|image, card-N-bio (array) or card-N-bio-0/1/2... Some tabs
    // also carry the container id as a prefix (tab-0-card-0-bio), so keys are
    // matched exactly first and by "-suffix" second.
    const pick = (obj, suffixes) => {
      for (const suffix of suffixes) {
        if (obj[suffix] !== undefined) return obj[suffix];
      }
      const keys = Object.keys(obj);
      for (const suffix of suffixes) {
        const match = keys.find((key) => key.endsWith('-' + suffix));
        if (match) return obj[match];
      }
      return undefined;
    };

    const collectBio = (rawTab, n) => {
      const direct = pick(rawTab, ['card-' + n + '-bio']);
      if (Array.isArray(direct)) return direct.filter((v) => typeof v === 'string' && v);
      if (typeof direct === 'string' && direct) return [direct];
      const bio = [];
      for (let b = 0; b < 24; b++) {
        const val = pick(rawTab, ['card-' + n + '-bio-' + b]);
        if (typeof val === 'string' && val) bio.push(val);
      }
      return bio;
    };

    const normalizeTab = (rawTab, idx) => {
      if (!rawTab || typeof rawTab !== 'object') return null;
      const label = (typeof rawTab.label === 'string' && rawTab.label) ||
                    (typeof rawTab.title === 'string' && rawTab.title) || '';
      const cards = [];
      for (let n = 0; n < 12; n++) {
        const title = pick(rawTab, ['card-' + n + '-title']);
        if (typeof title !== 'string' || !title) continue;
        const img = pick(rawTab, ['card-' + n + '-img', 'card-' + n + '-image']) || '';
        cards.push({ title, img, bio: collectBio(rawTab, n) });
      }
      return {
        id: slugify(label) || ('tab-' + idx),
        label,
        cards,
      };
    };

    let state = { tabs: [] };
    let activeTabId = '';

    const carouselContainer = root.querySelector('[data-carousel]');

    const syncLockState = () => {
      const swiperEl = carouselContainer && carouselContainer.querySelector('.swiper');
      const sw = swiperEl && swiperEl.swiper;
      if (!sw || !carouselContainer) return;
      carouselContainer.classList.toggle('is-locked', sw.isLocked === true);
    };

    const bindSwiperEvents = () => {
      const swiperEl = carouselContainer && carouselContainer.querySelector('.swiper');
      const sw = swiperEl && swiperEl.swiper;
      if (!sw) {
        setTimeout(bindSwiperEvents, 100);
        return;
      }
      sw.on('lock', () => carouselContainer.classList.add('is-locked'));
      sw.on('unlock', () => carouselContainer.classList.remove('is-locked'));
      sw.on('resize', syncLockState);
      sw.on('breakpoint', syncLockState);
      syncLockState();
    };
    bindSwiperEvents();

    const renderTabs = () => {
      if (!tabsEl) return;
      tabsEl.replaceChildren();
      // One tab = nothing to switch between, so it renders as a plain sub-title.
      tabsEl.classList.toggle('biomarkers__tabs--single', state.tabs.length < 2);
      state.tabs.forEach((tab) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'biomarkers__tab' + (tab.id === activeTabId ? ' biomarkers__tab--active' : '');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('data-biomarkers-tab', tab.id);
        btn.setAttribute('aria-selected', tab.id === activeTabId ? 'true' : 'false');
        btn.textContent = tab.label || '';
        tabsEl.appendChild(btn);
      });
    };

    const renderCards = () => {
      if (!cardsEl) return;
      cardsEl.replaceChildren();
      const tab = state.tabs.find((t) => t.id === activeTabId);
      if (!tab || !Array.isArray(tab.cards)) return;

      tab.cards.forEach((card) => {
        let slide;
        if (template && template.content && template.content.firstElementChild) {
          slide = template.content.firstElementChild.cloneNode(true);
        } else {
          slide = document.createElement('div');
          slide.className = 'swiper-slide biomarkers__card';
        }

        const imgEl = slide.querySelector('[data-biomarkers-card-image]');
        const titleElCard = slide.querySelector('[data-biomarkers-card-title]');
        const tagsEl = slide.querySelector('[data-biomarkers-card-tags]');

        if (imgEl) {
          const src = resolveAssetUrl(card.img);
          window.setAemImage(imgEl, src, 'general');
          imgEl.alt = card.title || '';
        }
        if (titleElCard) titleElCard.textContent = card.title || '';
        if (tagsEl) {
          tagsEl.replaceChildren();
          (Array.isArray(card.bio) ? card.bio : []).forEach((tag) => {
            if (typeof tag !== 'string' || !tag) return;
            const pill = document.createElement('span');
            pill.className = 'biomarkers__card-tag';
            pill.textContent = tag;
            tagsEl.appendChild(pill);
          });
        }

        cardsEl.appendChild(slide);
      });

      const carouselEl = root.querySelector('[data-carousel] .swiper');
      if (carouselEl && carouselEl.swiper) {
        setTimeout(() => {
          carouselEl.swiper.update();
          // Switching tabs swaps the whole slide set — start from the first card.
          carouselEl.swiper.slideTo(0, 0);
          syncLockState();
        }, 50);
      }
    };

    if (tabsEl) {
      tabsEl.addEventListener('click', (e) => {
        const target = e.target.closest('[data-biomarkers-tab]');
        if (!target) return;
        const id = target.getAttribute('data-biomarkers-tab');
        if (!id || id === activeTabId) return;
        activeTabId = id;
        renderTabs();
        renderCards();
      });
    }

    const apply = (aem) => {
      const node = aem && aem['shopify/measure-what-matters'];
      if (!node) return false;

      let hasContent = false;

      if (titleEl) {
        titleEl.textContent = (typeof node.title === 'string' && node.title) ? node.title : 'title';
        hasContent = true;
      }
      if (descEl && typeof node.description === 'string' && node.description) {
        descEl.innerHTML = node.description;
        hasContent = true;
      }

      if (Array.isArray(node.tabs) && node.tabs.length) {
        // A tab only earns a pill once AEM gives it at least one card. Tabs
        // published as a label with no cards (as the hormone panels were) are
        // dropped; if that leaves a single tab, renderTabs falls back to the
        // plain sub-title look.
        const labelled = node.tabs.map(normalizeTab).filter((t) => t && t.label);
        const withCards = labelled.filter((t) => t.cards.length);
        const tabs = withCards.length ? withCards : labelled.slice(0, 1);
        if (tabs.length) {
          state = { tabs };
          activeTabId = tabs[0].id;
          renderTabs();
          renderCards();
          hasContent = true;
        }
      }

      return hasContent;
    };

    if (typeof window.attachSectionLoading === 'function') {
      window.attachSectionLoading({ root, source: 'aem', apply, label: 'biomarkers', timeoutMs: 60000 });
    } else if (window.dataAEM) {
      apply(window.dataAEM);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blood-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-blood-faq]');
    if (!root) return;

    // Show only the first N items; reveal the rest when "Show more" is clicked.
    const VISIBLE_COUNT = 5;
    const loadMoreBtn = root.querySelector('[data-blood-faq-load-more]');

    const applyLoadMore = () => {
      const list = root.querySelector('[data-blood-faq-items]');
      if (!list) return;
      const items = Array.from(list.querySelectorAll('[data-blood-faq-item]'));
      const hasMore = items.length > VISIBLE_COUNT;
      items.forEach((item, i) => {
        item.classList.toggle('blood-faq__item--collapsed', hasMore && i >= VISIBLE_COUNT);
      });
      if (loadMoreBtn) loadMoreBtn.hidden = !hasMore;
    };

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', () => {
        root
          .querySelectorAll('[data-blood-faq-item].blood-faq__item--collapsed')
          .forEach((item) => item.classList.remove('blood-faq__item--collapsed'));
        loadMoreBtn.hidden = true;
      });
    }

    // FAQ entries arrive in two shapes: { question, answer } OR
    // { faq-NN-question, faq-NN-answer } as flat keys. Normalize.
    const normalizeEntry = (entry) => {
      if (!entry || typeof entry !== 'object') return null;
      if (typeof entry.question === 'string' && entry.question) {
        return { q: entry.question, a: typeof entry.answer === 'string' ? entry.answer : '' };
      }
      const qKey = Object.keys(entry).find((k) => /-question$/.test(k));
      if (qKey && typeof entry[qKey] === 'string' && entry[qKey]) {
        const aKey = qKey.replace(/-question$/, '-answer');
        return { q: entry[qKey], a: typeof entry[aKey] === 'string' ? entry[aKey] : '' };
      }
      return null;
    };

    const apply = (aem) => {
      const node = aem && aem['shopify/faq-bloodwork'];
      if (!node) return false;

      let hasContent = false;

      const titleEl = root.querySelector('[data-blood-faq-title]');
      if (titleEl && typeof node.title === 'string' && node.title) {
        titleEl.textContent = node.title;
        hasContent = true;
      }

      if (Array.isArray(node['faq-container']) && node['faq-container'].length) {
        const list = root.querySelector('[data-blood-faq-items]');
        const template = list && list.querySelector('[data-blood-faq-item]');
        if (list && template) {
          const fragment = document.createDocumentFragment();
          node['faq-container'].forEach((rawEntry) => {
            const entry = normalizeEntry(rawEntry);
            if (!entry) return;
            const clone = template.cloneNode(true);
            const qEl = clone.querySelector('[data-blood-faq-item-title]');
            const aEl = clone.querySelector('[data-blood-faq-item-description]');
            if (qEl) qEl.textContent = entry.q;
            if (aEl) aEl.innerHTML = entry.a;
            const details = clone.querySelector('details');
            if (details) details.open = false;
            fragment.appendChild(clone);
          });
          list.replaceChildren(fragment);
          applyLoadMore();
          hasContent = true;
        }
      }

      return hasContent;
    };

    // Limit the static fallback content too (before AEM resolves / if it doesn't).
    applyLoadMore();

    if (typeof window.attachSectionLoading === 'function') {
      window.attachSectionLoading({ root, source: 'aem', apply, label: 'blood-faq', timeoutMs: 60000 });
    } else if (window.dataAEM) {
      apply(window.dataAEM);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blood-science"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-blood-science]');
    if (!root) return;

    const modal      = root.querySelector('[data-blood-science-modal]');
    const modalTitle = modal && modal.querySelector('[data-blood-science-modal-title]');
    const modalImage = modal && modal.querySelector('[data-blood-science-modal-image]');
    const modalTags  = modal && modal.querySelector('[data-blood-science-modal-tags]');
    const modalBio   = modal && modal.querySelector('[data-blood-science-modal-bio]');
    const modalClose = modal && modal.querySelector('[data-blood-science-modal-close]');

    const expertsListEl = root.querySelector('[data-blood-science-experts]');
    const expertTemplate = root.querySelector('[data-blood-science-expert]');

    let experts = [];

    const resolveAssetUrl = (url) => {
      if (typeof url !== 'string' || !url) return '';
      if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:')) return url;
      const base = window.AEM_PUBLISHING_URL || '';
      return base.replace(/\/$/, '') + (url.startsWith('/') ? url : '/' + url);
    };

    // Credentials in AEM are HTML (rich text). Extract plain text and split into
    // pills on common separators so tags look like the existing design.
    const credentialsToTags = (html) => {
      if (typeof html !== 'string' || !html) return [];
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const text = (tmp.textContent || '').trim();
      if (!text) return [];
      return text
        .split(/\s*(?:,|–|—| - )\s*/)
        .map((s) => s.trim())
        .filter(Boolean);
    };

    const openModal = (index) => {
      if (!modal) return;
      const expert = experts[index];
      if (!expert) return;

      if (modalTitle) modalTitle.textContent = expert.name || '';
      if (modalImage) {
        const src = resolveAssetUrl(expert.headshot || expert.thumbnail);
        window.setAemImage(modalImage, src, 'general');
        modalImage.alt = expert.name || '';
      }
      if (modalTags) {
        modalTags.replaceChildren();
        (expert.tags || []).forEach((tag) => {
          const pill = document.createElement('span');
          pill.className = 'blood-science__modal-tag';
          pill.textContent = tag;
          modalTags.appendChild(pill);
        });
      }
      if (modalBio) modalBio.innerHTML = expert.bio || '';

      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
      document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
      if (!modal) return;
      if (typeof modal.close === 'function') {
        modal.close();
      } else {
        modal.removeAttribute('open');
      }
      document.body.style.overflow = '';
    };

    if (modalClose) modalClose.addEventListener('click', closeModal);
    if (modal) {
      modal.addEventListener('click', (e) => {
        if (e.target === modal) closeModal();
      });
      modal.addEventListener('close', () => { document.body.style.overflow = ''; });
    }

    // Click handler is delegated so it works for slides rebuilt from AEM data.
    if (expertsListEl) {
      expertsListEl.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-blood-science-expert-trigger]');
        if (!btn) return;
        const idx = parseInt(btn.getAttribute('data-expert-index') || '0', 10);
        openModal(idx);
      });
    }

    const buildSlide = (expert, index) => {
      const base = expertTemplate ? expertTemplate.cloneNode(true) : document.createElement('div');
      if (!expertTemplate) {
        base.className = 'swiper-slide blood-science__expert';
        base.setAttribute('data-blood-science-expert', '');
      }
      const imgEl     = base.querySelector('[data-blood-science-expert-image]');
      const nameEl    = base.querySelector('[data-blood-science-expert-name]');
      const triggerEl = base.querySelector('[data-blood-science-expert-trigger]');

      if (imgEl) {
        const src = resolveAssetUrl(expert.thumbnail || expert.headshot);
        window.setAemImage(imgEl, src, 'general');
        imgEl.alt = expert.name || '';
      }
      if (nameEl) nameEl.textContent = expert.name || '';
      if (triggerEl) {
        triggerEl.setAttribute('data-expert-index', String(index));
        if (expert.name) triggerEl.setAttribute('aria-label', 'Open ' + expert.name + ' details');
      }
      return base;
    };

    const apply = (aem) => {
      const node = aem && aem['shopify/expert-design'];
      if (!node) return false;

      let hasContent = false;

      const titleEl = root.querySelector('[data-blood-science-title]');
      const descEl  = root.querySelector('[data-blood-science-description]');
      if (titleEl) {
        titleEl.textContent = (typeof node.title === 'string' && node.title) ? node.title : 'title';
        hasContent = true;
      }
      if (descEl && typeof node.description === 'string' && node.description) {
        descEl.innerHTML = node.description;
        hasContent = true;
      }

      if (Array.isArray(node.experts) && node.experts.length && expertsListEl) {
        experts = node.experts.map((e) => ({
          name: e && e.name,
          thumbnail: e && e.thumbnail,
          headshot: e && e.headshot,
          bio: e && e.bio,
          tags: credentialsToTags(e && e.credentials),
        }));

        expertsListEl.replaceChildren();
        experts.forEach((expert, i) => expertsListEl.appendChild(buildSlide(expert, i)));

        const carouselEl = root.querySelector('[data-carousel] .swiper');
        if (carouselEl && carouselEl.swiper) {
          setTimeout(() => carouselEl.swiper.update(), 50);
        }
        hasContent = true;
      }

      return hasContent;
    };

    if (typeof window.attachSectionLoading === 'function') {
      window.attachSectionLoading({ root, source: 'aem', apply, label: 'blood-science', timeoutMs: 60000 });
    } else if (window.dataAEM) {
      apply(window.dataAEM);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blood-test-features"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-blood-test-features]');
    if (!root) return;

    const titleEl = root.querySelector('[data-blood-test-features-title]');
    const descEl  = root.querySelector('[data-blood-test-features-description]');
    const imageEl = root.querySelector('[data-blood-test-features-image]');
    const listEl  = root.querySelector('[data-blood-test-features-list]');

    const resolveAssetUrl = (url) => {
      if (typeof url !== 'string' || !url) return '';
      if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:')) return url;
      const base = window.AEM_PUBLISHING_URL || '';
      return base.replace(/\/$/, '') + (url.startsWith('/') ? url : '/' + url);
    };

    const itemTemplate = (label) => {
      const li = document.createElement('li');
      li.className = 'blood-test-features__item';
      li.innerHTML =
        '<span class="blood-test-features__icon" aria-hidden="true">' +
          '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M4 10.5L8 14.5L16 6.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</span>' +
        '<span class="blood-test-features__label"></span>';
      li.querySelector('.blood-test-features__label').textContent = label;
      return li;
    };

    const apply = (aem) => {
      const node = aem && aem['shopify/bloodwork'];
      if (!node) return false;

      let hasContent = false;

      if (titleEl) {
        titleEl.textContent = (typeof node.title === 'string' && node.title) ? node.title : 'title';
        hasContent = true;
      }
      if (descEl && typeof node.description === 'string' && node.description) {
        descEl.innerHTML = node.description;
        hasContent = true;
      }
      if (imageEl && typeof node['blood-kit-img'] === 'string' && node['blood-kit-img']) {
        window.setAemImage(imageEl, resolveAssetUrl(node['blood-kit-img']), 'general');
        hasContent = true;
      }
      if (listEl && Array.isArray(node.checks) && node.checks.length) {
        listEl.replaceChildren();
        node.checks.forEach((label) => {
          if (typeof label === 'string' && label) listEl.appendChild(itemTemplate(label));
        });
        hasContent = true;
      }

      return hasContent;
    };

    if (typeof window.attachSectionLoading === 'function') {
      window.attachSectionLoading({ root, source: 'aem', apply, label: 'blood-test-features', timeoutMs: 60000 });
    } else if (window.dataAEM) {
      apply(window.dataAEM);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloodwork-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-bloodwork-footer]');
    if (!root) return;

    const titleEl   = root.querySelector('[data-bloodwork-footer-title]');
    const descEl    = root.querySelector('[data-bloodwork-footer-description]');
    const ctaEl     = root.querySelector('[data-bloodwork-footer-cta]');
    const ctaLabelEl = root.querySelector('[data-bloodwork-footer-cta-label]');
    const imageEl   = root.querySelector('[data-bloodwork-footer-image]');
    const videoEl   = root.querySelector('[data-bloodwork-footer-video]');

    if (ctaEl && ctaEl.dataset.scrollBound !== 'true') {
      ctaEl.dataset.scrollBound = 'true';
      ctaEl.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    const VIDEO_EXT = /\.(mp4|webm|ogg|ogv|mov|m4v)(\?.*)?$/i;
    const isVideoUrl = (url) => typeof url === 'string' && VIDEO_EXT.test(url);

    const resolveAssetUrl = (url) => {
      if (typeof url !== 'string' || !url) return '';
      if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:')) return url;
      const base = window.AEM_PUBLISHING_URL || '';
      return base.replace(/\/$/, '') + (url.startsWith('/') ? url : '/' + url);
    };

    const apply = (aem) => {
      const node = aem && aem['shopify/bloodwork'];
      if (!node) return false;

      let hasContent = false;
      const title = node['footer-title'];
      const description = node['footer-description'];
      const buttonText = node['footer-button-text'];
      const image = node['footer-image'];

      if (titleEl) {
        titleEl.textContent = (typeof title === 'string' && title) ? title : 'footer-title';
        hasContent = true;
      }

      if (descEl && typeof description === 'string' && description) {
        descEl.innerHTML = description;
        descEl.hidden = false;
        hasContent = true;
      }

      if (ctaEl && ctaLabelEl) {
        ctaLabelEl.textContent = (typeof buttonText === 'string' && buttonText) ? buttonText : 'footer-button-text';
        ctaEl.hidden = false;
        hasContent = true;
      }

      if (typeof image === 'string' && image) {
        const assetUrl = resolveAssetUrl(image);
        if (assetUrl) {
          if (isVideoUrl(assetUrl) && videoEl) {
            videoEl.src = assetUrl;
            videoEl.hidden = false;
            if (imageEl) imageEl.hidden = true;
          } else if (imageEl) {
            window.setAemImage(imageEl, assetUrl, 'general');
            if (typeof title === 'string' && title) imageEl.alt = title;
            imageEl.hidden = false;
            if (videoEl) videoEl.hidden = true;
          }
          hasContent = true;
        }
      }

      return hasContent;
    };

    if (typeof window.attachSectionLoading === 'function') {
      window.attachSectionLoading({ root, source: 'aem', apply, label: 'bloodwork-footer', timeoutMs: 60000 });
    } else if (window.dataAEM) {
      apply(window.dataAEM);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloodwork-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-bloodwork-hero]');
    if (!root) return;

    const titleEl = root.querySelector('[data-bloodwork-hero-title]');
    const descEl  = root.querySelector('[data-bloodwork-hero-description]');
    const mediaEl = root.querySelector('[data-bloodwork-hero-media]');
    const imageEl = root.querySelector('[data-bloodwork-hero-image]');
    const videoEl = root.querySelector('[data-bloodwork-hero-video]');

    const VIDEO_EXT = /\.(mp4|webm|ogg|ogv|mov|m4v)(\?.*)?$/i;
    const isVideoUrl = (url) => typeof url === 'string' && VIDEO_EXT.test(url);

    const resolveAssetUrl = (url) => {
      if (typeof url !== 'string' || !url) return '';
      if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:')) return url;
      const base = window.AEM_PUBLISHING_URL || '';
      return base.replace(/\/$/, '') + (url.startsWith('/') ? url : '/' + url);
    };

    const apply = (aem) => {
      const node = aem && aem['shopify/bloodwork'];
      if (!node) return false;

      let hasContent = false;
      const title = node['hero-title'];
      const description = node['hero-description'];
      const image = node['hero-image'];

      if (titleEl) {
        titleEl.textContent = (typeof title === 'string' && title) ? title : 'hero-title';
        hasContent = true;
      }

      if (descEl && typeof description === 'string' && description) {
        descEl.innerHTML = description;
        descEl.hidden = false;
        hasContent = true;
      }

      if (mediaEl && typeof image === 'string' && image) {
        const assetUrl = resolveAssetUrl(image);
        if (assetUrl) {
          if (isVideoUrl(assetUrl) && videoEl) {
            videoEl.src = assetUrl;
            videoEl.hidden = false;
            if (imageEl) imageEl.hidden = true;
          } else if (imageEl) {
            window.setAemImage(imageEl, assetUrl, 'general');
            if (typeof title === 'string' && title) imageEl.alt = title;
            imageEl.hidden = false;
            if (videoEl) videoEl.hidden = true;
          }
          mediaEl.hidden = false;
          hasContent = true;
        }
      }

      return hasContent;
    };

    if (typeof window.attachSectionLoading === 'function') {
      window.attachSectionLoading({ root, source: 'aem', apply, label: 'bloodwork-hero', timeoutMs: 60000 });
    } else if (window.dataAEM) {
      apply(window.dataAEM);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enhanced-product-information"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // AEM consumer for the enhanced-product PDP section. Mirrors the per-section
    // pattern used in flagship-product.liquid and icon-columns.liquid: read
    // `window.dataAEM` directly, fall back to listening for `aem:data:loaded`,
    // populate every label/image/list once it lands.
    function applyAem(aem) {
      if (!aem) return;
      var discoveryKit = aem['shopify/discovery-kit'] || {};
      var offers       = aem['shopify/offers'] || {};
      var cart         = aem['shopify/cart'] || {};

      function resolveAssetUrl(url) {
        if (typeof url !== 'string' || !url) return '';
        if (/^(https?:)?\/\//i.test(url) || url.indexOf('data:') === 0) return url;
        var base = window.AEM_PUBLISHING_URL || '';
        return base.replace(/\/$/, '') + (url.charAt(0) === '/' ? url : '/' + url);
      }

      function setText(selector, value) {
        if (typeof value !== 'string' || !value) return;
        document.querySelectorAll(selector).forEach(function (el) { el.textContent = value; });
      }

      // ---- subscribe-and-earn card -------------------------------------------
      setText('[data-epi-subscribe-banner]', discoveryKit['subscribe-banner']);
      setText('[data-epi-subscribe-label]',  offers['subscribe-earn']);
      setText('[data-epi-onetime-label]',    offers['one-time-purchase']);
      setText('[data-epi-delivers-every]',   cart['delivers-every']);
      setText('[data-epi-excl-vat-label]',   cart['excl-vat-label']);

      // ---- delivery frequency dropdown: localize the time-unit words ---------
      // Options render from Shopify selling-plan option values (e.g. "Month",
      // "2 Weeks"). Swap each English unit word for its AEM-localized value,
      // leaving counts and other words untouched.
      var unitMap = {
        day:    cart['day'],    days:   cart['days'],
        week:   cart['week'],   weeks:  cart['weeks'],
        month:  cart['month'],  months: cart['months'],
        year:   cart['year'],   years:  cart['years']
      };
      // A single-interval plan arrives as a lone unit with no count, possibly
      // already localized ("mois"). It reads as incomplete next to "2 mois", so
      // it gets an explicit "1 " prefix. A bare unit is recognised as: no digit
      // AND the whole label equals a known unit word — English OR this locale's
      // (the AEM cart values) — so the "Loading…" placeholder and other single
      // words are never prefixed. Reading the digit guard from the current text
      // keeps this idempotent across repeat applyAem calls.
      var bareUnits = {};
      ['day', 'days', 'week', 'weeks', 'month', 'months', 'year', 'years'].forEach(function (k) { bareUnits[k] = true; });
      Object.keys(unitMap).forEach(function (k) {
        var v = unitMap[k];
        if (typeof v === 'string' && v) bareUnits[v.toLowerCase()] = true;
      });
      document.querySelectorAll('[data-delivery-frequency] option').forEach(function (opt) {
        var text = opt.textContent;
        if (typeof text !== 'string' || !text) return;
        var isBareUnit = !/\d/.test(text) && bareUnits[text.trim().toLowerCase()] === true;
        var translated = text.replace(/[A-Za-z]+/g, function (word) {
          var lower = word.toLowerCase();
          if (!(lower in unitMap)) return word; // not a time-unit word, leave untouched
          var value = unitMap[lower];
          // Use the AEM value when present; otherwise fall back to the AEM
          // key (never the English word) so a missing locale value is visible.
          return (typeof value === 'string' && value) ? value : lower;
        });
        if (isBareUnit) translated = '1 ' + translated;
        if (translated !== text) opt.textContent = translated;
      });

      // Stock label: AEM keys differ for in-stock vs out-of-stock.
      document.querySelectorAll('[data-epi-stock-label]').forEach(function (el) {
        var state = el.getAttribute('data-epi-stock');
        var value = state === 'out' ? cart['outOfStock'] : offers['in-stock'];
        if (typeof value === 'string' && value) el.textContent = value;
      });

      // ---- subscription benefits list (clone <template> per entry) ----------
      var benefitsList = discoveryKit['benefits'];
      var benefitsHost = document.querySelector('[data-epi-benefits]');
      var benefitTpl   = benefitsHost && benefitsHost.querySelector('template[data-epi-benefit-template]');
      if (benefitsHost && benefitTpl && Array.isArray(benefitsList) && benefitsList.length) {
        // Drop any previous renders, keep the template.
        Array.prototype.slice.call(benefitsHost.children).forEach(function (child) {
          if (child !== benefitTpl) benefitsHost.removeChild(child);
        });
        var frag = document.createDocumentFragment();
        benefitsList.forEach(function (text) {
          if (typeof text !== 'string' || !text) return;
          var clone = benefitTpl.content.firstElementChild.cloneNode(true);
          var slot  = clone.querySelector('[data-epi-benefit-label]');
          if (slot) slot.textContent = text;
          frag.appendChild(clone);
        });
        benefitsHost.appendChild(frag);
      }

      // ---- "Included With Your Purchase" promo card (first entry only) ------
      var included = Array.isArray(discoveryKit['included-with-purchase'])
        ? discoveryKit['included-with-purchase'][0]
        : null;
      setText('[data-epi-promo-eyebrow]', discoveryKit['included-title']);
      if (included) {
        setText('[data-epi-promo-title]', included.title);
        var descEl = document.querySelector('[data-epi-promo-description]');
        if (descEl && typeof included.description === 'string' && included.description) {
          descEl.innerHTML = included.description;
        }
        var imgEl = document.querySelector('[data-epi-promo-img]');
        var src = resolveAssetUrl(included.img);
        if (imgEl) {
          window.setAemImage(imgEl, src, 'general');
          imgEl.alt = included.title || '';
        }
      }
    }

    if (window.dataAEM) {
      applyAem(window.dataAEM);
    } else {
      document.addEventListener('aem:data:loaded', function (e) {
        applyAem((e && e.detail) || window.dataAEM);
      }, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-featured-collection]');
    if (!root) return;

    // EU browse-only gate: unlock once the wellness assessment was completed
    // on this device (flag set by src/scripts/DMO/profile-metrics.ts). Runs
    // before the card init below so unlocked cards behave exactly like US ones.
    // While still gated, card links point to the assessment quiz instead
    // (same URL builder as banner-with-card.liquid).
    const buildFindYourAgeUrl = () => {
      const baseUrl = (window.externalLinks && window.externalLinks.findYourAgeUrl) || '';
      if (!baseUrl) return '';
      const cleanBase = baseUrl.replace(/\/$/, '');
      const firstSegment = window.location.pathname.split('/').filter(Boolean)[0] || '';
      const localePattern = /^[a-z]{2}(-[a-z]{2})?$/i;
      const locale = localePattern.test(firstSegment) ? firstSegment : '';
      const path = locale ? '/' + locale + '/Intro' : '/Intro';
      // Preserve the current query string AND guarantee the site identifier is
      // present: on collection pages `site` often lives only in storage (the
      // redirect helper keeps it there), so window.location.search alone drops
      // it. Mirror theme-redirects.js by falling back to shopify_site_identifier.
      const search = new URLSearchParams(window.location.search);
      if (!search.get('site')) {
        const storedSite = (sessionStorage.getItem('shopify_site_identifier') || localStorage.getItem('shopify_site_identifier') || '').trim();
        if (storedSite) search.set('site', storedSite);
      }
      const qs = search.toString();
      return cleanBase + path + (qs ? '?' + qs : '');
    };

    // Sites with pro2colDownloadDisabled === true never offer the quiz, so
    // the gate has no way to unlock and must not apply — those sites browse
    // and buy like an ungated one. Absent flag means enabled (see
    // DMO/assessment-availability.ts). window.data arrives after this script
    // runs, hence the dmo:data:loaded re-run below.
    const assessmentDisabled = () =>
      !!(window.data && window.data.pro2colDownloadDisabled === true);

    // Reveal add-to-cart (and point card links at the product) once the
    // assessment flag is set. Extracted so it can re-run on bfcache restore
    // and cross-tab completion (see listeners below).
    const applyAssessmentGate = () => {
      if (assessmentDisabled() || localStorage.getItem('pro2col_assessment_completed') === 'true') {
        root.querySelectorAll('[data-fc-gated]').forEach((el) => el.removeAttribute('hidden'));
        root.querySelectorAll('[data-fc-gated-link]').forEach((a) => {
          a.setAttribute('href', a.getAttribute('data-fc-gated-link'));
          a.setAttribute('data-featured-collection-product-link', '');
        });
      } else {
        const quizUrl = buildFindYourAgeUrl();
        if (quizUrl) {
          root.querySelectorAll('[data-fc-gated-link]').forEach((a) => {
            a.setAttribute('href', quizUrl);
          });
        }
      }
    };

    applyAssessmentGate();

    // Make the unlock work right away without a manual reload:
    // - pro2col:assessment-completed: fired by profile-metrics.ts the moment it
    //   sets the flag on /pages/offers (same page load, after the assessment).
    //   This IIFE runs as a deferred script, so the listener is registered
    //   before that DOMContentLoaded-time dispatch.
    // - pageshow (persisted): user hits Back from the assessment and the page
    //   is restored from bfcache, so the load-time check never re-runs.
    // - storage: the assessment was completed in another tab.
    document.addEventListener('pro2col:assessment-completed', applyAssessmentGate);
    // - dmo:data:loaded: countryConfig only exists once the DMO payload lands,
    //   so the assessment-disabled unlock can't be decided on the first run.
    document.addEventListener('dmo:data:loaded', applyAssessmentGate);
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) applyAssessmentGate();
    });
    window.addEventListener('storage', (event) => {
      if (event.key === 'pro2col_assessment_completed') applyAssessmentGate();
    });

    // Intro copy comes from AEM (shopify/shopify-homepage). Skeleton on the
    // intro element stays until applyIntro fills at least one field.
    const intro = root.querySelector('[data-featured-collection-intro]');

    const applyIntro = (aem) => {
      const node = aem && aem['shopify/shopify-homepage'];
      if (!node) return false;

      const eyebrowEl = root.querySelector('[data-featured-collection-eyebrow]');
      const titleEl = root.querySelector('[data-featured-collection-title]');
      const descEl = root.querySelector('[data-featured-collection-description]');

      let hasContent = false;
      const eye = node['personal-path-eye'];
      const title = node['personal-path-title'];
      const desc = node['personal-path-description'];

      if (eyebrowEl) {
        eyebrowEl.textContent = (typeof eye === 'string' && eye) ? eye : 'personal-path-eye';
        hasContent = true;
      }
      if (titleEl) {
        titleEl.textContent = (typeof title === 'string' && title) ? title : 'personal-path-title';
        hasContent = true;
      }
      if (descEl && typeof desc === 'string' && desc) {
        descEl.innerHTML = desc; // personal-path-link intentionally ignored
        hasContent = true;
      }
      return hasContent;
    };

    if (intro) {
      if (typeof window.attachSectionLoading === 'function') {
        window.attachSectionLoading({
          root: intro,
          source: 'aem',
          apply: applyIntro,
          label: 'featured-collection-intro',
          timeoutMs: 60000,
        });
      } else if (window.dataAEM) {
        if (applyIntro(window.dataAEM)) intro.removeAttribute('data-loading');
      }
    }

    // Product-card UI labels (Add To Cart / One-time Purchase / Subscribe & Earn)
    // come from AEM shopify/offers so they localize with the rest of the page.
    const applyOfferLabels = (aem) => {
      const node = aem && aem['shopify/offers'];
      if (!node) return;
      const setAll = (sel, val) => {
        if (typeof val !== 'string' || !val) return;
        root.querySelectorAll(sel).forEach((el) => { el.textContent = val; });
      };
      setAll('[data-fc-addcart-label]', node['add-to-cart'] || 'add-to-cart');
      setAll('[data-fc-onetime-label]', node['one-time-purchase'] || 'one-time-purchase');
      setAll('[data-fc-subscribe-label]', node['subscribe-earn'] || 'subscribe-earn');
    };
    if (window.dataAEM) {
      applyOfferLabels(window.dataAEM);
    } else {
      document.addEventListener('aem:data:loaded', (e) => applyOfferLabels(e.detail || window.dataAEM), { once: true });
    }

    // Variant selector: each product card carries its own variant payload + select.
    // When the user changes variant, swap displayed name, price, hidden id and the PDP link.
    const productCards = root.querySelectorAll('[data-featured-collection-product]');
    productCards.forEach((card) => {
      const dataEl = card.querySelector('[data-featured-collection-variants]');
      if (!dataEl) return;

      let variants = [];
      try {
        variants = JSON.parse(dataEl.textContent || '[]');
      } catch (_e) {
        return;
      }
      if (!Array.isArray(variants) || variants.length === 0) return;

      // Approach B: the payload holds EVERY active variant. Filter to the user's
      // real country — window.data.profile.targetCountry (e.g. 'PR'), which the URL
      // can't carry because PR is redirected to es-us — using the URL locale only as
      // a fallback before DMO data loads. Variants are matched by the country suffix
      // in their title (e.g. '_PR'), mirroring the old server-side Liquid filter.
      const allVariants = variants;
      const resolveCountry = () => {
        const tc = window.data && window.data.profile && window.data.profile.targetCountry;
        if (tc) return String(tc).toUpperCase();
        const m = window.location.pathname.match(/^\/[a-z]{2}-([a-z]{2})(?=\/|$)/i);
        return m ? m[1].toUpperCase() : 'US';
      };
      const variantsForCountry = (country) => {
        const suffix = '_' + country;
        const matched = allVariants.filter((v) => (v.title || '').toUpperCase().indexOf(suffix) !== -1);
        return matched.length ? matched : allVariants;
      };
      variants = variantsForCountry(resolveCountry());

      const nameEls = card.querySelectorAll('[data-featured-collection-product-name]');
      const pricing = card.querySelector('.featured-collection__pricing');
      const inclEl = card.querySelector('[data-featured-collection-price-incl]');
      const inclCompareEl = card.querySelector('[data-featured-collection-price-incl-compare]');
      const exclRow = card.querySelector('[data-featured-collection-price-excl-row]');
      const exclEl = card.querySelector('[data-featured-collection-price-excl]');
      const exclCompareEl = card.querySelector('[data-featured-collection-price-excl-compare]');
      const cartPriceEl = card.querySelector('[data-featured-collection-product-cart-price]');
      const idInput = card.querySelector('[data-featured-collection-product-id]');
      const imgEl = card.querySelector('[data-featured-collection-product-image]');
      const variantSelectEl = card.querySelector('[data-featured-collection-product-variant]'); // flavor
      const sizeSelect = card.querySelector('[data-featured-collection-product-size]');
      const purchaseSelect = card.querySelector('[data-featured-collection-purchase]');
      const sellingPlanId = card.getAttribute('data-featured-collection-selling-plan') || null;

      // Track the chosen variant + purchase type so price/name/image stay in
      // sync as flavor, size or purchase type change.
      let currentVariant = variants[0];

      const isSubscription = () =>
        !!purchaseSelect && purchaseSelect.value === 'subscription';

      // Distinct sizes (in payload order) available for a given flavor. The
      // payload only contains active, locale-matching variants, so this never
      // includes inactive combos or other flavors' sizes.
      const sizesForFlavor = (flavor) => {
        const seen = {};
        const out = [];
        variants.forEach((v) => {
          if (v.flavor === flavor && v.size && !seen[v.size]) {
            seen[v.size] = true;
            out.push(v.size);
          }
        });
        return out;
      };

      // Rebuild the size select to only the sizes for `flavor`. Keeps the
      // previously-chosen size when it's still available, else picks the first.
      const populateSizes = (flavor, preferred) => {
        if (!sizeSelect) return;
        const sizes = sizesForFlavor(flavor);
        sizeSelect.innerHTML = '';
        sizes.forEach((s) => {
          const opt = document.createElement('option');
          opt.value = s;
          opt.textContent = s;
          sizeSelect.appendChild(opt);
        });
        if (preferred && sizes.indexOf(preferred) !== -1) {
          sizeSelect.value = preferred;
        } else if (sizes.length) {
          sizeSelect.value = sizes[0];
        }
        // The size <select> element renders whenever ANY country needs a size
        // (server count is country-agnostic). Hide it for countries/flavors that
        // have no size so PR (or any single-size locale) doesn't show an empty box.
        const sizeLabel = sizeSelect.closest('label');
        if (sizeLabel) sizeLabel.style.display = sizes.length ? '' : 'none';
      };

      // Resolve the variant from the flavor + size selects. Falls back to the
      // first variant for the chosen flavor, then to the first variant overall.
      const resolveVariant = () => {
        const flavor = variantSelectEl ? variantSelectEl.value : (currentVariant && currentVariant.flavor);
        const size = sizeSelect ? sizeSelect.value : null;
        return (
          variants.find((v) => v.flavor === flavor && (size === null || v.size === size)) ||
          variants.find((v) => v.flavor === flavor) ||
          variants[0]
        );
      };

      const setLine = (mainEl, compareEl, mainText, compareText) => {
        if (mainEl) mainEl.textContent = mainText || '';
        if (compareEl) {
          if (compareText) {
            compareEl.textContent = compareText;
            compareEl.removeAttribute('hidden');
          } else {
            compareEl.textContent = '';
            compareEl.setAttribute('hidden', '');
          }
        }
      };

      const render = () => {
        if (!currentVariant) return;
        const sub = isSubscription();
        const v = currentVariant;

        nameEls.forEach((el) => { el.textContent = v.name; });

        // Incl-VAT (top) line. In subscription mode show the subscription incl
        // price with the one-time incl price crossed out.
        const inclMain = sub ? v.subIncl : v.priceIncl;
        const inclCompare = sub ? v.priceIncl : '';
        setLine(inclEl, inclCompareEl, inclMain, inclCompare);

        // Excl-VAT (bottom "HT") line — same treatment. Hide the whole row
        // when there's no excl price (e.g. Shopify fallback).
        const exclMain = sub ? v.subExcl : v.priceExcl;
        const exclCompare = sub ? v.priceExcl : '';
        if (exclRow) {
          if (exclMain) exclRow.removeAttribute('hidden');
          else exclRow.setAttribute('hidden', '');
        }
        setLine(exclEl, exclCompareEl, exclMain, exclCompare);

        if (pricing) pricing.classList.toggle('is-subscription', sub);

        if (cartPriceEl) cartPriceEl.textContent = inclMain;
        if (idInput) idInput.value = v.id;
        if (imgEl) {
          if (v.imageUrl) {
            imgEl.setAttribute('src', v.imageUrl);
            imgEl.setAttribute('alt', v.name || '');
            imgEl.removeAttribute('hidden');
          } else {
            imgEl.removeAttribute('src');
            imgEl.setAttribute('hidden', '');
          }
        }
        if (v.url) {
          // Re-queried per render rather than captured at card init: in
          // browse-only markets Liquid omits the product-link attribute and
          // applyAssessmentGate adds it on unlock, which for the
          // assessment-disabled case lands with the DMO payload — after init.
          // A capture taken at init would be empty and the link would never
          // follow flavor/size.
          card.querySelectorAll('a[data-featured-collection-product-link]').forEach((el) => {
            el.setAttribute('href', v.url);
          });
          // Keep the stashed URL current too, so a later unlock uses the
          // variant actually on screen: the country filter above can resolve a
          // different one than the Liquid initial_variant_id (e.g. PR).
          card.querySelectorAll('a[data-fc-gated-link]').forEach((el) => {
            el.setAttribute('data-fc-gated-link', v.url);
          });
        }
      };

      // Flavor change: rebuild the size options for the new flavor (keeping the
      // current size if it's still offered), then resolve + render.
      const onFlavorChange = () => {
        const flavor = variantSelectEl.value;
        const prevSize = sizeSelect ? sizeSelect.value : null;
        populateSizes(flavor, prevSize);
        currentVariant = resolveVariant() || currentVariant;
        render();
      };

      const onSizeChange = () => {
        currentVariant = resolveVariant() || currentVariant;
        render();
      };

      if (variantSelectEl) variantSelectEl.addEventListener('change', onFlavorChange);
      if (sizeSelect) sizeSelect.addEventListener('change', onSizeChange);
      if (purchaseSelect) purchaseSelect.addEventListener('change', render);

      // Rebuild the flavor <select> from the currently-active (country-filtered)
      // variants. The server renders the URL-locale flavors; for a PR user this
      // swaps them for the _PR flavors once targetCountry is known.
      const rebuildFlavors = () => {
        if (!variantSelectEl) return;
        const seen = {};
        const flavors = [];
        variants.forEach((v) => {
          if (v.flavor && !seen[v.flavor]) {
            seen[v.flavor] = true;
            // value = flavor (option1) so resolution is unaffected; text = localized label.
            flavors.push({ value: v.flavor, label: v.flavorLabel || v.flavor });
          }
        });
        const prev = variantSelectEl.value;
        variantSelectEl.innerHTML = '';
        flavors.forEach((fl) => {
          const opt = document.createElement('option');
          opt.value = fl.value;
          opt.textContent = fl.label;
          variantSelectEl.appendChild(opt);
        });
        variantSelectEl.value = flavors.some((f) => f.value === prev) ? prev : (flavors[0] ? flavors[0].value : '');
      };

      // (Re)apply the country filter, rebuild selectors and re-render. Runs once
      // on init (URL-locale fallback) and again on dmo:data:loaded once the real
      // targetCountry (e.g. PR) is available.
      const applyCountry = () => {
        variants = variantsForCountry(resolveCountry());
        if (!variants.length) return;
        rebuildFlavors();
        const flavor0 = variantSelectEl ? variantSelectEl.value : (variants[0] && variants[0].flavor);
        const prevSize = currentVariant ? currentVariant.size : null;
        if (sizeSelect) populateSizes(flavor0, prevSize);
        currentVariant = resolveVariant() || variants[0];
        render();
      };

      applyCountry();
      if (!window.data) {
        document.addEventListener('dmo:data:loaded', applyCountry, { once: true });
      }

      // Add-to-cart via the unified window.addToCart (src/scripts/add-to-cart.ts):
      // it appends the free app/Beta item, posts a single /cart/add.js, fires
      // cart:update and opens the drawer. When the subscription purchase type is
      // selected we pass subscription:true + the product's selling plan id.
      const form = card.querySelector('[data-featured-collection-form]');
      if (form) {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          const btn = form.querySelector('button[type="submit"]');
          const id = idInput ? idInput.value : (form.querySelector('[name="id"]') || {}).value;
          const qtyEl = form.querySelector('[name="quantity"]');
          const quantity = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
          if (!id) return;

          if (typeof window.addToCart !== 'function') {
            console.error('[featured-collection] window.addToCart not available');
            return;
          }

          const subscription = isSubscription() && !!sellingPlanId;

          if (btn) {
            btn.disabled = true;
            btn.classList.add('is-loading');
          }
          try {
            await window.addToCart({
              items: [{ id: id, quantity: quantity, sellingPlanId: subscription ? sellingPlanId : null }],
              subscription: subscription,
              source: 'featured-collection',
            });
          } catch (err) {
            console.error('[featured-collection] add to cart failed:', err);
          } finally {
            if (btn) {
              btn.disabled = false;
              btn.classList.remove('is-loading');
            }
          }
        });
      }
    });

    // When the DMO payload reports subscriptions are disabled for this site,
    // strip the subscribe option from every card and reset any that had it
    // selected back to one-time (dispatching change so the price re-renders).
    const gateSubscriptions = (data) => {
      if (!data || data.subscriptionsEnabled !== false) return;
      root.querySelectorAll('[data-featured-collection-purchase]').forEach((sel) => {
        const subOpt = sel.querySelector('option[value="subscription"]');
        if (subOpt) subOpt.remove();
        if (sel.value !== 'one-time') {
          sel.value = 'one-time';
          sel.dispatchEvent(new Event('change'));
        }
      });
    };

    if (window.data) {
      gateSubscriptions(window.data);
    } else {
      document.addEventListener('dmo:data:loaded', (e) => gateSubscriptions(e.detail || window.data), { once: true });
    }

    // Equalize product-title heights across the visible row so the price and
    // selects line up regardless of how many lines each title wraps to. Runs
    // after layout settles and on resize. (The variant row is reserved in
    // markup via the spacer, so titles are the only variable height.)
    const titleEls = Array.from(root.querySelectorAll('.featured-collection__product-title'));

    const equalizeCardRows = () => {
      if (titleEls.length === 0) return;
      titleEls.forEach((el) => { el.style.minHeight = ''; });
      let max = 0;
      titleEls.forEach((el) => { max = Math.max(max, el.offsetHeight); });
      if (max > 0) titleEls.forEach((el) => { el.style.minHeight = max + 'px'; });
    };

    // Run after the carousel has set slide widths (title wrap depends on width).
    requestAnimationFrame(() => requestAnimationFrame(equalizeCardRows));
    window.setTimeout(equalizeCardRows, 600);

    let resizeRaf = 0;
    window.addEventListener('resize', () => {
      window.cancelAnimationFrame(resizeRaf);
      resizeRaf = window.requestAnimationFrame(equalizeCardRows);
    });

    if (typeof ResizeObserver === 'function') {
      const ro = new ResizeObserver(() => equalizeCardRows());
      ro.observe(root);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flagship-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const PLACEHOLDER_IMAGE =
      'https://cdn.shopify.com/s/files/1/0689/7509/9951/files/pc-0106-us_ca0d5356-cc6d-45c0-a901-0358d647e498.jpg?v=1758650474';

    // Locale resolver. The whole section reads window.getCurrentLocale to match the
    // URL's /xx-xx/ prefix (used for the translations metafield lookup + pricing).
    // That global is only defined by enhanced-product-helpers.js, which isn't loaded
    // on every page that renders this section (e.g. the offers page) — so define it
    // here from the URL when absent, using the same logic. Without this it silently
    // falls back to 'en-US' and shows the wrong locale's product name.
    if (typeof window.getCurrentLocale !== 'function') {
      window.getCurrentLocale = function () {
        // In the site-builder preview the document URL is the proxy endpoint;
        // the previewed storefront path lives on window.__p2cPreview.path.
        const pathname = window.__p2cPreview?.path || window.location.pathname;
        const match = pathname.match(/^\/([a-z]{2})-([a-z]{2})(?:\/|$|\?)/i);
        return match ? `${match[1].toLowerCase()}-${match[2].toUpperCase()}` : 'en-US';
      };
    }

    function getFlagshipTemplate(root, name) {
      return root.querySelector(`template[data-flagship-template="${name}"]`);
    }

    function cloneFlagshipTemplate(root, name) {
      const template = getFlagshipTemplate(root, name);
      if (!template) return null;
      return template.content.cloneNode(true);
    }

    function stripShopifyUuid(filename) {
      return filename.replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/, '');
    }

    function getTargetCountry() {
      if (window.data?.profile?.targetCountry) {
        return window.data.profile.targetCountry.toLowerCase();
      }
      const currentLocale =
        typeof window.getCurrentLocale === 'function' ? window.getCurrentLocale() : 'en-US';
      return (currentLocale.split('-')[1] || 'US').toLowerCase();
    }

    function filterImagesByCountry(imageUrls) {
      const targetCountry = getTargetCountry();

      return imageUrls.filter((url) => {
        const rawFilename = url.split('/').pop()?.split('.')[0]?.toLowerCase() || '';
        const filename = stripShopifyUuid(rawFilename);
        const countryMatch = filename.match(/-([a-z]{2})$/);

        if (countryMatch) {
          return countryMatch[1] === targetCountry;
        }

        return true;
      });
    }

    function getFlagshipOffer(data) {
      const offers = data?.theme?.productOffer?.offers;
      if (!Array.isArray(offers)) return null;

      return offers.find((offer) => offer.type === 'FLAGSHIP_PRODUCT') || null;
    }

    function getFlagshipItem(data) {
      return getFlagshipOffer(data)?.data?.item ?? null;
    }

    function parseFlagshipTranslations(translationsString) {
      if (!translationsString || translationsString.trim() === '') return null;
      try {
        return JSON.parse(translationsString);
      } catch {
        return null;
      }
    }

    function getFlagshipTranslatedValue(translations, field, fallback) {
      if (!translations) return fallback;

      const currentLocale =
        typeof window.getCurrentLocale === 'function' ? window.getCurrentLocale() : 'en-US';
      const variations = [
        currentLocale,
        currentLocale.toUpperCase(),
        currentLocale.toLowerCase(),
        `${currentLocale.split('-')[0].toLowerCase()}-${currentLocale.split('-')[1].toUpperCase()}`
      ];

      for (const locale of variations) {
        if (!translations[locale]) continue;

        const variantVal = translations[locale].variant?.[field];
        if (variantVal && typeof variantVal === 'string' && variantVal.trim()) return variantVal;

        const productVal = translations[locale].product?.[field];
        if (productVal && typeof productVal === 'string' && productVal.trim()) return productVal;
      }

      return fallback;
    }

    function getFlagshipTitle(item) {
      if (!item) return '';

      const fallback = item.productName || item.title || '';
      const translations = parseFlagshipTranslations(item.translations);
      const translated = getFlagshipTranslatedValue(translations, 'product_name', fallback);

      return translated.split(' - ')[0].split('/')[0].trim();
    }

    function truncateToTwoDecimals(num) {
      return Math.floor(num * 100) / 100;
    }

    function formatFlagshipPrice(amount) {
      const currentLocale =
        typeof window.getCurrentLocale === 'function' ? window.getCurrentLocale() : 'en-US';

      return new Intl.NumberFormat(currentLocale, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(truncateToTwoDecimals(amount));
    }

    function getFlagshipDescription(item) {
      if (!item) return '';

      const fallback = item.productDescription || item.overview || '';
      const translations = parseFlagshipTranslations(item.translations);
      return getFlagshipTranslatedValue(translations, 'product_description', fallback);
    }

    const FLAGSHIP_ALLOWED_HTML_TAGS = [
      'p', 'br', 'strong', 'em', 'b', 'i', 'u', 'a', 'span', 'div',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'img',
      'table', 'thead', 'tbody', 'tr', 'th', 'td'
    ];

    const FLAGSHIP_ALLOWED_HTML_ATTRIBUTES = {
      a: ['href', 'target', 'rel'],
      img: ['src', 'alt', 'width', 'height', 'class'],
      span: ['class'],
      div: ['class'],
      td: ['colspan', 'rowspan'],
      th: ['colspan', 'rowspan']
    };

    function sanitizeFlagshipHTML(html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const sanitized = document.createElement('div');

      function sanitizeNode(node, parent) {
        if (node.nodeType === Node.TEXT_NODE) {
          parent.appendChild(document.createTextNode(node.textContent || ''));
          return;
        }

        if (node.nodeType !== Node.ELEMENT_NODE) return;

        const tagName = node.tagName.toLowerCase();

        if (FLAGSHIP_ALLOWED_HTML_TAGS.includes(tagName)) {
          const newElement = document.createElement(tagName);
          const allowedAttrs = FLAGSHIP_ALLOWED_HTML_ATTRIBUTES[tagName] || [];

          Array.from(node.attributes).forEach((attr) => {
            if (!allowedAttrs.includes(attr.name)) return;

            if (attr.name === 'href') {
              const href = attr.value.trim().toLowerCase();
              if (href.startsWith('javascript:') || href.startsWith('data:') || href.startsWith('vbscript:')) {
                return;
              }
            }

            newElement.setAttribute(attr.name, attr.value);
          });

          Array.from(node.childNodes).forEach((child) => sanitizeNode(child, newElement));
          parent.appendChild(newElement);
        } else {
          Array.from(node.childNodes).forEach((child) => sanitizeNode(child, parent));
        }
      }

      Array.from(doc.body.childNodes).forEach((node) => sanitizeNode(node, sanitized));
      return sanitized.innerHTML;
    }

    function getFlagshipSkuDisplay(sku) {
      if (!sku) return '';

      const parts = sku.split('_');
      if (parts.length > 1) {
        parts.pop();
        return parts.join('_');
      }

      return sku;
    }

    function getFlagshipDisplayPrice(item) {
      const prices = getFlagshipPrices(item);
      return prices?.base ?? null;
    }

    function getFlagshipPrices(item) {
      if (!item) return null;

      const country = (
        window.data?.profile?.targetCountry ||
        (typeof window.getCurrentLocale === 'function'
          ? window.getCurrentLocale().split('-')[1]
          : 'US') ||
        'US'
      ).toUpperCase();

      // US/CA/PR have no VAT — the "Excl. VAT" rows must never show there,
      // whatever the DMO payload carries (catalogPricesV2 entry or taxAmount).
      const noVatMarket = country === 'US' || country === 'CA' || country === 'PR';

      const catalogPriceEntry = item.catalogPricesV2?.[country];
      if (catalogPriceEntry) {
        return {
          base: catalogPriceEntry.VATPrice,
          subscription: catalogPriceEntry.VATSubscriptionPrice,
          baseExcl: catalogPriceEntry.RetailPrice,
          subExcl: catalogPriceEntry.SubscriptionPrice,
          hasVat: !noVatMarket
        };
      }

      const basePrice = item.catalogPrice ?? item.price;
      if (basePrice == null) return null;

      const taxRate = typeof item.taxAmount === 'number' ? item.taxAmount : 0;
      const taxMultiplier = 1 + taxRate;

      return {
        base: basePrice * taxMultiplier,
        subscription: basePrice * 0.95 * taxMultiplier,
        baseExcl: basePrice,
        subExcl: basePrice * 0.95,
        hasVat: !noVatMarket && taxRate > 0
      };
    }

    function getFlagshipExclVatLabel() {
      const currentLocale =
        typeof window.getCurrentLocale === 'function' ? window.getCurrentLocale() : 'en-US';
      const country = currentLocale.split('-')[1]?.toUpperCase() || '';
      // Derive the language from the resolved locale (preview-aware) rather
      // than the document URL, which is the proxy endpoint in preview mode.
      const urlLang = currentLocale.split('-')[0]?.toLowerCase() || '';
      const labelsByCountry = {
        FR: 'HT',
        IT: 'Escl. IVA',
        AT: 'Exkl. MwSt.',
        DE: 'Exkl. MwSt.',
        NL: 'Excl. BTW',
        ES: 'Excl. IVA',
        GB: 'Excl. VAT',
        TR: 'KDV hariç'
      };

      if (country === 'BE') {
        return ({ fr: 'HT', nl: 'Excl. BTW', de: 'Exkl. MwSt.' })[urlLang] || 'HT';
      }

      if (country === 'CH') {
        return ({ de: 'Exkl. MwSt.', fr: 'HT', it: 'Escl. IVA' })[urlLang] || 'Exkl. MwSt.';
      }

      return labelsByCountry[country] || window.translations?.content?.excl_vat_label || 'Excl. VAT';
    }

    function applyFlagshipSubscriptionPrices(root, item) {
      const prices = getFlagshipPrices(item);
      if (!prices) return;

      const salePriceEl = root.querySelector('[data-flagship-subscription-price]');
      const originalPriceEl = root.querySelector('[data-flagship-original-price]');
      const regularPriceEl = root.querySelector('[data-flagship-regular-price]');
      const subExclEl = root.querySelector('[data-excl-vat-target="subscription"]');
      const onetimeExclEl = root.querySelector('[data-excl-vat-target="onetime"]');

      if (salePriceEl) salePriceEl.textContent = formatFlagshipPrice(prices.subscription);
      if (originalPriceEl) originalPriceEl.textContent = formatFlagshipPrice(prices.base);
      if (regularPriceEl) regularPriceEl.textContent = formatFlagshipPrice(prices.base);

      const exclVatLabel = getFlagshipExclVatLabel();
      if (prices.hasVat) {
        if (subExclEl) {
          subExclEl.textContent = `${formatFlagshipPrice(prices.subExcl)} ${exclVatLabel}`;
          subExclEl.style.display = '';
        }
        if (onetimeExclEl) {
          onetimeExclEl.textContent = `${formatFlagshipPrice(prices.baseExcl)} ${exclVatLabel}`;
          onetimeExclEl.style.display = '';
        }
      } else {
        if (subExclEl) subExclEl.style.display = 'none';
        if (onetimeExclEl) onetimeExclEl.style.display = 'none';
      }
    }

    async function fetchFlagshipSellingPlans(item) {
      const productHandle = item?.productHandle || item?.handle;
      const variantId = item?.id;

      if (!productHandle || !variantId) {
        return { hasSellingPlans: false, sellingPlans: [] };
      }

      try {
        const currentLocale =
          typeof window.getCurrentLocale === 'function' ? window.getCurrentLocale() : 'en-US';
        let response = await fetch(`/${currentLocale}/products/${productHandle}.js`);

        if (!response.ok) {
          response = await fetch(`/products/${productHandle}.js`);
        }

        if (!response.ok) {
          return { hasSellingPlans: false, sellingPlans: [] };
        }

        const productData = await response.json();
        const sellingPlans = productData.selling_plan_groups?.[0]?.selling_plans || [];

        return {
          hasSellingPlans: sellingPlans.length > 0,
          sellingPlans
        };
      } catch {
        return { hasSellingPlans: false, sellingPlans: [] };
      }
    }

    // Localize the delivery-frequency unit words ("Month", "2 months", …) using
    // the AEM shopify/cart node (day/days/week/weeks/month/months/year/years).
    // This section also renders on the offers page, where the shared
    // window.translateFrequencyText helper (defined by the enhanced-product PDP
    // script) is NOT loaded — so we read AEM directly here. Plain word
    // replacement keeps counts intact and is idempotent; the original text is
    // returned untouched when AEM hasn't loaded yet or the word isn't a unit.
    function translateFlagshipFrequency(text) {
      if (!text) return text;

      // Single-interval plans arrive as a lone unit with no count — and the
      // label is often ALREADY localized by Shopify ("mois", "Monat", "month").
      // A bare unit reads as incomplete ("mois") next to "2 mois" / "3 mois", so
      // we prefix an explicit "1 ", preserving case to match the siblings
      // ("1 mois" / "1 Monat"). A bare unit is recognised as: no digit AND the
      // whole label equals a known unit word — in English OR the page's locale
      // (the AEM cart values) — so unrelated single words are never prefixed.
      const cart = window.dataAEM && window.dataAEM['shopify/cart'];
      const bareUnits = {};
      ['day', 'days', 'week', 'weeks', 'month', 'months', 'year', 'years'].forEach(function (k) { bareUnits[k] = true; });

      let result = text;
      if (cart) {
        const unitMap = {
          day: cart.day, days: cart.days,
          week: cart.week, weeks: cart.weeks,
          month: cart.month, months: cart.months,
          year: cart.year, years: cart.years
        };
        Object.keys(unitMap).forEach(function (k) {
          const v = unitMap[k];
          if (typeof v === 'string' && v) bareUnits[v.toLowerCase()] = true;
        });
        result = text.replace(/[A-Za-z]+/g, function (word) {
          const lower = word.toLowerCase();
          if (!(lower in unitMap)) return word; // not an English time-unit word, leave untouched
          const value = unitMap[lower];
          return (typeof value === 'string' && value) ? value : word;
        });
      }

      const isBareUnit = !/\d/.test(text) && bareUnits[text.trim().toLowerCase()] === true;
      return isBareUnit ? '1 ' + result : result;
    }

    function updateFlagshipDeliveryFrequency(root, sellingPlans) {
      const container = root.querySelector('[data-flagship-delivery-wrapper]');
      const select = root.querySelector('[data-flagship-delivery-select]');

      if (!container || !select) return;

      if (!sellingPlans?.length) {
        container.style.display = 'none';
        return;
      }

      container.style.display = '';
      select.innerHTML = '';

      sellingPlans.forEach((plan, index) => {
        const option = document.createElement('option');
        option.value = plan.id.toString();
        option.setAttribute('data-selling-plan-id', plan.id.toString());

        // Use the raw label as-is (no capitalize): it may already be localized
        // ("mois") and the numbered siblings ("2 mois") keep their source case,
        // so capitalizing only the bare unit ("Mois") would look inconsistent.
        // Stored raw so the AEM cart-node units can re-translate once dataAEM
        // lands (the dropdown may be built before AEM resolves).
        const rawText = (plan.options?.length ? plan.options[0].value : plan.name) || '';
        option.dataset.rawFrequency = rawText;
        option.textContent = translateFlagshipFrequency(rawText);

        if (index === 0) option.selected = true;
        select.appendChild(option);
      });
    }

    // Re-localize the delivery-frequency unit words from the AEM cart node once
    // it loads — the dropdown is populated after an async product fetch, so AEM
    // data may arrive either before or after it is built. Translating from the
    // stored raw English label keeps this correct regardless of order.
    (function initFlagshipDeliveryTranslation() {
      function retranslate() {
        document
          .querySelectorAll('[data-flagship-delivery-select] option[data-raw-frequency]')
          .forEach(function (opt) {
            opt.textContent = translateFlagshipFrequency(opt.dataset.rawFrequency);
          });
      }

      if (window.dataAEM) {
        retranslate();
      } else {
        document.addEventListener('aem:data:loaded', retranslate, { once: true });
      }
    })();

    function updateFlagshipSellingPlanVisibility(root, hasSellingPlans) {
      const subscribeOption = root.querySelector('.subscription-option.subscribe-save');
      const onetimeOption = root.querySelector('.subscription-option.one-time');
      const subscribeRadio = root.querySelector('#flagship-subscribe');
      const onetimeRadio = root.querySelector('#flagship-one-time');
      const subscriptionsEnabled = window.data?.subscriptionsEnabled !== false;

      if (!subscribeOption || !onetimeOption) return;

      if (hasSellingPlans && subscriptionsEnabled) {
        subscribeOption.classList.add('subs-visible');

        const preferOneTime = window.data?.countryConfig?.subscriptionPreference === 'one-time';

        if (preferOneTime) {
          subscribeOption.classList.remove('active');
          onetimeOption.classList.add('active');
          if (onetimeRadio) onetimeRadio.checked = true;
        } else {
          subscribeOption.classList.add('active');
          onetimeOption.classList.remove('active');
          if (subscribeRadio) subscribeRadio.checked = true;
        }
      } else {
        subscribeOption.classList.remove('subs-visible', 'active');
        onetimeOption.classList.add('active');
        if (onetimeRadio) onetimeRadio.checked = true;
      }

      const checkedOption = root.querySelector('input[name="flagship-purchase-option"]:checked');
      if (checkedOption) {
        checkedOption.dispatchEvent(new Event('change'));
      }
    }

    function setupFlagshipPurchaseOptions(component) {
      if (component._purchaseOptionsBound) return;
      component._purchaseOptionsBound = true;

      const purchaseOptions = component.querySelectorAll('input[name="flagship-purchase-option"]');
      const subscriptionCards = component.querySelectorAll('.subscription-option');

      function updatePurchaseOptionDisplay(optionId) {
        const deliveryFrequencyEls = component.querySelectorAll('[data-flagship-delivery-wrapper]');
        const subscribeText = component.querySelector('.subscribe-text');
        const onetimeText = component.querySelector('.onetime-text');

        if (subscribeText && onetimeText) {
          if (optionId === 'flagship-subscribe') {
            subscribeText.style.display = 'inline';
            onetimeText.style.display = 'none';
            deliveryFrequencyEls.forEach((el) => {
              const select = el.querySelector('[data-flagship-delivery-select]');
              const hasPlans =
                select && select.options.length > 0 && select.options[0].value !== '';
              el.style.display = hasPlans ? '' : 'none';
            });
          } else {
            subscribeText.style.display = 'none';
            onetimeText.style.display = 'inline';
            deliveryFrequencyEls.forEach((el) => {
              el.style.display = 'none';
            });
          }
        }

        subscriptionCards.forEach((card) => {
          const radioInput = card.querySelector('input[name="flagship-purchase-option"]');
          card.classList.toggle('active', !!radioInput?.checked);
        });
      }

      purchaseOptions.forEach((option) => {
        option.addEventListener('change', function () {
          updatePurchaseOptionDisplay(this.id);
        });
      });

      subscriptionCards.forEach((card) => {
        card.addEventListener('click', function (event) {
          const radioInput = this.querySelector('input[name="flagship-purchase-option"]');
          if (!radioInput || radioInput.checked) return;
          radioInput.checked = true;
          updatePurchaseOptionDisplay(radioInput.id);
        });
      });

      const checkedOption = component.querySelector('input[name="flagship-purchase-option"]:checked');
      if (checkedOption) {
        updatePurchaseOptionDisplay(checkedOption.id);
      }
    }

    function getOrderedAdditionalImageUrls(additionalImages) {
      if (!additionalImages || typeof additionalImages !== 'object') {
        return [];
      }

      // The label PDF is surfaced as a "See label" link, never in the gallery.
      const pdfUrl = window.P2CLabel ? window.P2CLabel.getPdfUrl(additionalImages) : null;

      return Object.entries(additionalImages)
        .sort(([keyA], [keyB]) => {
          if (keyA === 'ProductImage') return -1;
          if (keyB === 'ProductImage') return 1;
          return 0;
        })
        .map(([, url]) => url)
        .filter(Boolean)
        .filter((url) => url !== pdfUrl);
    }

    function getFlagshipImageUrls(data) {
      const offer = getFlagshipOffer(data);
      const additionalImages = offer?.data?.item?.additionalImages;
      const imageUrls = getOrderedAdditionalImageUrls(additionalImages);

      if (!Array.isArray(imageUrls) || imageUrls.length === 0) {
        return [];
      }

      return filterImagesByCountry(imageUrls);
    }

    class FlagshipGallery {
      constructor(element) {
        this.element = element;
        this.currentIndex = 0;
        this.track = element.querySelector('.flagship-gallery__track');
        this.slides = element.querySelectorAll('.flagship-gallery__slide');
        this.totalSlides = this.slides.length;
        this.init();
      }

      init() {
        const prevBtn = this.element.querySelector('.flagship-gallery__arrow--prev');
        const nextBtn = this.element.querySelector('.flagship-gallery__arrow--next');

        if (prevBtn) prevBtn.addEventListener('click', () => this.goToPrevious());
        if (nextBtn) nextBtn.addEventListener('click', () => this.goToNext());

        const thumbnails = this.element.querySelectorAll('.flagship-gallery__thumbnail');
        thumbnails.forEach((thumb, index) => {
          thumb.addEventListener('click', () => this.goToSlide(index));
        });

        const navItems = this.element.querySelectorAll('.flagship-gallery__nav-item');
        navItems.forEach((item, index) => {
          item.addEventListener('click', () => this.goToSlide(index));
        });

        this.addSwipeSupport();
        this.updateGallery();
      }

      goToSlide(index) {
        this.currentIndex = index;
        this.updateGallery();
      }

      goToPrevious() {
        this.currentIndex = (this.currentIndex - 1 + this.totalSlides) % this.totalSlides;
        this.updateGallery();
      }

      goToNext() {
        this.currentIndex = (this.currentIndex + 1) % this.totalSlides;
        this.updateGallery();
      }

      updateGallery() {
        if (this.track) {
          this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
        }

        this.slides.forEach((slide, index) => {
          slide.classList.toggle('is-active', index === this.currentIndex);
        });

        const thumbnails = this.element.querySelectorAll('.flagship-gallery__thumbnail');
        thumbnails.forEach((thumb, index) => {
          thumb.classList.toggle('is-active', index === this.currentIndex);
        });

        const navItems = this.element.querySelectorAll('.flagship-gallery__nav-item');
        navItems.forEach((item, index) => {
          item.classList.toggle('is-active', index === this.currentIndex);
        });

        const activeThumbnail = thumbnails[this.currentIndex];
        const thumbnailsContainer = this.element.querySelector('.flagship-gallery__thumbnails-scroll');
        if (activeThumbnail && thumbnailsContainer) {
          const scrollTop =
            activeThumbnail.offsetTop -
            thumbnailsContainer.offsetHeight / 2 +
            activeThumbnail.offsetHeight / 2;
          thumbnailsContainer.scrollTo({ top: scrollTop, behavior: 'smooth' });
        }

        const prevArrow = this.element.querySelector('.flagship-gallery__arrow--prev');
        const nextArrow = this.element.querySelector('.flagship-gallery__arrow--next');
        const hideArrows = this.totalSlides <= 1;

        if (prevArrow) prevArrow.classList.toggle('is-hidden', hideArrows);
        if (nextArrow) nextArrow.classList.toggle('is-hidden', hideArrows);

        const nav = this.element.querySelector('.flagship-gallery__nav');
        if (nav) nav.classList.toggle('is-hidden', hideArrows);
      }

      addSwipeSupport() {
        if (!this.track) return;

        let startX = 0;
        let endX = 0;

        this.track.addEventListener('touchstart', (e) => {
          startX = e.touches[0].clientX;
        });

        this.track.addEventListener('touchmove', (e) => {
          endX = e.touches[0].clientX;
        });

        this.track.addEventListener('touchend', () => {
          const diff = startX - endX;
          if (Math.abs(diff) > 50) {
            if (diff > 0) {
              this.goToNext();
            } else {
              this.goToPrevious();
            }
          }
        });
      }
    }

    function buildGalleryElement(imageUrls, root) {
      const hasMultiple = imageUrls.length > 1;
      const galleryFragment = cloneFlagshipTemplate(root, 'gallery-root');
      if (!galleryFragment) return null;

      const gallery = galleryFragment.querySelector('[data-flagship-gallery-root]');
      const track = gallery.querySelector('.flagship-gallery__track');
      const slideTemplate = getFlagshipTemplate(root, 'gallery-slide');

      if (!gallery || !track || !slideTemplate) return null;

      imageUrls.forEach((url, index) => {
        const slide = slideTemplate.content.firstElementChild.cloneNode(true);
        slide.dataset.slideIndex = String(index);
        slide.classList.toggle('is-active', index === 0);

        const img = slide.querySelector('img');
        img.src = url;
        img.alt = `Product image ${index + 1}`;
        img.loading = index === 0 ? 'eager' : 'lazy';

        if (index === 0) {
          img.setAttribute('fetchpriority', 'high');
        }

        track.appendChild(slide);
      });

      if (hasMultiple) {
        const thumbnailsFragment = cloneFlagshipTemplate(root, 'gallery-thumbnails');
        const thumbsScroll = thumbnailsFragment?.querySelector('.flagship-gallery__thumbnails-scroll');
        const thumbTemplate = getFlagshipTemplate(root, 'gallery-thumbnail');

        if (thumbnailsFragment && thumbsScroll && thumbTemplate) {
          imageUrls.forEach((url, index) => {
            const thumb = thumbTemplate.content.firstElementChild.cloneNode(true);
            thumb.dataset.mediaId = String(index);
            thumb.classList.toggle('is-active', index === 0);
            thumb.setAttribute('aria-label', `View image ${index + 1}`);

            const img = thumb.querySelector('img');
            img.src = url;
            img.alt = '';

            thumbsScroll.appendChild(thumb);
          });

          gallery.insertBefore(thumbnailsFragment.firstElementChild, gallery.firstElementChild);
        }

        const controlsFragment = cloneFlagshipTemplate(root, 'gallery-controls');
        const main = gallery.querySelector('.flagship-gallery__main');
        const nav = controlsFragment?.querySelector('.flagship-gallery__nav');
        const navItemTemplate = getFlagshipTemplate(root, 'gallery-nav-item');

        if (controlsFragment && main && nav && navItemTemplate) {
          imageUrls.forEach((_, index) => {
            const navItem = navItemTemplate.content.firstElementChild.cloneNode(true);
            navItem.dataset.slideIndex = String(index);
            navItem.classList.toggle('is-active', index === 0);
            navItem.setAttribute('aria-label', `View image ${index + 1}`);
            nav.appendChild(navItem);
          });

          main.appendChild(controlsFragment.firstElementChild);
        }
      }

      return gallery;
    }

    function showFlagshipBtnLoading(btn) {
      btn.classList.add('is-loading');
      btn.disabled = true;
    }

    function hideFlagshipBtnLoading(btn) {
      btn.classList.remove('is-loading');
      btn.disabled = false;
    }

    // Add-to-cart via the unified window.addToCart: passes the flagship variant +
    // quantity, the chosen selling plan when subscribing, and lets addToCart attach
    // the free app item + open the drawer. Circular spinner covers the request.
    function setupFlagshipAddToCart(component) {
      if (component._addToCartBound) return;
      component._addToCartBound = true;

      const btn = component.querySelector('[data-flagship-add-to-cart]');
      if (!btn) return;

      btn.addEventListener('click', function () {
        const item = component.productOffer;
        if (!item || !item.id || typeof window.addToCart !== 'function') return;

        const qtyEl = component.querySelector('#flagship-quantity');
        const quantity = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;

        const subscribeRadio = component.querySelector('#flagship-subscribe');
        const isSubscription = !!(subscribeRadio && subscribeRadio.checked);

        const deliverySelect = component.querySelector('[data-flagship-delivery-select]');
        const selectedOption = deliverySelect && deliverySelect.options[deliverySelect.selectedIndex];
        const sellingPlanId = selectedOption
          ? (selectedOption.getAttribute('data-selling-plan-id') || selectedOption.value || null)
          : null;

        showFlagshipBtnLoading(btn);
        window.addToCart({
          items: [{
            id: item.id,
            quantity: quantity,
            sellingPlanId: isSubscription ? sellingPlanId : null,
          }],
          subscription: isSubscription,
          source: 'flagship-product',
        })
          .catch(function () {})
          .finally(function () { hideFlagshipBtnLoading(btn); });
      });
    }

    // Intro copy from AEM shopify/shopify-homepage (personal-path-*).
    (function initFlagshipIntro() {
      const intro = document.querySelector('[data-flagship-intro]');
      if (!intro || !intro.hasAttribute('data-loading')) return;

      function applyIntro(aem) {
        const node = aem && aem['shopify/shopify-homepage'];
        if (!node) return;
        const eyebrow = intro.querySelector('[data-flagship-intro-eyebrow]');
        const title = intro.querySelector('[data-flagship-intro-title]');
        const desc = intro.querySelector('[data-flagship-intro-description]');
        if (eyebrow) eyebrow.textContent = (typeof node['personal-path-eye'] === 'string' && node['personal-path-eye']) ? node['personal-path-eye'] : 'personal-path-eye';
        if (title) title.textContent = (typeof node['personal-path-title'] === 'string' && node['personal-path-title']) ? node['personal-path-title'] : 'personal-path-title';
        if (desc && node['personal-path-description']) desc.innerHTML = node['personal-path-description'];
        intro.removeAttribute('data-loading');
      }

      if (window.dataAEM) {
        applyIntro(window.dataAEM);
      } else {
        document.addEventListener('aem:data:loaded', function (e) {
          applyIntro(e.detail || window.dataAEM);
        }, { once: true });
      }
    })();

    // Purchase-option UI labels from AEM shopify/offers and shopify/discovery-kit
    // (subscribe banner, included-with-purchase promo) — localized with the rest of the page.
    (function initFlagshipOfferLabels() {
      const root = document.querySelector('[data-flagship-product]');
      if (!root || root.hasAttribute('data-design-mode')) return;

      function resolveAssetUrl(url) {
        if (typeof url !== 'string' || !url) return '';
        if (/^(https?:)?\/\//i.test(url) || url.indexOf('data:') === 0) return url;
        const base = window.AEM_PUBLISHING_URL || '';
        return base.replace(/\/$/, '') + (url.charAt(0) === '/' ? url : '/' + url);
      }

      function applyLabels(aem) {
        if (!aem) return;
        const offers = aem['shopify/offers'] || {};
        const discovery = aem['shopify/discovery-kit'] || {};
        const setText = function (sel, val) {
          if (typeof val !== 'string' || !val) return;
          const el = root.querySelector(sel);
          if (el) el.textContent = val;
        };

        setText('[data-flagship-subscribe-label]', offers['subscribe-earn'] || 'subscribe-earn');
        setText('[data-flagship-onetime-label]', offers['one-time-purchase'] || 'one-time-purchase');
        setText('[data-flagship-stock-label]', offers['in-stock'] || 'in-stock');
        setText('[data-flagship-subscribe-btn]', offers['subscribe-earn'] || 'subscribe-earn');
        setText('[data-flagship-onetime-btn]', offers['add-to-cart'] || 'add-to-cart');

        const banner = root.querySelector('[data-flagship-banner]');
        if (banner) banner.textContent = (typeof discovery['subscribe-banner'] === 'string' && discovery['subscribe-banner']) ? discovery['subscribe-banner'] : 'subscribe-banner';

        setText('[data-flagship-promo-eyebrow]', discovery['included-title'] || 'included-title');
        const included = Array.isArray(discovery['included-with-purchase'])
          ? discovery['included-with-purchase'][0]
          : null;
        if (included) {
          setText('[data-flagship-promo-title]', included.title);
          const descEl = root.querySelector('[data-flagship-promo-description]');
          if (descEl && typeof included.description === 'string' && included.description) {
            descEl.innerHTML = included.description;
          }
          const imgEl = root.querySelector('[data-flagship-promo-img]');
          const src = resolveAssetUrl(included.img);
          if (imgEl) {
            window.setAemImage(imgEl, src, 'general');
            imgEl.alt = included.title || '';
          }
        }
      }

      if (window.dataAEM) {
        applyLabels(window.dataAEM);
      } else {
        document.addEventListener('aem:data:loaded', function (e) {
          applyLabels(e.detail || window.dataAEM);
        }, { once: true });
      }
    })();

    class FlagshipProduct extends HTMLElement {
      galleryInstance = null;
      productOffer = null;

      connectedCallback() {
        this.initGallery();
        setupFlagshipPurchaseOptions(this);
        setupFlagshipAddToCart(this);

        // In the site-builder live preview the DMO payload is (re)injected on
        // every edit, so we must keep listening and re-apply rather than applying
        // a single time — otherwise the product stays blank if the first event
        // raced ahead of (or arrived before) the enriched offer data.
        const isPreview = !!window.__p2cPreview;

        if (window.data) {
          this.init(window.data);
        }
        if (isPreview) {
          document.addEventListener('dmo:data:loaded', this.handleDataLoaded);
        } else if (!window.data) {
          document.addEventListener('dmo:data:loaded', this.handleDataLoaded, { once: true });
        }
      }

      disconnectedCallback() {
        document.removeEventListener('dmo:data:loaded', this.handleDataLoaded);
        this.galleryInstance = null;
        this.productOffer = null;
      }

      init(data) {
        this.productOffer = getFlagshipItem(data);

        // No FLAGSHIP_PRODUCT offer → hide the whole section (intro + product).
        // On /pages/offers it's already hidden server-side; this covers other pages.
        if (!this.productOffer && !this.hasAttribute('data-design-mode')) {
          this.removeAttribute('data-loading');
          this.style.display = 'none';
          const introEl = document.querySelector('[data-flagship-intro]');
          if (introEl) introEl.style.display = 'none';
          return;
        }

        // A prior (racy/empty) apply may have hidden the section in preview;
        // restore visibility now that we have a flagship product.
        this.style.display = '';
        const introEl = document.querySelector('[data-flagship-intro]');
        if (introEl) introEl.style.display = '';

        // Sites with pro2colDownloadDisabled === true do not offer the app, so
        // the "Included With Your Purchase" promo must not advertise access to
        // it. Absent flag means enabled (see DMO/assessment-availability.ts).
        // Re-evaluated on every apply so the site-builder preview follows the
        // toggle without a reload.
        const promoEl = this.querySelector('[data-flagship-promo]');
        if (promoEl) {
          promoEl.style.display = data && data.pro2colDownloadDisabled === true ? 'none' : '';
        }

        this.applyGallery(data);
        this.applyProductDetails();
        this.applySubscription();

        // Data applied — drop the skeleton.
        this.removeAttribute('data-loading');

        if (this.productOffer?.translations) {
          try {
            this.translations = JSON.parse(this.productOffer.translations);
          } catch {
            this.translations = null;
          }
        }
      }

      handleDataLoaded = (event) => {
        const data = event.detail || window.data;
        this.init(data);
      };

      initGallery() {
        const existingGallery = this.querySelector('[data-flagship-gallery-root]');
        if (existingGallery) {
          this.galleryInstance = new FlagshipGallery(existingGallery);
        }
      }

      applyGallery(data) {
        if (this.hasAttribute('data-design-mode')) {
          this.initGallery();
          return;
        }

        const mediaContainer = this.querySelector('[data-flagship-gallery]');
        if (!mediaContainer) return;

        let imageUrls = getFlagshipImageUrls(data);
        if (imageUrls.length === 0) {
          imageUrls = [PLACEHOLDER_IMAGE];
        }

        mediaContainer.replaceChildren();
        const gallery = buildGalleryElement(imageUrls, this);

        if (gallery) {
          mediaContainer.appendChild(gallery);
          this.galleryInstance = new FlagshipGallery(gallery);
        }
      }

      applyProductDetails() {
        if (this.hasAttribute('data-design-mode')) return;

        const titleEl = this.querySelector('[data-flagship-title]');
        const priceEl = this.querySelector('[data-flagship-price]');
        const descriptionEl = this.querySelector('[data-flagship-description]');
        const skuEl = this.querySelector('[data-flagship-sku]');
        const item = this.productOffer;

        if (titleEl && item) {
          const title = getFlagshipTitle(item);
          if (title) titleEl.textContent = title;
        }

        if (priceEl && item) {
          const price = getFlagshipDisplayPrice(item);
          if (price != null) {
            const fromPrefix = window.translations?.content?.from_price_prefix || 'From';
            priceEl.textContent = `${fromPrefix} ${formatFlagshipPrice(price)}`;
          }
        }

        const seeLabelSlot = this.querySelector('[data-see-label-slot]');
        if (seeLabelSlot && window.P2CLabel) {
          const pdfUrl = item ? window.P2CLabel.getPdfUrl(item.additionalImages) : null;
          seeLabelSlot.replaceChildren();
          if (pdfUrl) seeLabelSlot.appendChild(window.P2CLabel.buildLink(pdfUrl));
        }

        if (descriptionEl && item) {
          const description = getFlagshipDescription(item);
          if (description) descriptionEl.innerHTML = sanitizeFlagshipHTML(description);
        }

        if (skuEl && item?.sku) {
          const skuLabel = window.translations?.content?.sku_label || 'SKU';
          const displaySku = getFlagshipSkuDisplay(item.sku);
          if (displaySku) skuEl.textContent = `${skuLabel} ${displaySku}`;
        }
      }

      async applySubscription() {
        if (this.hasAttribute('data-design-mode')) return;

        const item = this.productOffer;
        if (!item) return;

        applyFlagshipSubscriptionPrices(this, item);

        const { hasSellingPlans, sellingPlans } = await fetchFlagshipSellingPlans(item);
        const subscriptionsEnabled = window.data?.subscriptionsEnabled !== false;
        const effectiveHasSellingPlans =
          subscriptionsEnabled && (hasSellingPlans || Array.isArray(item.sellingPlans));

        updateFlagshipDeliveryFrequency(
          this,
          sellingPlans.length ? sellingPlans : item.sellingPlans || []
        );
        updateFlagshipSellingPlanVisibility(this, effectiveHasSellingPlans);
      }
    }

    if (!customElements.get('flagship-product')) {
      customElements.define('flagship-product', FlagshipProduct);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-hero]');
    if (!root) return;

    const headingEl = root.querySelector('[data-hero-heading]');
    const textEl    = root.querySelector('[data-hero-text]');
    const imageEl   = root.querySelector('[data-hero-image]');
    const videoEl   = root.querySelector('[data-hero-video]');

    const VIDEO_EXT = /\.(mp4|webm|ogg|ogv|mov|m4v)(\?.*)?$/i;
    const isVideoUrl = (url) => typeof url === 'string' && VIDEO_EXT.test(url);

    const apply = (data) => {
      const banner = data && data.theme && data.theme.bannerFooter;
      if (!banner) return false;

      if (headingEl && banner.title) headingEl.textContent = banner.title;

      if (textEl && banner.descriptionEnabled && banner.description) {
        textEl.textContent = banner.description;
        textEl.hidden = false;
      }

      if (banner.photoUrl) {
        if (isVideoUrl(banner.photoUrl) && videoEl) {
          videoEl.src = banner.photoUrl;
          videoEl.hidden = false;
          if (imageEl) imageEl.hidden = true;
        } else if (imageEl) {
          imageEl.src = banner.photoUrl;
          if (banner.title) imageEl.alt = banner.title;
          imageEl.hidden = false;
          if (videoEl) videoEl.hidden = true;
        }
      }

      return true;
    };

    if (typeof window.attachSectionLoading === 'function') {
      window.attachSectionLoading({ root, source: 'dmo', apply, label: 'hero' });
    } else if (window.data) {
      apply(window.data);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-how-it-works]');
    if (!root) return;

    const resolveAssetUrl = (url) => {
      if (typeof url !== 'string' || !url) return '';
      if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:')) return url;
      const base = window.AEM_PUBLISHING_URL || '';
      return base.replace(/\/$/, '') + (url.startsWith('/') ? url : '/' + url);
    };

    const apply = (aem) => {
      const node = aem && aem['shopify/how-it-works'];

      // No node yet: keep static fallback, but still resolve the loader so the
      // skeleton drops cleanly on aem:data:loaded.
      if (!node) return true;

      const titleEl    = root.querySelector('[data-how-it-works-title]');
      const subtitleEl = root.querySelector('[data-how-it-works-subtitle]');

      if (titleEl) {
        titleEl.textContent = (typeof node.title === 'string' && node.title) ? node.title : 'title';
      }
      if (subtitleEl && typeof node.description === 'string' && node.description) {
        subtitleEl.innerHTML = node.description;
      }

      const steps = node['steps-list'];
      if (Array.isArray(steps) && steps.length) {
        const list = root.querySelector('[data-how-it-works-steps]');
        const template = list && list.querySelector('[data-how-it-works-step]');
        if (list && template) {
          const fragment = document.createDocumentFragment();
          steps.forEach((step) => {
            if (!step || typeof step !== 'object') return;
            const clone = template.cloneNode(true);
            const imageEl = clone.querySelector('[data-how-it-works-step-image]');
            const labelEl = clone.querySelector('[data-how-it-works-step-label]');
            const stepTitleEl = clone.querySelector('[data-how-it-works-step-title]');
            const descEl = clone.querySelector('[data-how-it-works-step-description]');

            if (imageEl) {
              window.setAemImage(imageEl, resolveAssetUrl(step.img), 'general');
              if (typeof step.subtitle === 'string' && step.subtitle) imageEl.alt = step.subtitle;
            }
            if (labelEl && typeof step.title === 'string' && step.title) labelEl.textContent = step.title;
            if (stepTitleEl && typeof step.subtitle === 'string' && step.subtitle) stepTitleEl.textContent = step.subtitle;
            if (descEl && typeof step.description === 'string' && step.description) descEl.innerHTML = step.description;

            fragment.appendChild(clone);
          });
          list.replaceChildren(fragment);
        }
      }

      const carouselEl = root.querySelector('[data-carousel] .swiper');
      if (carouselEl && carouselEl.swiper) {
        setTimeout(() => carouselEl.swiper.update(), 50);
      }

      return true;
    };

    if (typeof window.attachSectionLoading === 'function') {
      window.attachSectionLoading({ root, source: 'aem', apply, label: 'how-it-works', timeoutMs: 60000 });
    } else if (window.dataAEM) {
      apply(window.dataAEM);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icon-columns"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-icon-columns]');
    if (!root) return;

    const titleEl = root.querySelector('[data-icon-columns-title]');
    const descEl  = root.querySelector('[data-icon-columns-description]');
    const gridEl  = root.querySelector('[data-icon-columns-grid]');

    // Resolve AEM /content/dam/... paths against the publish origin.
    const resolveAssetUrl = (url) => {
      if (typeof url !== 'string' || !url) return '';
      if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:')) return url;
      const base = window.AEM_PUBLISHING_URL || '';
      return base.replace(/\/$/, '') + (url.startsWith('/') ? url : '/' + url);
    };

    const apply = (aem) => {
      const node = aem && aem['shopify/offers'];
      if (!node) return false;

      const title    = node['healthy-aging-title'];
      const descHtml = node['healthy-aging-description'];
      const pillars  = node['healthy-aging-pillars'];

      let hasContent = false;

      if (titleEl) {
        titleEl.textContent = (typeof title === 'string' && title) ? title : 'healthy-aging-title';
        titleEl.hidden = false;
        hasContent = true;
      }

      if (descEl && typeof descHtml === 'string' && descHtml) {
        descEl.innerHTML = descHtml;
        descEl.hidden = false;
        hasContent = true;
      }

      if (gridEl && Array.isArray(pillars) && pillars.length > 0) {
        gridEl.replaceChildren();
        pillars.forEach((p) => {
          if (!p || typeof p !== 'object') return;
          const item = document.createElement('div');
          item.className = 'icon-columns__item';

          if (p.img) {
            const iconWrap = document.createElement('div');
            iconWrap.className = 'icon-columns__item-icon';
            const img = document.createElement('img');
            window.setAemImage(img, resolveAssetUrl(p.img), 'general');
            img.alt = typeof p.title === 'string' ? p.title : '';
            img.loading = 'lazy';
            iconWrap.appendChild(img);
            item.appendChild(iconWrap);
          }

          if (typeof p.title === 'string' && p.title) {
            const h3 = document.createElement('h3');
            h3.className = 'icon-columns__item-title';
            h3.textContent = p.title;
            item.appendChild(h3);
          }

          if (typeof p.description === 'string' && p.description) {
            const desc = document.createElement('div');
            desc.className = 'icon-columns__item-description';
            desc.innerHTML = p.description;
            item.appendChild(desc);
          }

          gridEl.appendChild(item);
        });
        hasContent = true;
      }

      return hasContent;
    };

    if (typeof window.attachSectionLoading === 'function') {
      window.attachSectionLoading({ root, source: 'aem', apply, label: 'icon-columns', timeoutMs: 60000 });
    } else if (window.dataAEM) {
      apply(window.dataAEM);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-content-card"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const DUPLICATE_MESSAGE = 'Not possible to order more than one of each';
    const buttons = document.querySelectorAll('.image-content-card__add-to-cart');

    function findErrorTarget(button) {
      const sectionEl = button.closest('.image-content-card');
      if (!sectionEl) return null;
      return sectionEl.querySelector('.image-content-card__error');
    }

    function showError(button, message) {
      const errorEl = findErrorTarget(button);
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
      clearTimeout(errorEl.__hideTimer);
      errorEl.__hideTimer = setTimeout(function() {
        errorEl.hidden = true;
      }, 5000);
    }

    function clearError(button) {
      const errorEl = findErrorTarget(button);
      if (!errorEl) return;
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    function markBloodInCart() {
      document.querySelectorAll('.image-content-card__add-to-cart, .blood-checkout-btn').forEach(function(btn) {
        btn.dataset.bloodInCart = 'true';
      });
    }

    buttons.forEach(button => {
      button.addEventListener('click', async function(e) {
        e.preventDefault();

        const variantId = this.dataset.variantId;
        if (!variantId) return;

        const isBloodwork = this.dataset.isBloodwork === 'true';
        const bloodInCart = this.dataset.bloodInCart === 'true';

        clearError(this);

        if (isBloodwork && bloodInCart) {
          showError(this, DUPLICATE_MESSAGE);
          return;
        }

        this.classList.add('is-loading');
        this.disabled = true;

        try {
          const cartData = {
            id: variantId,
            quantity: 1
          };

          if (isBloodwork) {
            cartData.properties = {
              '_bloodwork': 'true',
              'Pro2col Labs': ''
            };
          }

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify(cartData)
          });

          if (!response.ok) {
            throw new Error('Failed to add to cart');
          }

          if (isBloodwork) {
            markBloodInCart();
          }

          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              data: {
                source: 'product-form-component',
                itemCount: 1
              }
            }
          }));

        } catch (error) {
          console.error('Error adding to cart:', error);
        } finally {
          this.classList.remove('is-loading');
          this.disabled = false;
        }
      });
    });

    // Sticky bar: show when scrolled past the section, hide near footer
    const stickyBars = document.querySelectorAll('.image-content-card__sticky-bar');
    if (stickyBars.length) {
      function handleScroll() {
        const footer = document.querySelector('footer, .shopify-section-group-footer-group');
        stickyBars.forEach(stickyBar => {
          const barId = stickyBar.id;
          const sectionId = barId.replace('sticky-bar-', '');
          const section = document.querySelector('.image-content-card--' + sectionId);
          if (!section) return;

          const sectionBottom = section.getBoundingClientRect().bottom;
          const footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
          const windowHeight = window.innerHeight;
          const isNearBottom = (window.innerHeight + window.scrollY) >= (document.body.scrollHeight - 100);

          if (sectionBottom < 0 && footerTop > windowHeight && !isNearBottom) {
            stickyBar.classList.add('is-visible');
          } else {
            stickyBar.classList.remove('is-visible');
          }
        });
      }

      window.addEventListener('scroll', handleScroll, { passive: true });
      window.addEventListener('resize', handleScroll);
      handleScroll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-featured"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-main-collection-featured]');
    if (!root) return;

    // EU browse-only gate: unlock once the wellness assessment was completed
    // on this device (flag set by src/scripts/DMO/profile-metrics.ts). Runs
    // before the card init below so unlocked cards behave exactly like US ones.
    // While still gated, card links point to the assessment quiz instead
    // (same URL builder as banner-with-card.liquid).
    const buildFindYourAgeUrl = () => {
      const baseUrl = (window.externalLinks && window.externalLinks.findYourAgeUrl) || '';
      if (!baseUrl) return '';
      const cleanBase = baseUrl.replace(/\/$/, '');
      const firstSegment = window.location.pathname.split('/').filter(Boolean)[0] || '';
      const localePattern = /^[a-z]{2}(-[a-z]{2})?$/i;
      const locale = localePattern.test(firstSegment) ? firstSegment : '';
      const path = locale ? '/' + locale + '/Intro' : '/Intro';
      // Preserve the current query string AND guarantee the site identifier is
      // present: on collection pages `site` often lives only in storage (the
      // redirect helper keeps it there), so window.location.search alone drops
      // it. Mirror theme-redirects.js by falling back to shopify_site_identifier.
      const search = new URLSearchParams(window.location.search);
      if (!search.get('site')) {
        const storedSite = (sessionStorage.getItem('shopify_site_identifier') || localStorage.getItem('shopify_site_identifier') || '').trim();
        if (storedSite) search.set('site', storedSite);
      }
      const qs = search.toString();
      return cleanBase + path + (qs ? '?' + qs : '');
    };

    // Sites with pro2colDownloadDisabled === true never offer the quiz, so
    // the gate has no way to unlock and must not apply — those sites browse
    // and buy like an ungated one. Absent flag means enabled (see
    // DMO/assessment-availability.ts). window.data arrives after this script
    // runs, hence the dmo:data:loaded re-run below.
    const assessmentDisabled = () =>
      !!(window.data && window.data.pro2colDownloadDisabled === true);

    // Reveal add-to-cart (and point card links at the product) once the
    // assessment flag is set. Extracted so it can re-run on bfcache restore
    // and cross-tab completion (see listeners below).
    const applyAssessmentGate = () => {
      if (assessmentDisabled() || localStorage.getItem('pro2col_assessment_completed') === 'true') {
        root.querySelectorAll('[data-fc-gated]').forEach((el) => el.removeAttribute('hidden'));
        root.querySelectorAll('[data-fc-gated-link]').forEach((a) => {
          a.setAttribute('href', a.getAttribute('data-fc-gated-link'));
          a.setAttribute('data-featured-collection-product-link', '');
        });
      } else {
        const quizUrl = buildFindYourAgeUrl();
        if (quizUrl) {
          root.querySelectorAll('[data-fc-gated-link]').forEach((a) => {
            a.setAttribute('href', quizUrl);
          });
        }
      }
    };

    applyAssessmentGate();

    // Make the unlock work right away without a manual reload:
    // - pro2col:assessment-completed: fired by profile-metrics.ts the moment it
    //   sets the flag on /pages/offers (same page load, after the assessment).
    //   This IIFE runs as a deferred script, so the listener is registered
    //   before that DOMContentLoaded-time dispatch.
    // - pageshow (persisted): user hits Back from the assessment and the page
    //   is restored from bfcache, so the load-time check never re-runs.
    // - storage: the assessment was completed in another tab.
    document.addEventListener('pro2col:assessment-completed', applyAssessmentGate);
    // - dmo:data:loaded: countryConfig only exists once the DMO payload lands,
    //   so the assessment-disabled unlock can't be decided on the first run.
    document.addEventListener('dmo:data:loaded', applyAssessmentGate);
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) applyAssessmentGate();
    });
    window.addEventListener('storage', (event) => {
      if (event.key === 'pro2col_assessment_completed') applyAssessmentGate();
    });

    // Product-card UI labels (Add To Cart / One-time Purchase / Subscribe & Earn)
    // come from AEM shopify/offers so they localize with the rest of the page.
    const applyOfferLabels = (aem) => {
      const node = aem && aem['shopify/offers'];
      if (!node) return;
      const setAll = (sel, val) => {
        if (typeof val !== 'string' || !val) return;
        root.querySelectorAll(sel).forEach((el) => { el.textContent = val; });
      };
      setAll('[data-fc-addcart-label]', node['add-to-cart'] || 'add-to-cart');
      setAll('[data-fc-onetime-label]', node['one-time-purchase'] || 'one-time-purchase');
      setAll('[data-fc-subscribe-label]', node['subscribe-earn'] || 'subscribe-earn');
    };
    if (window.dataAEM) {
      applyOfferLabels(window.dataAEM);
    } else {
      document.addEventListener('aem:data:loaded', (e) => applyOfferLabels(e.detail || window.dataAEM), { once: true });
    }

    // Per-card variant selector: each card carries its own variant payload + select.
    const productCards = root.querySelectorAll('[data-featured-collection-product]');
    productCards.forEach((card) => {
      const dataEl = card.querySelector('[data-featured-collection-variants]');
      if (!dataEl) return;

      let variants = [];
      try {
        variants = JSON.parse(dataEl.textContent || '[]');
      } catch (_e) {
        return;
      }
      if (!Array.isArray(variants) || variants.length === 0) return;

      // Approach B (PR support): the payload holds EVERY active variant. Filter to
      // the user's real country — window.data.profile.targetCountry (e.g. 'PR'),
      // which the URL can't carry because PR is redirected to es-us — using the URL
      // locale only as a fallback before DMO data loads. Variants match by the
      // country suffix in their title (e.g. '_PR'), mirroring the old Liquid filter.
      const allVariants = variants;
      const resolveCountry = () => {
        const tc = window.data && window.data.profile && window.data.profile.targetCountry;
        if (tc) return String(tc).toUpperCase();
        const m = window.location.pathname.match(/^\/[a-z]{2}-([a-z]{2})(?=\/|$)/i);
        return m ? m[1].toUpperCase() : 'US';
      };
      const variantsForCountry = (country) => {
        const suffix = '_' + country;
        const matched = allVariants.filter((v) => (v.title || '').toUpperCase().indexOf(suffix) !== -1);
        return matched.length ? matched : allVariants;
      };
      variants = variantsForCountry(resolveCountry());

      const nameEls = card.querySelectorAll('[data-featured-collection-product-name]');
      const pricing = card.querySelector('.featured-collection__pricing');
      const inclEl = card.querySelector('[data-featured-collection-price-incl]');
      const inclCompareEl = card.querySelector('[data-featured-collection-price-incl-compare]');
      const exclRow = card.querySelector('[data-featured-collection-price-excl-row]');
      const exclEl = card.querySelector('[data-featured-collection-price-excl]');
      const exclCompareEl = card.querySelector('[data-featured-collection-price-excl-compare]');
      const cartPriceEl = card.querySelector('[data-featured-collection-product-cart-price]');
      const idInput = card.querySelector('[data-featured-collection-product-id]');
      const imgEl = card.querySelector('[data-featured-collection-product-image]');
      const variantSelectEl = card.querySelector('[data-featured-collection-product-variant]');
      const sizeSelect = card.querySelector('[data-featured-collection-product-size]');
      const purchaseSelect = card.querySelector('[data-featured-collection-purchase]');
      const sellingPlanId = card.getAttribute('data-featured-collection-selling-plan') || null;

      let currentVariant = variants[0];

      const isSubscription = () =>
        !!purchaseSelect && purchaseSelect.value === 'subscription';

      const sizesForFlavor = (flavor) => {
        const seen = {};
        const out = [];
        variants.forEach((v) => {
          if (v.flavor === flavor && v.size && !seen[v.size]) {
            seen[v.size] = true;
            out.push(v.size);
          }
        });
        return out;
      };

      const populateSizes = (flavor, preferred) => {
        if (!sizeSelect) return;
        const sizes = sizesForFlavor(flavor);
        sizeSelect.innerHTML = '';
        sizes.forEach((s) => {
          const opt = document.createElement('option');
          opt.value = s;
          opt.textContent = s;
          sizeSelect.appendChild(opt);
        });
        if (preferred && sizes.indexOf(preferred) !== -1) {
          sizeSelect.value = preferred;
        } else if (sizes.length) {
          sizeSelect.value = sizes[0];
        }
        // The size <select> element renders whenever ANY country needs a size
        // (server count is country-agnostic). Hide it for countries/flavors that
        // have no size so PR (or any single-size locale) doesn't show an empty box.
        const sizeLabel = sizeSelect.closest('label');
        if (sizeLabel) sizeLabel.style.display = sizes.length ? '' : 'none';
      };

      const resolveVariant = () => {
        const flavor = variantSelectEl ? variantSelectEl.value : (currentVariant && currentVariant.flavor);
        const size = sizeSelect ? sizeSelect.value : null;
        return (
          variants.find((v) => v.flavor === flavor && (size === null || v.size === size)) ||
          variants.find((v) => v.flavor === flavor) ||
          variants[0]
        );
      };

      const setLine = (mainEl, compareEl, mainText, compareText) => {
        if (mainEl) mainEl.textContent = mainText || '';
        if (compareEl) {
          if (compareText) {
            compareEl.textContent = compareText;
            compareEl.removeAttribute('hidden');
          } else {
            compareEl.textContent = '';
            compareEl.setAttribute('hidden', '');
          }
        }
      };

      const render = () => {
        if (!currentVariant) return;
        const sub = isSubscription();
        const v = currentVariant;

        nameEls.forEach((el) => { el.textContent = v.name; });

        const inclMain = sub ? v.subIncl : v.priceIncl;
        const inclCompare = sub ? v.priceIncl : '';
        setLine(inclEl, inclCompareEl, inclMain, inclCompare);

        const exclMain = sub ? v.subExcl : v.priceExcl;
        const exclCompare = sub ? v.priceExcl : '';
        if (exclRow) {
          if (exclMain) exclRow.removeAttribute('hidden');
          else exclRow.setAttribute('hidden', '');
        }
        setLine(exclEl, exclCompareEl, exclMain, exclCompare);

        if (pricing) pricing.classList.toggle('is-subscription', sub);

        if (cartPriceEl) cartPriceEl.textContent = inclMain;
        if (idInput) idInput.value = v.id;
        if (imgEl) {
          if (v.imageUrl) {
            imgEl.setAttribute('src', v.imageUrl);
            imgEl.setAttribute('alt', v.name || '');
            imgEl.removeAttribute('hidden');
          } else {
            imgEl.removeAttribute('src');
            imgEl.setAttribute('hidden', '');
          }
        }
        if (v.url) {
          // Re-queried per render rather than captured at card init: in
          // browse-only markets Liquid omits the product-link attribute and
          // applyAssessmentGate adds it on unlock, which for the
          // assessment-disabled case lands with the DMO payload — after init.
          // A capture taken at init would be empty and the link would never
          // follow flavor/size.
          card.querySelectorAll('a[data-featured-collection-product-link]').forEach((el) => {
            el.setAttribute('href', v.url);
          });
          // Keep the stashed URL current too, so a later unlock uses the
          // variant actually on screen: the country filter above can resolve a
          // different one than the Liquid initial_variant_id (e.g. PR).
          card.querySelectorAll('a[data-fc-gated-link]').forEach((el) => {
            el.setAttribute('data-fc-gated-link', v.url);
          });
        }
      };

      const onFlavorChange = () => {
        const flavor = variantSelectEl.value;
        const prevSize = sizeSelect ? sizeSelect.value : null;
        populateSizes(flavor, prevSize);
        currentVariant = resolveVariant() || currentVariant;
        render();
      };

      const onSizeChange = () => {
        currentVariant = resolveVariant() || currentVariant;
        render();
      };

      if (variantSelectEl) variantSelectEl.addEventListener('change', onFlavorChange);
      if (sizeSelect) sizeSelect.addEventListener('change', onSizeChange);
      if (purchaseSelect) purchaseSelect.addEventListener('change', render);

      // Rebuild the flavor <select> from the currently-active (country-filtered)
      // variants. The server renders the URL-locale flavors; for a PR user this
      // swaps them for the _PR flavors once targetCountry is known.
      const rebuildFlavors = () => {
        if (!variantSelectEl) return;
        const seen = {};
        const flavors = [];
        variants.forEach((v) => {
          if (v.flavor && !seen[v.flavor]) {
            seen[v.flavor] = true;
            // value = flavor (option1) so resolution is unaffected; text = localized label.
            flavors.push({ value: v.flavor, label: v.flavorLabel || v.flavor });
          }
        });
        const prev = variantSelectEl.value;
        variantSelectEl.innerHTML = '';
        flavors.forEach((fl) => {
          const opt = document.createElement('option');
          opt.value = fl.value;
          opt.textContent = fl.label;
          variantSelectEl.appendChild(opt);
        });
        variantSelectEl.value = flavors.some((f) => f.value === prev) ? prev : (flavors[0] ? flavors[0].value : '');
      };

      // (Re)apply the country filter, rebuild selectors and re-render. Runs once on
      // init (URL-locale fallback) and again on dmo:data:loaded once the real
      // targetCountry (e.g. PR) is available.
      const applyCountry = () => {
        variants = variantsForCountry(resolveCountry());
        if (!variants.length) return;
        rebuildFlavors();
        const flavor0 = variantSelectEl ? variantSelectEl.value : (variants[0] && variants[0].flavor);
        const prevSize = currentVariant ? currentVariant.size : null;
        if (sizeSelect) populateSizes(flavor0, prevSize);
        currentVariant = resolveVariant() || variants[0];
        render();
      };

      applyCountry();
      if (!window.data) {
        document.addEventListener('dmo:data:loaded', applyCountry, { once: true });
      }

      // Add-to-cart via the unified window.addToCart (src/scripts/add-to-cart.ts).
      const form = card.querySelector('[data-featured-collection-form]');
      if (form) {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          const btn = form.querySelector('button[type="submit"]');
          const id = idInput ? idInput.value : (form.querySelector('[name="id"]') || {}).value;
          const qtyEl = form.querySelector('[name="quantity"]');
          const quantity = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
          if (!id) return;

          if (typeof window.addToCart !== 'function') {
            console.error('[main-collection-featured] window.addToCart not available');
            return;
          }

          const subscription = isSubscription() && !!sellingPlanId;

          if (btn) {
            btn.disabled = true;
            btn.classList.add('is-loading');
          }
          try {
            await window.addToCart({
              items: [{ id: id, quantity: quantity, sellingPlanId: subscription ? sellingPlanId : null }],
              subscription: subscription,
              source: 'main-collection-featured',
            });
          } catch (err) {
            console.error('[main-collection-featured] add to cart failed:', err);
          } finally {
            if (btn) {
              btn.disabled = false;
              btn.classList.remove('is-loading');
            }
          }
        });
      }
    });

    // When the DMO payload reports subscriptions are disabled for this site,
    // strip the subscribe option from every card.
    const gateSubscriptions = (data) => {
      if (!data || data.subscriptionsEnabled !== false) return;
      root.querySelectorAll('[data-featured-collection-purchase]').forEach((sel) => {
        const subOpt = sel.querySelector('option[value="subscription"]');
        if (subOpt) subOpt.remove();
        if (sel.value !== 'one-time') {
          sel.value = 'one-time';
          sel.dispatchEvent(new Event('change'));
        }
      });
    };

    if (window.data) {
      gateSubscriptions(window.data);
    } else {
      document.addEventListener('dmo:data:loaded', (e) => gateSubscriptions(e.detail || window.data), { once: true });
    }

    // Equalize product-title heights so prices/selects line up across cards.
    const titleEls = Array.from(root.querySelectorAll('.featured-collection__product-title'));

    const equalizeCardRows = () => {
      if (titleEls.length === 0) return;
      titleEls.forEach((el) => { el.style.minHeight = ''; });
      let max = 0;
      titleEls.forEach((el) => { max = Math.max(max, el.offsetHeight); });
      if (max > 0) titleEls.forEach((el) => { el.style.minHeight = max + 'px'; });
    };

    requestAnimationFrame(() => requestAnimationFrame(equalizeCardRows));
    window.setTimeout(equalizeCardRows, 600);

    let resizeRaf = 0;
    window.addEventListener('resize', () => {
      window.cancelAnimationFrame(resizeRaf);
      resizeRaf = window.requestAnimationFrame(equalizeCardRows);
    });

    if (typeof ResizeObserver === 'function') {
      const ro = new ResizeObserver(() => equalizeCardRows());
      ro.observe(root);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Filter product cards by target country SKU suffix
  function filterProductCardsByTargetCountry() {
    const targetCountry = window.data?.profile?.targetCountry;
    if (!targetCountry) {
      // No country data available — show all products rather than a blank page
      return;
    }

    const targetCountryLower = targetCountry.toLowerCase();
    const productCards = document.querySelectorAll('.product-grid__item[data-product-skus]');

    // Pre-compute supported category set so we can apply both filters in one pass.
    // Ids are compared lowercased and accent-stripped: the collection metafield is
    // translatable and localized storefronts serve its translation ("boissons-thés"),
    // while the variant category slugs are never translated ("boissons-thes").
    const normalizeCategoryId = id => String(id).trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    const resultsEl = document.querySelector('results-list');
    const supportedRaw = resultsEl && resultsEl.getAttribute('data-supported-category-ids');
    let supportedSet = null;
    if (supportedRaw) {
      let supportedIds;
      try {
        const parsed = JSON.parse(supportedRaw);
        supportedIds = Array.isArray(parsed) ? parsed : [String(parsed)];
      } catch (e) {
        supportedIds = supportedRaw.split(',');
      }
      supportedIds = supportedIds.map(normalizeCategoryId).filter(Boolean);
      if (supportedIds.length > 0) supportedSet = new Set(supportedIds);
    }

    // Single pass: compute country + category visibility together so display is
    // written once — prevents a flash of country-matching cards before category
    // filtering hides the ones that don't belong to this collection.
    const cardVisibility = [];
    let anyMatch = false;

    productCards.forEach(card => {
      const skusString = card.getAttribute('data-product-skus');

      if (!skusString || skusString.trim() === '') {
        cardVisibility.push({ card, visible: false });
        return;
      }

      const skus = skusString.split('|').filter(sku => sku.trim());
      const hasMatchingSku = skus.some(sku => {
        const skuParts = sku.split('_');
        if (skuParts.length < 2) return false;
        return skuParts[skuParts.length - 1].toLowerCase() === targetCountryLower;
      });

      if (!hasMatchingSku) {
        cardVisibility.push({ card, visible: false });
        return;
      }

      // Country matched — now check category if this collection has category filtering
      let visible = true;
      if (supportedSet) {
        const categoryRaw = card.getAttribute('data-variant-category-ids');
        if (!categoryRaw) {
          visible = false;
        } else {
          let variantCategories;
          try {
            const parsed = JSON.parse(categoryRaw);
            variantCategories = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
          } catch (e) {
            visible = false;
          }
          if (visible && (!Array.isArray(variantCategories) || !variantCategories.some(id => supportedSet.has(normalizeCategoryId(id))))) {
            visible = false;
          }
        }
      }

      cardVisibility.push({ card, visible });
      if (visible) anyMatch = true;
    });

    // Apply all visibility in one DOM write
    if (!anyMatch) {
      productCards.forEach(card => { card.style.display = 'none'; });
      showNoProductsMessage();
      return;
    }

    cardVisibility.forEach(({ card, visible }) => {
      card.style.display = visible ? '' : 'none';
    });

    const anyVisible = Array.from(productCards).some(card => card.style.display !== 'none');
    if (!anyVisible) {
      showNoProductsMessage();
    } else {
      hideNoProductsMessage();
    }

    // Update prices based on locale-matching variants
    updatePricesByLocale(targetCountryLower);

    // Filter card images by country code in filename
    filterCardImagesByCountry(targetCountryLower);

    // Update option tag counts (Sizes, Flavors) to only count country-matching variants
    updateOptionTagsByCountry(targetCountryLower);

    logLowestPriceVariant(targetCountryLower);
  }

  // Show a single static locale-matching image per card. No carousel, no hover.
  function filterCardImagesByCountry(targetCountryLower) {
    document.querySelectorAll('.product-grid__item').forEach(card => {
      if (card.style.display === 'none') return;

      // Prefer ProductImage from additionalImages variant metafield
      const additionalImagesRaw = card.getAttribute('data-additional-images');
      if (additionalImagesRaw) {
        try {
          const additionalImages = JSON.parse(additionalImagesRaw);
          const productImage = additionalImages.ProductImage;
          if (productImage) {
            const slideshow = card.querySelector('slideshow-component');
            const newImg = document.createElement('img');
            newImg.src = productImage;
            newImg.alt = card.getAttribute('data-product-handle') || '';
            newImg.className = 'collection-single-img';
            if (slideshow) {
              slideshow.replaceWith(newImg);
            }
            return;
          }
        } catch (e) {}
      }

      const slideshow = card.querySelector('slideshow-component');
      if (!slideshow) return;

      const slides = slideshow.querySelectorAll('slideshow-slide');
      if (!slides.length) return;

      let localeImg = null;
      let genericImg = null;

      slides.forEach(slide => {
        const img = slide.querySelector('img');
        if (!img || !img.src) return;

        const filename = img.src
          .split('/').pop()
          .split('?')[0]
          .split('.')[0]
          .toLowerCase()
          .replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/, '');

        const isCountryTagged = filename.includes('pc-') || filename.includes('pn-');

        if (!isCountryTagged) {
          if (!genericImg) genericImg = img;
          return;
        }

        const suffix = filename.split('-').pop();
        if (suffix && suffix.length === 2 && suffix === targetCountryLower && !localeImg) {
          localeImg = img;
        } else if (!genericImg) {
          genericImg = img;
        }
      });

      const source = localeImg || genericImg || slides[0].querySelector('img');
      if (!source || !source.src) {
        showPlaceholderImage(card);
        return;
      }

      // Request a high-resolution image from Shopify CDN
      let src = source.src;
      try {
        const u = new URL(src);
        u.searchParams.set('width', '1200');
        src = u.toString();
      } catch (e) {}

      const newImg = document.createElement('img');
      newImg.src = src;
      newImg.alt = source.alt || '';
      newImg.className = 'collection-single-img';
      slideshow.replaceWith(newImg);
    });
  }

  // Show placeholder image when no country-matching images exist
  function showPlaceholderImage(card) {
    const gallery = card.querySelector('.card-gallery');
    if (!gallery) return;

    // Don't add placeholder twice
    if (gallery.querySelector('.country-placeholder-image')) return;

    const placeholderUrl = document.querySelector('results-list')?.getAttribute('data-placeholder-image') || '';
    if (!placeholderUrl) return;

    const placeholder = document.createElement('div');
    placeholder.className = 'country-placeholder-image';
    placeholder.style.cssText = 'display:flex;align-items:center;justify-content:center;aspect-ratio:var(--gallery-aspect-ratio, 1/1);background:#fff;border-radius:var(--product-corner-radius, 8px);overflow:hidden;';
    placeholder.innerHTML = '<img src="' + placeholderUrl + '" alt="Product placeholder" style="max-width:70%;max-height:70%;object-fit:contain;" />';

    // Hide the slideshow and insert placeholder
    const slideshow = gallery.querySelector('slideshow-component');
    if (slideshow) {
      slideshow.style.display = 'none';
    }
    // Insert at the beginning of the gallery (before slideshow or any other content)
    gallery.insertBefore(placeholder, gallery.firstChild);
  }

  // Update option tag counts to only count variants matching the target country
  // Reads data-variant-options and data-option-map from the <li> product grid item
  function updateOptionTagsByCountry(targetCountryLower) {
    const productCards = document.querySelectorAll('.product-grid__item[data-variant-options]');

    productCards.forEach(card => {
      if (card.style.display === 'none') return;

      try {
        const variantsData = card.getAttribute('data-variant-options');
        const optionMapData = card.getAttribute('data-option-map');
        if (!variantsData || !optionMapData) return;

        const variants = JSON.parse(variantsData);
        const optionMap = JSON.parse(optionMapData);

        // Filter variants by country SKU suffix
        const countrySuffix = '_' + targetCountryLower;
        const matchingVariants = variants.filter(v => {
          if (!v.s) return false;
          return v.s.toLowerCase().endsWith(countrySuffix);
        });

        // Determine which option positions map to size/flavor/color
        let sizePosKey = null, flavorPosKey = null, colorPosKey = null;

        for (const [name, pos] of Object.entries(optionMap)) {
          const n = name.toLowerCase();
          if (n === 'size' || n === 'sizes') sizePosKey = 'o' + pos;
          else if (n === 'flavor' || n === 'flavors' || n === 'flavour' || n === 'flavours') flavorPosKey = 'o' + pos;
          else if (n === 'color' || n === 'colors' || n === 'colour' || n === 'colours') colorPosKey = 'o' + pos;
        }

        // Count unique values for each option type from matching variants
        const sizeValues = new Set();
        const flavorValues = new Set();
        const colorValues = new Set();

        matchingVariants.forEach(v => {
          if (sizePosKey && v[sizePosKey]) sizeValues.add(v[sizePosKey]);
          if (flavorPosKey && v[flavorPosKey]) flavorValues.add(v[flavorPosKey]);
          if (colorPosKey && v[colorPosKey]) colorValues.add(v[colorPosKey]);
        });

        // Find the option tags container within this card
        const container = card.querySelector('.product-option-tags');
        if (!container) return;

        // Update or create badge elements
        const tags = container.querySelectorAll('.product-option-tag');

        // Read translated labels from data attributes (set by product-option-tags.liquid via | t)
        const sizeSingular = container.getAttribute('data-size-singular') || 'Size';
        const sizePlural = container.getAttribute('data-size-plural') || 'Sizes';
        const flavorSingular = container.getAttribute('data-flavor-singular') || 'Flavor';
        const flavorPlural = container.getAttribute('data-flavor-plural') || 'Flavors';
        const colorSingular = container.getAttribute('data-color-singular') || 'Color';
        const colorPlural = container.getAttribute('data-color-plural') || 'Colors';

        tags.forEach(tag => {
          const type = tag.getAttribute('data-option-type');
          if (type === 'size') {
            if (sizeValues.size > 0) {
              tag.textContent = sizeValues.size + ' ' + (sizeValues.size === 1 ? sizeSingular : sizePlural);
              tag.style.display = '';
            } else {
              tag.style.display = 'none';
            }
          } else if (type === 'flavor') {
            if (flavorValues.size > 0) {
              tag.textContent = flavorValues.size + ' ' + (flavorValues.size === 1 ? flavorSingular : flavorPlural);
              tag.style.display = '';
            } else {
              tag.style.display = 'none';
            }
          } else if (type === 'color') {
            if (colorValues.size > 0) {
              tag.textContent = colorValues.size + ' ' + (colorValues.size === 1 ? colorSingular : colorPlural);
              tag.style.display = '';
            } else {
              tag.style.display = 'none';
            }
          }
        });

        // Hide entire container if no tags visible
        const anyVisible = Array.from(tags).some(t => t.style.display !== 'none');
        container.style.display = anyVisible ? '' : 'none';
      } catch (e) {
        console.error('Error updating option tags by country:', e);
      }
    });
  }

  // Update product card prices based on locale-matching variants.
  // data-variants contains "price" (TTC, with metafield tax already applied), "price_excl" (HT, raw),
  // and "catalog_vat_price" (cents from catalog_prices.VATPrice metafield, for international markets).
  // For EU/CA countries: uses "price" (tax_amount metafield applied in Liquid).
  // For all other international markets: uses "catalog_vat_price" when available.
  function updatePricesByLocale(targetCountryLower) {
    const cc = window.data && window.data.countryConfig;
    const firstContainer = document.querySelector('[data-locale-price="true"]');
    const currency = (firstContainer && firstContainer.getAttribute('data-currency-code')) || (cc && cc.currency) || 'USD';

    // In the site-builder preview the document URL is the proxy endpoint;
    // the previewed storefront path lives on window.__p2cPreview.path.
    const localePath = (window.__p2cPreview && window.__p2cPreview.path) || window.location.pathname;
    const urlLang = (localePath.match(/^\/([a-z]{2})-/) || [])[1] || '';

    const vatLabels = {
      FR: 'TTC', IT: 'IVA incl.', AT: 'inkl. MwSt.',
      BE: urlLang === 'nl' ? 'Incl. BTW' : urlLang === 'de' ? 'inkl. MwSt.' : 'TVA incl.',
      DE: 'inkl. MwSt.',
      CH: urlLang === 'fr' ? 'TTC' : urlLang === 'it' ? 'IVA incl.' : 'inkl. MwSt.',
      NL: 'Incl. BTW', ES: 'IVA incl.', GB: 'Incl. VAT'
    };
    const exclVatLabels = {
      FR: 'HT', IT: 'Escl. IVA', AT: 'Exkl. MwSt.',
      BE: urlLang === 'nl' ? 'Excl. BTW' : urlLang === 'de' ? 'Exkl. MwSt.' : 'HT',
      DE: 'Exkl. MwSt.',
      CH: urlLang === 'fr' ? 'HT' : urlLang === 'it' ? 'Escl. IVA' : 'Exkl. MwSt.',
      NL: 'Excl. BTW', ES: 'Excl. IVA', GB: 'Excl. VAT'
    };
    const country = (window.data && window.data.profile && window.data.profile.targetCountry || '').toUpperCase();
    const vatLabel = vatLabels[country] || '';
    const exclVatLabel = exclVatLabels[country] || '';

    // North America uses Shopify native prices (no catalog_prices metafield expected)
    const naCountries = ['US', 'CA', 'PR'];
    const useNativePrices = naCountries.includes(country);

    const collectionLocaleMap = {
      FR: 'fr-FR', IT: 'it-IT', AT: 'de-AT',
      BE: urlLang === 'nl' ? 'nl-BE' : urlLang === 'de' ? 'de-BE' : 'fr-BE',
      DE: 'de-DE',
      CH: urlLang === 'fr' ? 'fr-CH' : urlLang === 'it' ? 'it-CH' : 'de-CH',
      NL: 'nl-NL', ES: 'es-ES', GB: 'en-GB', TR: 'tr-TR',
      CA: 'en-CA', US: 'en-US', PR: 'en-US',
    };
    const collectionLocale = collectionLocaleMap[country] || 'en-US';

    function formatWithCurrency(cents) {
      return new Intl.NumberFormat(collectionLocale, { style: 'currency', currency: currency, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
    }

    const priceContainers = document.querySelectorAll('[data-locale-price="true"]');

    priceContainers.forEach(container => {
      try {
        const variantsData = container.getAttribute('data-variants');
        if (!variantsData) return;

        const variants = JSON.parse(variantsData);

        // Filter variants that match the target country and are active
        const matchingVariants = variants.filter(variant => {
          if (!variant.sku) return false;
          if (variant.is_active === false) return false;
          const skuParts = variant.sku.split('_');
          if (skuParts.length < 2) return false;
          return skuParts[skuParts.length - 1].toLowerCase() === targetCountryLower;
        });

        if (matchingVariants.length === 0) return;

        // For all non-NA markets: use catalog_vat_price (from catalog_prices.VATPrice metafield) when available.
        // This matches the product page behavior (enhanced-product-information.liquid) which uses catalog_prices
        // for all non-North America countries. For NA: use "price" (Shopify native price).
        const ttcPrices = matchingVariants.map(v => {
          if (!useNativePrices && v.catalog_vat_price != null) return v.catalog_vat_price;
          // US/CA/PR: use the base RetailPrice from catalog_prices (no VAT) when present.
          if (useNativePrices && v.catalog_retail_price != null) return v.catalog_retail_price;
          return v.price;
        });
        const minTtc = Math.min(...ttcPrices);
        const maxTtc = Math.max(...ttcPrices);

        // HT prices (VAT-excl). Prefer catalog_prices.RetailPrice metafield → fallback to tax-computed price_excl.
        const htPrices = matchingVariants.map(v => {
          if (v.catalog_retail_price != null) return v.catalog_retail_price;
          return v.price_excl != null ? v.price_excl : v.price;
        });
        const minHt = Math.min(...htPrices);
        const maxHt = Math.max(...htPrices);

        // Determine whether any locale variant has tax info. Presence of catalog_prices (non-NA) is definitive —
        // it matches the PDP which treats the metafield as proof VAT applies. Otherwise fall back to tax_amount.
        const hasTax = matchingVariants.some(v => {
          if (!useNativePrices && v.catalog_prices != null) return true;
          return v.price_excl != null && v.price !== v.price_excl;
        });

        // Update data attributes with locale-filtered TTC prices
        container.setAttribute('data-min-cents', minTtc);
        container.setAttribute('data-max-cents', maxTtc);
        container.setAttribute('data-price-cents', minTtc);

        // --- Primary price (TTC) ---
        const formattedTtc = formatWithCurrency(minTtc);
        const priceElement = container.querySelector('.price, .price-from');
        if (priceElement) {
          if (minTtc !== maxTtc) {
            const fromPrefix = document.querySelector('results-list')?.getAttribute('data-from-price-prefix') || 'From';
            const toPrefix = document.querySelector('results-list')?.getAttribute('data-to-price-prefix') || 'to';
            const formattedMax = formatWithCurrency(maxTtc);
            priceElement.textContent = fromPrefix + ' ' + formattedTtc + ' ' + toPrefix + ' ' + formattedMax;
            priceElement.classList.add('price-from');
          } else {
            priceElement.textContent = formattedTtc;
            priceElement.classList.remove('price-from');
          }
        }

        // TTC label after main price (e.g. "TTC", "inkl. MwSt.")
        var existingVatLabel = container.querySelector('.price-vat-label');
        if (existingVatLabel) existingVatLabel.remove();

        if (hasTax && vatLabel) {
          var vatLabelEl = document.createElement('span');
          vatLabelEl.className = 'price-vat-label';
          vatLabelEl.textContent = '(' + vatLabel + ')';
          var insertAfterEl = container.querySelector('.price-from') || container.querySelector('.price:not(.price-from)');
          if (insertAfterEl && insertAfterEl.parentNode) {
            insertAfterEl.parentNode.insertBefore(vatLabelEl, insertAfterEl.nextSibling);
          }
          container.dataset.vatApplied = 'true';
        } else {
          delete container.dataset.vatApplied;
        }

        // --- Secondary price (HT / excl. VAT) ---
        // Replace the Liquid-rendered .price-excl-vat span (which uses the wrong global price_min)
        // with the correct locale-filtered HT price.
        var exclVatSpan = container.querySelector('.price-excl-vat');
        if (hasTax && exclVatLabel) {
          const formattedMinHt = formatWithCurrency(minHt);
          const fromPrefix = document.querySelector('results-list')?.getAttribute('data-from-price-prefix') || 'From';
          const toPrefix = document.querySelector('results-list')?.getAttribute('data-to-price-prefix') || 'to';
          const htText = (minHt !== maxHt)
            ? fromPrefix + ' ' + formattedMinHt + ' ' + toPrefix + ' ' + formatWithCurrency(maxHt) + '\u00a0' + exclVatLabel
            : formattedMinHt + '\u00a0' + exclVatLabel;
          if (exclVatSpan) {
            exclVatSpan.textContent = htText;
            exclVatSpan.style.display = '';
          } else {
            // Span not rendered by Liquid (e.g. selected variant had tax_rate=0) — create it
            var newExclVatSpan = document.createElement('span');
            newExclVatSpan.className = 'price-excl-vat';
            newExclVatSpan.textContent = htText;
            container.appendChild(newExclVatSpan);
          }
        } else if (exclVatSpan) {
          exclVatSpan.style.display = 'none';
        }
      } catch (e) {
        console.error('Error updating price by locale:', e);
      }
    });
  }

  // Show "no products" message when country filter hides all products
  function showNoProductsMessage() {
    const grid = document.querySelector('[ref="grid"]');
    if (!grid) return;

    grid.style.display = 'none';

    if (!document.getElementById('no-products-country-message')) {
      const noProductsText = document.querySelector('results-list')?.getAttribute('data-no-products-text') || 'No products found.';
      const emptyDiv = document.createElement('div');
      emptyDiv.id = 'no-products-country-message';
      emptyDiv.style.cssText = 'display:flex;justify-content:center;align-items:center;text-align:center;min-height:50vh;padding:2rem 1rem;';
      emptyDiv.innerHTML = '<h2 class="h2" style="margin:0;">' + noProductsText + '</h2>';
      grid.parentNode.insertBefore(emptyDiv, grid);
    }
  }

  function hideNoProductsMessage() {
    const msg = document.getElementById('no-products-country-message');
    if (msg) msg.remove();

    const grid = document.querySelector('[ref="grid"]');
    if (grid) grid.style.display = '';
  }

  // Product titles on the collection page are rendered by Liquid (blocks/product-title.liquid)
  // using locale translations and custom.product_name metafield — no JS needed here.
  function translateProductTitles() {}

  // Register a DMO gate so main.ts can wait for the grid reveal before unhiding the body.
  var _collectionGate = window.dmoGates && window.dmoGates.register('main-collection');

  // Reveal the product grid after filtering is complete.
  // The grid starts hidden (opacity: 0 via CSS) so products are never visible unfiltered.
  var _gridRevealed = false;
  function revealGrid() {
    if (_gridRevealed) return;
    _gridRevealed = true;
    var grid = document.querySelector('[ref="grid"]');
    if (grid) {
      grid.classList.add('collection-grid--ready');
    }
    if (_collectionGate) _collectionGate.signal();
  }

  // Run filtering + reveal.
  function runFiltering() {
    if (window.data && window.data.profile && window.data.profile.targetCountry) {
      filterProductCardsByTargetCountry();
      translateProductTitles();
    } else {
      // No country data — show all products as-is (fail-open).
      var productCards = document.querySelectorAll('.product-grid__item[data-product-skus]');
      productCards.forEach(function(card) { card.style.display = ''; });
      document.querySelectorAll('.product-option-tag[data-option-type="size"]').forEach(function(tag) { tag.style.display = ''; });
      hideNoProductsMessage();
    }
    revealGrid();
  }

  // Fallback: if dmo:data:loaded never fires within 4 seconds, reveal whatever we have.
  // This is slightly longer than the 3s body-show fallback so the page isn't blank
  // for any longer than necessary if the API is genuinely unavailable.
  var _filterFired = false;
  var _fallbackTimer = setTimeout(function() {
    if (!_filterFired) {
      _filterFired = true;
      runFiltering();
      // Keep retrying in the background in case data arrives late.
      setTimeout(function() {
        if (window.data && window.data.profile && window.data.profile.targetCountry) {
          filterProductCardsByTargetCountry();
          translateProductTitles();
        }
      }, 3000);
    }
  }, 4000);

  // Primary path: filter as soon as DMO data is available.
  // dmo:data:loaded fires before showBodyAfterJSLoad(), so the grid is filtered
  // before the body opacity transition starts — no visible flash.
  function onDataReady() {
    if (_filterFired) return;
    _filterFired = true;
    clearTimeout(_fallbackTimer);
    runFiltering();
  }

  document.addEventListener('dmo:data:loaded', onDataReady, { once: true });

  // Also handle the case where data is already set by the time DOMContentLoaded fires
  // (e.g., script runs after a cached API response).
  function init() {
    if (window.data && window.data.profile && window.data.profile.targetCountry) {
      onDataReady();
    }
    setupProductGridObserver();
    logLowestPriceVariant();
  }

  // Setup observer to re-filter when product grid changes (e.g., after sorting)
  function setupProductGridObserver() {
    var productGrid = document.querySelector('[ref="grid"]');
    if (!productGrid) return;

    var observer = new MutationObserver(function(mutations) {
      var hasSignificantChanges = mutations.some(function(m) {
        return m.type === 'childList' && m.addedNodes.length > 0;
      });
      if (hasSignificantChanges) {
        // Re-run filtering after content updates (sorting, pagination, etc.).
        // Grid is already visible at this point — just re-filter in place.
        if (window.data && window.data.profile && window.data.profile.targetCountry) {
          filterProductCardsByTargetCountry();
          translateProductTitles();
        }
      }
    });

    observer.observe(productGrid, { childList: true, subtree: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function logLowestPriceVariant(targetCountryLower) {
    const targetCountry = (targetCountryLower || '').toUpperCase();
    const localeSuffix = targetCountry ? '_' + targetCountry : null;

    const priceContainers = document.querySelectorAll('[data-variants][data-locale-price]');
    let lowestPrice = Infinity;
    let lowestEntry = null;

    priceContainers.forEach(el => {
      const card = el.closest('[data-product-handle]');
      const productHandle = card ? card.getAttribute('data-product-handle') : 'unknown';

      try {
        const variants = JSON.parse(el.getAttribute('data-variants'));

        // Filter to only active, locale-matching variants
        const localeVariants = variants.filter(v => {
          if (!v.sku || v.is_active === false) return false;
          return localeSuffix ? v.sku.toUpperCase().endsWith(localeSuffix) : true;
        });

        if (localeVariants.length === 0) return;

        const minVariant = localeVariants.reduce((min, v) => v.price < min.price ? v : min, localeVariants[0]);

        if (minVariant.price < lowestPrice) {
          lowestPrice = minVariant.price;
          lowestEntry = { product: productHandle, sku: minVariant.sku, price: minVariant.price, is_active: minVariant.is_active };
        }
      } catch (e) {
        // ignore parse errors
      }
    });

  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-bundles"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-new-bundles]');
    if (!root) return;

    // ── helpers ──────────────────────────────────────────────────────────────
    if (typeof window.getCurrentLocale !== 'function') {
      window.getCurrentLocale = function () {
        // In the site-builder preview the document URL is the proxy endpoint;
        // the previewed storefront path lives on window.__p2cPreview.path.
        const pathname = window.__p2cPreview?.path || window.location.pathname;
        const m = pathname.match(/^\/([a-z]{2})-([a-z]{2})(?:\/|$|\?)/i);
        return m ? m[1].toLowerCase() + '-' + m[2].toUpperCase() : 'en-US';
      };
    }
    const locale = () => window.getCurrentLocale();

    const resolveAssetUrl = (url) => {
      if (typeof url !== 'string' || !url) return '';
      if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:')) return url;
      const base = window.AEM_PUBLISHING_URL || '';
      return base.replace(/\/$/, '') + (url.startsWith('/') ? url : '/' + url);
    };

    const parseTranslations = (s) => {
      if (!s || typeof s !== 'string' || !s.trim()) return null;
      try { return JSON.parse(s); } catch { return null; }
    };
    const tValue = (translations, scope, field) => {
      if (!translations) return '';
      const loc = locale();
      const tries = [loc, loc.toLowerCase(), loc.split('-')[0].toLowerCase() + '-' + (loc.split('-')[1] || '').toUpperCase()];
      for (const l of tries) {
        const v = translations[l] && translations[l][scope] && translations[l][scope][field];
        if (typeof v === 'string' && v.trim()) return v;
      }
      return '';
    };
    // DMO rich-text values are JSON ({type:root,children:[...]}); render them to HTML.
    const parseRichText = (s) => {
      if (typeof s !== 'string' || !s.trim()) return '';
      if (!s.trim().startsWith('{')) return s;
      let parsed;
      try { parsed = JSON.parse(s); }
      catch { try { parsed = JSON.parse(s.replace(/\r?\n/g, '\\n')); } catch { return ''; } }
      if (!parsed || parsed.type !== 'root' || !Array.isArray(parsed.children)) {
        return typeof parsed === 'string' ? parsed : '';
      }
      const parts = [];
      parsed.children.forEach((child) => {
        if (!Array.isArray(child.children)) return;
        const text = child.children
          .map((c) => (c.value ? String(c.value).replace(/\\n/g, '<br>').replace(/\n/g, '<br>') : ''))
          .join('').replace(/^(<br>)+|(<br>)+$/g, '').trim();
        if (text) parts.push(child.type === 'paragraph' ? '<p>' + text + '</p>' : text);
      });
      return parts.join('');
    };
    // Accordion content: variant translation first, then product, then the raw DMO field.
    const itemContent = (item, field, fallbackField) => {
      const tr = parseTranslations(item.translations);
      const translated = tValue(tr, 'variant', field) || tValue(tr, 'product', field);
      return parseRichText(translated || item[fallbackField] || '');
    };

    const itemName = (item) => {
      const tr = parseTranslations(item.translations);
      const translated = tValue(tr, 'variant', 'product_name') || tValue(tr, 'product', 'product_name');
      const base = translated || item.productName || (item.title || '').split(' - ')[0];
      return (base || '').split(' - ')[0].split('/')[0].trim();
    };
    const itemFlavourSize = (item) => {
      const tr = parseTranslations(item.translations);
      let flavour = tValue(tr, 'variant', 'flavour');
      let size = tValue(tr, 'variant', 'variant_size');
      // fall back to parsing the variant title: "Name - Flavour / Size / SKU"
      if (!flavour || !size) {
        const parts = (item.title || '').split(' - ').slice(1).join(' - ').split(' / ');
        if (!flavour && parts[0]) flavour = parts[0].trim();
        if (!size && parts[1]) size = parts[1].trim();
      }
      return [flavour, size].filter(Boolean).join(', ');
    };
    const itemSku = (item) => {
      const sku = item.sku || '';
      const parts = sku.split('_');
      return parts.length > 1 ? parts.slice(0, -1).join('_') : sku;
    };

    const country = () => ((window.data && window.data.profile && window.data.profile.targetCountry)
      || (locale().split('-')[1]) || 'US').toUpperCase();

    const itemPrices = (item) => {
      const cp = item.catalogPricesV2 && item.catalogPricesV2[country()];
      if (cp) return { base: cp.VATPrice, sub: cp.VATSubscriptionPrice, hasVat: true };
      const basePrice = item.catalogPrice != null ? item.catalogPrice : item.price;
      const taxRate = typeof item.taxAmount === 'number' ? item.taxAmount : 0;
      const mult = 1 + taxRate;
      return { base: (basePrice || 0) * mult, sub: (basePrice || 0) * 0.95 * mult, hasVat: taxRate > 0 };
    };
    const fmt = (amount) => {
      try {
        return new Intl.NumberFormat(locale(), {
          style: 'currency',
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
          minimumFractionDigits: 2, maximumFractionDigits: 2,
        }).format(Math.floor(amount * 100) / 100);
      } catch { return '$' + (Math.floor(amount * 100) / 100).toFixed(2); }
    };
    const itemImage = (item) => {
      if (item.additionalImages && item.additionalImages.ProductImage) return item.additionalImages.ProductImage;
      if (Array.isArray(item.imageUrls) && item.imageUrls[0]) return item.imageUrls[0];
      return '';
    };
    const itemGallery = (item) => {
      const imgs = [];
      // The label PDF is surfaced as a "See label" link, never in the gallery.
      const pdfUrl = window.P2CLabel ? window.P2CLabel.getPdfUrl(item.additionalImages) : null;
      if (item.additionalImages) {
        Object.keys(item.additionalImages).sort((a) => (a === 'ProductImage' ? -1 : 1))
          .forEach((k) => { const u = item.additionalImages[k]; if (u && u !== pdfUrl) imgs.push(u); });
      }
      (item.imageUrls || []).forEach((u) => { if (u && imgs.indexOf(u) === -1) imgs.push(u); });
      return imgs;
    };

    // ── AEM strings ──────────────────────────────────────────────────────────
    let aemOffers = {};
    let aemHome = {};
    let aemCart = {};
    const readAem = (aem) => {
      aemOffers = (aem && aem['shopify/offers']) || {};
      aemHome = (aem && aem['shopify/shopify-homepage']) || {};
      aemCart = (aem && aem['shopify/cart']) || {};
    };
    const L = (key, fallback) => (typeof aemOffers[key] === 'string' && aemOffers[key]) ? aemOffers[key] : fallback;

    // ── DMO offer ──────────────────────────────────────────────────────────────
    const getBundleOffer = (data) => {
      const offers = data && data.theme && data.theme.productOffer && data.theme.productOffer.offers;
      if (!Array.isArray(offers)) return null;
      return offers.find((o) => o && o.type === 'BUNDLE') || null;
    };
    const getAppItem = (data) => {
      const offers = data && data.theme && data.theme.productOffer && data.theme.productOffer.offers;
      if (!Array.isArray(offers)) return null;
      const app = offers.find((o) => o && o.type === 'APP');
      return app && app.data && app.data.item ? app.data.item : null;
    };

    // ── modal ────────────────────────────────────────────────────────────────
    const modal = document.querySelector('[data-nb-modal]');
    const modalState = { gallery: [], idx: 0 };
    const showImage = (i) => {
      if (!modal || !modalState.gallery.length) return;
      const img = modal.querySelector('[data-nb-modal-image]');
      modalState.idx = (i + modalState.gallery.length) % modalState.gallery.length;
      if (img) img.src = modalState.gallery[modalState.idx];
      const thumbs = modal.querySelectorAll('[data-nb-modal-thumbs] img');
      thumbs.forEach((t, ti) => t.classList.toggle('is-active', ti === modalState.idx));
    };
    const openModal = (item) => {
      if (!modal || !item) return;
      const img = modal.querySelector('[data-nb-modal-image]');
      const thumbs = modal.querySelector('[data-nb-modal-thumbs]');
      modalState.gallery = itemGallery(item);
      modalState.idx = 0;
      if (img) { img.src = modalState.gallery[0] || ''; img.alt = itemName(item); }
      if (thumbs) {
        thumbs.replaceChildren();
        modalState.gallery.forEach((u, gi) => {
          const t = document.createElement('img');
          t.src = u; t.alt = ''; if (gi === 0) t.classList.add('is-active');
          t.addEventListener('click', () => showImage(gi));
          thumbs.appendChild(t);
        });
      }
      // Hide arrows when there's only one image.
      const prevBtn = modal.querySelector('[data-nb-modal-prev]');
      const nextBtn = modal.querySelector('[data-nb-modal-next]');
      const hideArrows = modalState.gallery.length <= 1;
      if (prevBtn) prevBtn.hidden = hideArrows;
      if (nextBtn) nextBtn.hidden = hideArrows;

      const titleEl = modal.querySelector('[data-nb-modal-title]');
      if (titleEl) titleEl.textContent = itemName(item);
      const priceEl = modal.querySelector('[data-nb-modal-price]');
      if (priceEl) {
        const p = itemPrices(item);
        const prefix = (window.translations && window.translations.content && window.translations.content.from_price_prefix) || 'From';
        priceEl.textContent = prefix + ' ' + fmt(p.base);
      }
      const seeLabelSlot = modal.querySelector('[data-see-label-slot]');
      if (seeLabelSlot && window.P2CLabel) {
        const pdfUrl = window.P2CLabel.getPdfUrl(item.additionalImages);
        seeLabelSlot.replaceChildren();
        if (pdfUrl) seeLabelSlot.appendChild(window.P2CLabel.buildLink(pdfUrl));
      }
      const fdaEl = modal.querySelector('[data-nb-modal-fda]');
      if (fdaEl) fdaEl.hidden = ['US', 'PR'].indexOf(country()) === -1;
      const variantEl = modal.querySelector('[data-nb-modal-variant]');
      if (variantEl) variantEl.textContent = itemFlavourSize(item);
      const skuEl = modal.querySelector('[data-nb-modal-sku]');
      if (skuEl) {
        const skuLabel = (window.translations && window.translations.content && window.translations.content.sku_label) || 'SKU';
        const sku = itemSku(item);
        skuEl.textContent = sku ? skuLabel + ': ' + sku : '';
      }
      // accordions: labels from AEM shopify/cart, content from the DMO item.
      const acc = modal.querySelector('[data-nb-modal-accordions]');
      if (acc) {
        acc.replaceChildren();
        const sections = [
          [aemCart.overviewLabel || 'overviewLabel', itemContent(item, 'overview', 'overview')],
          [aemCart.benefitsLabel || 'benefitsLabel', itemContent(item, 'features_and_benefits', 'benefits')],
          [aemCart.ingredientsLabel || 'ingredientsLabel', itemContent(item, 'ingredients', 'ingredients')],
          [aemCart.instructionsLabel || 'instructionsLabel', itemContent(item, 'instructions', 'instructions')],
        ];
        sections.forEach(([label, html], idx) => {
          if (!html || typeof html !== 'string' || !html.trim()) return;
          const wrap = document.createElement('div');
          wrap.className = 'nb-modal__accordion' + (idx === 0 ? ' is-open' : '');
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'nb-modal__accordion-trigger';
          btn.textContent = label;
          const panel = document.createElement('div');
          panel.className = 'nb-modal__accordion-panel';
          panel.innerHTML = html;
          // Single-open: close any other open accordion in the same group before opening this one.
          btn.addEventListener('click', () => {
            const wasOpen = wrap.classList.contains('is-open');
            acc.querySelectorAll('.nb-modal__accordion.is-open').forEach((o) => o.classList.remove('is-open'));
            if (!wasOpen) wrap.classList.add('is-open');
          });
          wrap.appendChild(btn); wrap.appendChild(panel);
          acc.appendChild(wrap);
        });
      }
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    };
    const closeModal = () => {
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    };
    if (modal) {
      modal.querySelectorAll('[data-nb-modal-close]').forEach((el) => el.addEventListener('click', closeModal));
      const prevBtn = modal.querySelector('[data-nb-modal-prev]');
      const nextBtn = modal.querySelector('[data-nb-modal-next]');
      if (prevBtn) prevBtn.addEventListener('click', () => showImage(modalState.idx - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => showImage(modalState.idx + 1));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeModal(); });
    }

    // The DMO payload carries no selling plan data, so when "Subscribe & Earn"
    // is selected each product's plan id is resolved from Shopify's own
    // /products/{handle}.js — the variant's first allocation, falling back to
    // the first plan of the first group (same source the old DMO bundles
    // used). window.addToCart only attaches selling_plan when the line item
    // carries a sellingPlanId. A failed lookup returns null and that item
    // falls back to a one-time line.
    const sellingPlanCache = {};
    const resolveSellingPlanId = async (handle, variantId) => {
      if (!handle) return null;
      const cacheKey = handle + ':' + variantId;
      if (cacheKey in sellingPlanCache) return sellingPlanCache[cacheKey];
      let planId = null;
      try {
        const m = window.location.pathname.match(/^\/([a-z]{2}-[a-z]{2})(?=\/|$)/i);
        const res = await fetch((m ? '/' + m[1] : '') + '/products/' + handle + '.js');
        if (res.ok) {
          const product = await res.json();
          const group = (product.selling_plan_groups || [])[0];
          if (group && Array.isArray(group.selling_plans) && group.selling_plans.length) {
            const variant = (product.variants || []).find((v) => String(v.id) === String(variantId));
            const alloc = variant && Array.isArray(variant.selling_plan_allocations) && variant.selling_plan_allocations[0];
            planId = alloc ? alloc.selling_plan_id : group.selling_plans[0].id;
          }
        }
      } catch (err) { /* no plan resolvable — item adds as one-time */ }
      sellingPlanCache[cacheKey] = planId;
      return planId;
    };

    // ── card builder ─────────────────────────────────────────────────────────
    const grid = root.querySelector('[data-nb-grid]');

    const buildCard = (bundle, index, appItem, total) => {
      // Products flagged inactive by the backend don't belong to the bundle:
      // drop them here so they're excluded from the media, the included list,
      // the price sum and the add-to-cart line items. Only an explicit
      // isActive === false hides an item; a missing flag keeps it.
      //
      // Out-of-stock products are skipped the same way: an item with
      // inventoryQuantity 0 or null is dropped so the bundle shows, prices and
      // adds only the in-stock products (rather than failing the whole add on a
      // sold-out item). A missing/undefined quantity is treated as in stock.
      const items = (Array.isArray(bundle.items) ? bundle.items : [])
        .filter((it) => it && it.isActive !== false)
        .filter((it) => it.inventoryQuantity !== 0 && it.inventoryQuantity !== null);
      // Nothing active/in-stock left → the bundle has no products to show; skip the card.
      if (!items.length) return null;
      const isLast = index === (total - 1);

      // Bundle price = sum of item prices.
      let base = 0, sub = 0, hasVat = false;
      items.forEach((it) => { const p = itemPrices(it); base += p.base; sub += p.sub; hasVat = hasVat || p.hasVat; });

      const card = document.createElement('div');
      card.className = 'new-bundles__card' + (isLast ? ' new-bundles__card--featured' : '');

      const title = document.createElement('h3');
      title.className = 'new-bundles__title';
      // Bundle title comes from the DMO backend (bundle.name), not AEM.
      title.textContent = (typeof bundle.name === 'string' && bundle.name)
        ? bundle.name
        : (bundle.class || ('Bundle ' + (index + 1)));
      card.appendChild(title);

      // Purchase options. subscriptionsEnabled === false on the DMO payload
      // (also forced off for some markets by market-overrides.ts, e.g. TR)
      // drops the subscription option entirely — one-time becomes the only,
      // pre-selected choice.
      const opts = document.createElement('div');
      opts.className = 'new-bundles__options';
      const subsDisabled = window.data && window.data.subscriptionsEnabled === false;
      const subOption = subsDisabled ? '' :
        '<label class="new-bundles__option is-active" data-analytics-id="bundle_suscription_btn">' +
          '<input type="radio" name="nb-opt-' + index + '" value="subscription" checked hidden>' +
          '<span class="new-bundles__option-label">' + L('subscribe-earn', 'subscribe-earn') + '</span>' +
          '<span class="new-bundles__option-price">' + fmt(sub) + ' <s>' + fmt(base) + '</s></span>' +
          '<span class="new-bundles__option-note">' + L('cancel-anytime', 'cancel-anytime') + '</span>' +
        '</label>';
      opts.innerHTML =
        subOption +
        '<label class="new-bundles__option' + (subsDisabled ? ' is-active' : '') + '" data-analytics-id="bundle_one_time_btn">' +
          '<input type="radio" name="nb-opt-' + index + '" value="one-time"' + (subsDisabled ? ' checked' : '') + ' hidden>' +
          '<span class="new-bundles__option-label">' + L('one-time-purchase', 'one-time-purchase') + '</span>' +
          '<span class="new-bundles__option-price">' + fmt(base) + '</span>' +
          '<span class="new-bundles__option-note">' + L('in-stock', 'in-stock') + '</span>' +
        '</label>';
      card.appendChild(opts);
      opts.querySelectorAll('.new-bundles__option').forEach((opt) => {
        opt.addEventListener('click', () => {
          opts.querySelectorAll('.new-bundles__option').forEach((o) => o.classList.remove('is-active'));
          opt.classList.add('is-active');
          const radio = opt.querySelector('input'); if (radio) radio.checked = true;
        });
      });

      // Cart row
      const cartRow = document.createElement('div');
      cartRow.className = 'new-bundles__cart-row';
      const qty = document.createElement('div');
      qty.className = 'new-bundles__qty';
      let qtyOptions = '';
      for (let q = 1; q <= 10; q++) qtyOptions += '<option value="' + q + '">' + q + '</option>';
      qty.innerHTML = '<select aria-label="Quantity" data-analytics-id="bundle_quantity_btn">' + qtyOptions + '</select>';
      const addBtn = document.createElement('button');
      addBtn.type = 'button';
      addBtn.className = 'new-bundles__add';
      addBtn.setAttribute('data-analytics-id', 'bundle_add_to_cart_btn');
      addBtn.textContent = L('add-to-cart', 'add-to-cart');
      cartRow.appendChild(qty); cartRow.appendChild(addBtn);
      card.appendChild(cartRow);

      // Add-to-cart — same pattern as sections/featured-collection.liquid:
      // async/await around window.addToCart with the loading-state toggle. We
      // post all bundle items (each tagged _bundle so the global interceptor
      // skips Beta auto-add) in a single request, and pass appendApp:false so
      // the unified function doesn't attach the app either.
      addBtn.addEventListener('click', async () => {
        if (typeof window.addToCart !== 'function') {
          console.error('[new-bundles] window.addToCart not available');
          return;
        }
        const quantity = parseInt(qty.querySelector('select').value, 10) || 1;
        const isSub = (opts.querySelector('input:checked') || {}).value === 'subscription';
        const bundleName = bundle.name || title.textContent;

        // Candidate line items. Keep each product's sku/name so that if Shopify
        // reports one as sold out we can drop that product and retry with the rest
        // (the DMO inventory flag isn't always in sync with Shopify's live stock).
        let candidates = items
          .filter((it) => it.id)
          .map((it) => ({
            sku: String(it.sku || ''),
            name: String(it.productName || it.title || ''),
            lineItem: {
              id: it.id,
              quantity: quantity,
              properties: { _bundle: bundleName, _bundle_class: bundle.class || '', _product_handle: it.productHandle || '' },
            },
          }));
        if (!candidates.length) return;

        addBtn.classList.add('is-loading');
        addBtn.disabled = true;

        // Subscription adds must carry each product's selling plan, otherwise
        // the items land in the cart as one-time purchases.
        if (isSub) {
          await Promise.all(candidates.map(async (c) => {
            c.lineItem.sellingPlanId = await resolveSellingPlanId(
              c.lineItem.properties._product_handle,
              c.lineItem.id
            );
          }));
        }

        // Shopify rejects the whole /cart/add.js batch on the FIRST sold-out item and
        // names it in the error. Drop that product and retry until the batch succeeds
        // or nothing addable is left.
        let added = false;
        while (candidates.length) {
          try {
            await window.addToCart({
              items: candidates.map((c) => c.lineItem),
              subscription: isSub,
              appendApp: false,
              source: 'new-bundles',
            });
            added = true;
            break;
          } catch (err) {
            const desc = String(
              (err && err.response && (err.response.description || err.response.message)) ||
              (err && err.message) || ''
            );
            const soldOut = (err && err.status === 422) || /sold[\s-]?out|out of stock/i.test(desc);
            if (!soldOut) {
              console.error('[new-bundles] add to cart failed:', err);
              break;
            }
            // Remove the product Shopify named — match by SKU first, then product name.
            const before = candidates.length;
            candidates = candidates.filter((c) => !(c.sku && desc.indexOf(c.sku) !== -1));
            if (candidates.length === before) {
              const idx = candidates.findIndex((c) => c.name && desc.indexOf(c.name) !== -1);
              if (idx !== -1) candidates.splice(idx, 1);
              else candidates.shift(); // couldn't identify the item — drop one to keep progressing
            }
          }
        }

        addBtn.classList.remove('is-loading');
        if (added) {
          addBtn.disabled = false;
        } else {
          // Every product in the bundle is sold out → block the button.
          addBtn.dataset.soldOut = 'true';
          addBtn.disabled = true;
          addBtn.textContent = L('out-of-stock', 'Out of Stock');
        }
      });

      // White panel holding the big image + the included list.
      const panel = document.createElement('div');
      panel.className = 'new-bundles__panel';

      // Media: one slide per bundle product image. Uses a native CSS scroll-snap
      // track (swipe on touch, drag/scroll on desktop) with a custom progress bar
      // below — no Swiper, so there's no width-measurement/init timing to break
      // when the section starts hidden. Single image → plain <img>.
      const media = document.createElement('div');
      media.className = 'new-bundles__media';
      const mediaImgs = items.map(itemImage).filter(Boolean);
      if (mediaImgs.length > 1) {
        const track = document.createElement('div');
        track.className = 'new-bundles__media-track';
        mediaImgs.forEach((src) => {
          const slide = document.createElement('div');
          slide.className = 'new-bundles__media-slide';
          const im = document.createElement('img');
          im.src = src; im.alt = ''; im.loading = 'lazy';
          im.draggable = false; // native image-drag would swallow the drag-to-scroll
          slide.appendChild(im);
          track.appendChild(slide);
        });
        media.appendChild(track);

        // Mouse drag-to-scroll. Touch/trackpad already scroll natively; mice have
        // no horizontal wheel, so map pointer drag onto scrollLeft and snap to the
        // nearest slide on release. Move/up listeners live on window only while a
        // drag is active — releasing anywhere (even outside the track) always ends
        // it, so the slider can never stay "stuck" to the cursor.
        let dragStartX = 0, dragStartScroll = 0, dragging = false, snapTimer = 0;
        const endDrag = () => {
          if (!dragging) return;
          dragging = false;
          window.removeEventListener('pointermove', onDragMove);
          window.removeEventListener('pointerup', endDrag);
          window.removeEventListener('pointercancel', endDrag);
          window.removeEventListener('blur', endDrag);
          // No snap — the track stays exactly where the grab is released.
          track.classList.remove('is-dragging');
        };
        const onDragMove = (e) => {
          // Failsafe: button no longer pressed (pointerup was missed) → stop.
          if ((e.buttons & 1) === 0) { endDrag(); return; }
          track.scrollLeft = dragStartScroll - (e.clientX - dragStartX);
        };
        track.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          clearTimeout(snapTimer); // a previous release must not un-snap mid-drag
          dragging = true;
          dragStartX = e.clientX;
          dragStartScroll = track.scrollLeft;
          track.classList.add('is-dragging');
          e.preventDefault(); // stop text-selection drag from fighting the scroll
          window.addEventListener('pointermove', onDragMove);
          window.addEventListener('pointerup', endDrag);
          window.addEventListener('pointercancel', endDrag);
          window.addEventListener('blur', endDrag);
        });

        const progress = document.createElement('div');
        progress.className = 'new-bundles__media-progress';
        const bar = document.createElement('div');
        bar.className = 'new-bundles__media-progress-bar';
        progress.appendChild(bar);
        media.appendChild(progress);

        // Progress bar = a segment sized 1/N that slides with the scroll ratio.
        const segment = 100 / mediaImgs.length;
        bar.style.width = segment + '%';
        const updateBar = () => {
          const maxScroll = track.scrollWidth - track.clientWidth;
          const ratio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
          bar.style.left = (ratio * (100 - segment)) + '%';
        };
        track.addEventListener('scroll', () => window.requestAnimationFrame(updateBar), { passive: true });
        updateBar();
      } else if (mediaImgs.length === 1) {
        const im = document.createElement('img');
        im.src = mediaImgs[0]; im.alt = ''; im.loading = 'lazy';
        media.appendChild(im);
      }
      panel.appendChild(media);

      const inclTitle = document.createElement('h4');
      inclTitle.className = 'new-bundles__included-title';
      inclTitle.textContent = L('whats-included-title', 'whats-included-title');
      panel.appendChild(inclTitle);

      const incl = document.createElement('div');
      incl.className = 'new-bundles__included';
      const renderItem = (it) => {
        const row = document.createElement('div');
        row.className = 'new-bundles__item';
        const im = document.createElement('img');
        im.className = 'new-bundles__item-img';
        im.src = itemImage(it); im.alt = ''; im.loading = 'lazy';
        const body = document.createElement('div');
        body.className = 'new-bundles__item-body';
        const nm = document.createElement('span');
        nm.className = 'new-bundles__item-name';
        nm.textContent = itemName(it);
        const link = document.createElement('button');
        link.type = 'button';
        link.className = 'new-bundles__item-link';
        link.textContent = L('learn-more', 'learn-more');
        link.addEventListener('click', () => openModal(it));
        body.appendChild(nm); body.appendChild(link);
        row.appendChild(im); row.appendChild(body);
        incl.appendChild(row);
      };
      items.forEach(renderItem);
      panel.appendChild(incl);
      card.appendChild(panel);

      return card;
    };

    // ── apply ────────────────────────────────────────────────────────────────
    const applyIntro = () => {
      const intro = document.querySelector('[data-new-bundles-intro]');
      if (!intro) return;
      const eye = intro.querySelector('[data-nb-intro-eyebrow]');
      const title = intro.querySelector('[data-nb-intro-title]');
      const desc = intro.querySelector('[data-nb-intro-description]');
      if (eye) eye.textContent = (typeof aemHome['personal-path-eye'] === 'string' && aemHome['personal-path-eye']) ? aemHome['personal-path-eye'] : 'personal-path-eye';
      if (title) title.textContent = (typeof aemHome['personal-path-title'] === 'string' && aemHome['personal-path-title']) ? aemHome['personal-path-title'] : 'personal-path-title';
      if (desc && aemHome['personal-path-description']) desc.innerHTML = aemHome['personal-path-description'];
      intro.removeAttribute('data-loading');
    };

    const applyDmo = (data) => {
      const offer = getBundleOffer(data);
      const bundles = offer && offer.data && Array.isArray(offer.data.bundles) ? offer.data.bundles : [];
      if (!bundles.length) return false;
      const appItem = getAppItem(data);
      if (grid) {
        grid.replaceChildren();
        bundles.forEach((b, i) => {
          const card = buildCard(b, i, appItem, bundles.length);
          if (card) grid.appendChild(card);
        });
      }
      root.removeAttribute('data-loading');
      return true;
    };

    // AEM provides the card labels + bundle titles. DMO builds the cards. The
    // two arrive independently: when DMO lands first the cards render with the
    // key fallbacks (e.g. "subscribe-earn") and the DMO class names as titles,
    // so once AEM resolves we re-render the cards to apply the AEM copy.
    const onAem = (aem) => {
      readAem(aem);
      applyIntro();
      if (window.data) applyDmo(window.data);
    };
    if (window.dataAEM) onAem(window.dataAEM);
    else document.addEventListener('aem:data:loaded', (e) => onAem(e.detail || window.dataAEM), { once: true });

    if (typeof window.attachSectionLoading === 'function') {
      window.attachSectionLoading({ root, source: 'dmo', apply: applyDmo, label: 'new-bundles' });
    } else if (window.data) {
      applyDmo(window.data);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-collection-offer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const ATTACH = window.attachSectionLoading;

    // EU browse-only gate quiz link — same URL builder as banner-with-card /
    // featured-collection / main-collection-featured.
    const buildFindYourAgeUrl = () => {
      const baseUrl = (window.externalLinks && window.externalLinks.findYourAgeUrl) || '';
      if (!baseUrl) return '';
      const cleanBase = baseUrl.replace(/\/$/, '');
      const firstSegment = window.location.pathname.split('/').filter(Boolean)[0] || '';
      const localePattern = /^[a-z]{2}(-[a-z]{2})?$/i;
      const locale = localePattern.test(firstSegment) ? firstSegment : '';
      const path = locale ? '/' + locale + '/Intro' : '/Intro';
      // Preserve the current query string AND guarantee the site identifier is
      // present: `site` often lives only in storage (the redirect helper keeps
      // it there), so window.location.search alone drops it. Mirror
      // theme-redirects.js by falling back to shopify_site_identifier.
      const search = new URLSearchParams(window.location.search);
      if (!search.get('site')) {
        const storedSite = (sessionStorage.getItem('shopify_site_identifier') || localStorage.getItem('shopify_site_identifier') || '').trim();
        if (storedSite) search.set('site', storedSite);
      }
      const qs = search.toString();
      return cleanBase + path + (qs ? '?' + qs : '');
    };

    // -----------------------------------------------------------------------
    // Number / price formatting (mirrors snippets/intl-price.liquid).
    // -----------------------------------------------------------------------
    function localeUsesComma(country) {
      // North America keeps the dot + symbol-prefix; everyone else uses a
      // comma + symbol-suffix. This matches what featured-collection emits via
      // the intl-price snippet.
      return country !== 'US' && country !== 'CA' && country !== 'PR';
    }

    function formatMoney(value, symbol, country) {
      if (value == null || value === '' || isNaN(value)) return '';
      const fixed = Number(value).toFixed(2);
      if (localeUsesComma(country)) {
        return fixed.replace('.', ',') + ' ' + (symbol || '');
      }
      return (symbol || '') + fixed;
    }

    function setText(el, text) {
      if (!el) return;
      el.textContent = text || '';
    }

    function setLine(mainEl, compareEl, mainText, compareText) {
      setText(mainEl, mainText);
      if (compareEl) {
        if (compareText) {
          compareEl.textContent = compareText;
          compareEl.removeAttribute('hidden');
        } else {
          compareEl.textContent = '';
          compareEl.setAttribute('hidden', '');
        }
      }
    }

    // -----------------------------------------------------------------------
    // DMO locale translations (custom.translations metafield on each item).
    // -----------------------------------------------------------------------
    function getFullLocale() {
      // In the site-builder preview the document URL is the proxy endpoint;
      // the previewed storefront path lives on window.__p2cPreview.path.
      const pathname = window.__p2cPreview?.path || window.location.pathname;
      const m = pathname.match(/^\/([a-z]{2})-([a-z]{2})(?:\/|$|\?)/i);
      return m ? m[1].toLowerCase() + '-' + m[2].toUpperCase() : 'en-US';
    }
    function parseTranslations(s) {
      if (!s || typeof s !== 'string' || !s.trim()) return null;
      try { return JSON.parse(s); } catch { return null; }
    }
    function tValue(translations, scope, field) {
      if (!translations) return '';
      const loc = getFullLocale();
      const tries = [loc, loc.toLowerCase(), loc.split('-')[0].toLowerCase() + '-' + (loc.split('-')[1] || '').toUpperCase()];
      for (const l of tries) {
        const v = translations[l] && translations[l][scope] && translations[l][scope][field];
        if (typeof v === 'string' && v.trim()) return v;
      }
      return '';
    }

    // -----------------------------------------------------------------------
    // Title parsing.
    // The DMO `title` is structured: `Product Name - Flavor / Size / SKU`.
    // Prefer the per-locale translation (custom.translations), then fall back
    // to whatever's present in the title.
    // -----------------------------------------------------------------------
    function parseTitle(item) {
      const raw = String(item.title || '').trim();
      const tr = parseTranslations(item.translations);
      // Name fallback chain: per-locale translation (lives on the variant's
      // translations blob) → DMO productName → the product-title part of the
      // structured title → the full title as a last resort.
      const translatedName = tValue(tr, 'variant', 'product_name') || tValue(tr, 'product', 'product_name');
      const productName =
        translatedName ||
        (item.productName || '').trim() ||
        (raw.split(' - ')[0] || '').trim() ||
        raw;

      // Strip the leading "Product Name - " when present so we can split the
      // descriptor by " / ".
      let descriptor = raw;
      const dashIdx = raw.indexOf(' - ');
      if (dashIdx !== -1) descriptor = raw.slice(dashIdx + 3);

      const parts = descriptor.split(' / ').map((p) => p.trim()).filter(Boolean);
      // Last segment is the SKU (matches `XXX_FR` style); everything before is
      // flavor + size in declaration order.
      let flavor = '';
      let size = '';
      if (parts.length >= 3) {
        flavor = parts[0];
        size = parts[1];
      } else if (parts.length === 2) {
        flavor = parts[0];
        size = parts[1];
      } else if (parts.length === 1) {
        // Could be either; default to flavor.
        flavor = parts[0];
      }

      // Per-locale flavour / size override the title-parsed values when present.
      flavor = tValue(tr, 'variant', 'flavour') || flavor;
      size = tValue(tr, 'variant', 'variant_size') || size;
      return { name: productName, flavor: flavor, size: size };
    }

    function formatFlavorSize(flavor, size) {
      if (flavor && size) return flavor + ' · ' + size;
      return flavor || size || '';
    }

    // -----------------------------------------------------------------------
    // Pricing — pull from catalogPricesV2[country] when present, otherwise
    // fall back to the flat `price` field.
    // -----------------------------------------------------------------------
    function getPricing(item, country, subscriptionsEnabled) {
      const cp = item && item.catalogPricesV2 ? item.catalogPricesV2[country] : null;

      // US/CA/PR have no VAT — the "Excl. VAT" rows must never show there,
      // whatever the DMO payload carries (PR payloads key catalogPricesV2 by
      // 'PR' and still ship RetailPrice/SubscriptionPrice). Same gate as
      // flagship-product / featured-collection.
      const noVatMarket = country === 'US' || country === 'CA' || country === 'PR';

      let priceIncl = null;
      let priceExcl = null;
      let subIncl = null;
      let subExcl = null;
      let hasCatalog = false;

      if (cp) {
        hasCatalog = true;
        priceIncl = cp.VATPrice != null ? Number(cp.VATPrice) : null;
        subIncl = cp.VATSubscriptionPrice != null ? Number(cp.VATSubscriptionPrice) : null;
        if (noVatMarket) {
          // NA payloads may carry the base price only in RetailPrice /
          // SubscriptionPrice (featured-collection reads those for NA) — use
          // them as the shown price when the VAT fields are absent.
          if (priceIncl == null && cp.RetailPrice != null) priceIncl = Number(cp.RetailPrice);
          if (subIncl == null && cp.SubscriptionPrice != null) subIncl = Number(cp.SubscriptionPrice);
        } else {
          priceExcl = cp.RetailPrice != null ? Number(cp.RetailPrice) : null;
          subExcl = cp.SubscriptionPrice != null ? Number(cp.SubscriptionPrice) : null;
        }
      }

      // catalogPricesV2 missing (US payloads send null) → fall back to the
      // flat item.catalogPrice, then item.price, for the incl line. No
      // excl-VAT row in that case.
      if (!hasCatalog) {
        const flat = item.catalogPrice != null ? item.catalogPrice : item.price;
        if (flat != null) priceIncl = Number(flat);
      }

      // Subscription fallback: 5% off the one-time when the metafield's own
      // subscription numbers are absent.
      if (subscriptionsEnabled !== false) {
        if (subIncl == null && priceIncl != null) subIncl = +(priceIncl * 0.95).toFixed(2);
        if (subExcl == null && priceExcl != null) subExcl = +(priceExcl * 0.95).toFixed(2);
      }

      return { priceIncl, priceExcl, subIncl, subExcl, hasCatalog };
    }

    // -----------------------------------------------------------------------
    // Selling plan resolution.
    // Subscription adds need a Shopify selling_plan id, which the DMO payload
    // doesn't carry. Fetch the product JSON once per handle+variant (cached)
    // and take the first plan allocated to the card's variant — the same plan
    // featured-collection picks server-side via selling_plan_groups.first.
    // -----------------------------------------------------------------------
    const sellingPlanCache = {};
    function fetchSellingPlanId(handle, variantId, localePrefix) {
      if (!handle || !variantId) return Promise.resolve(null);
      const key = handle + ':' + variantId;
      if (!sellingPlanCache[key]) {
        sellingPlanCache[key] = fetch('/' + localePrefix + 'products/' + handle + '.js')
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (product) {
            if (!product || !Array.isArray(product.variants)) return null;
            const variant = product.variants.find(function (v) {
              return String(v.id) === String(variantId);
            });
            const alloc =
              variant && Array.isArray(variant.selling_plan_allocations)
                ? variant.selling_plan_allocations[0]
                : null;
            return alloc ? alloc.selling_plan_id : null;
          })
          .catch(function () { return null; });
      }
      return sellingPlanCache[key];
    }

    // -----------------------------------------------------------------------
    // Card rendering.
    // -----------------------------------------------------------------------
    function buildCard(template, item, ctx) {
      const node = template.content.firstElementChild.cloneNode(true);

      const { name, flavor, size } = parseTitle(item);
      const flavorSize = formatFlavorSize(flavor, size);

      const titleEl = node.querySelector('[data-new-collection-offer-name]');
      const subtitleEl = node.querySelector('[data-new-collection-offer-flavor-size]');
      const imageEl = node.querySelector('[data-new-collection-offer-image]');
      const linkEl = node.querySelector('[data-new-collection-offer-link]');
      const idInput = node.querySelector('[data-new-collection-offer-id]');
      const formEl = node.querySelector('[data-new-collection-offer-form]');
      const purchaseRow = node.querySelector('[data-new-collection-offer-purchase-row]');
      const purchaseSelect = node.querySelector('[data-new-collection-offer-purchase]');
      const addBtn = node.querySelector('[data-new-collection-offer-add]');
      const inclEl = node.querySelector('[data-new-collection-offer-price-incl]');
      const inclCompareEl = node.querySelector('[data-new-collection-offer-price-incl-compare]');
      const exclRow = node.querySelector('[data-new-collection-offer-excl-row]');
      const exclEl = node.querySelector('[data-new-collection-offer-price-excl]');
      const exclCompareEl = node.querySelector('[data-new-collection-offer-price-excl-compare]');

      setText(titleEl, name || item.title || '');
      setText(subtitleEl, flavorSize);
      if (!flavorSize && subtitleEl) subtitleEl.setAttribute('hidden', '');

      // Image: prefer the "ProductImage" additional image; fall back to the
      // first imageUrls entry.
      const imageUrl =
        (item.additionalImages && item.additionalImages.ProductImage) ||
        (Array.isArray(item.imageUrls) ? item.imageUrls[0] : '') ||
        '';
      if (imageEl && imageUrl) {
        imageEl.setAttribute('src', imageUrl);
        imageEl.setAttribute('alt', name || item.title || '');
        imageEl.removeAttribute('hidden');
      }

      // Product link — Shopify handle plus the URL's locale prefix. While the
      // EU browse-only gate is active the link points to the assessment quiz.
      const handle = item.productHandle ? '/' + ctx.localePrefix + 'products/' + item.productHandle : '#';
      if (linkEl) {
        if (ctx.gated) {
          if (ctx.quizUrl) linkEl.setAttribute('href', ctx.quizUrl);
          else linkEl.removeAttribute('href');
        } else {
          linkEl.setAttribute('href', handle);
        }
      }

      // EU browse-only gate: hide pricing and add-to-cart while gated.
      if (ctx.gated) {
        const priceBlock = node.querySelector('.featured-collection__price-block');
        if (priceBlock) {
          priceBlock.setAttribute('data-fc-gated', '');
          priceBlock.setAttribute('hidden', '');
        }
        if (formEl) {
          formEl.setAttribute('data-fc-gated', '');
          formEl.setAttribute('hidden', '');
        }
      }

      if (idInput) idInput.value = String(item.id || '');

      // Subscription toggle shows whenever a subscription price exists — from
      // catalogPricesV2 when present, otherwise the 5%-off fallback computed
      // from the flat price. (US payloads have catalogPricesV2: null, so
      // requiring hasCatalog here kept the toggle permanently hidden.)
      const pricing = getPricing(item, ctx.country, ctx.subscriptionsEnabled);
      const showSubscription =
        ctx.subscriptionsEnabled !== false &&
        (pricing.subIncl != null || pricing.subExcl != null);

      if (showSubscription && purchaseRow) {
        purchaseRow.removeAttribute('hidden');
      }

      // Default to Subscribe & Save in US/GB, but only when this card actually
      // offers a subscription (otherwise leave it on one-time).
      if (showSubscription && purchaseSelect && (ctx.country === 'US' || ctx.country === 'GB')) {
        purchaseSelect.value = 'subscription';
      }

      function render() {
        const isSub = purchaseSelect && purchaseSelect.value === 'subscription';
        const inclMain = isSub ? pricing.subIncl : pricing.priceIncl;
        const inclCompare = isSub ? pricing.priceIncl : null;
        const exclMain = isSub ? pricing.subExcl : pricing.priceExcl;
        const exclCompare = isSub ? pricing.priceExcl : null;

        setLine(
          inclEl,
          inclCompareEl,
          formatMoney(inclMain, ctx.currencySymbol, ctx.country),
          inclCompare != null ? formatMoney(inclCompare, ctx.currencySymbol, ctx.country) : null
        );

        if (exclMain != null) {
          exclRow.removeAttribute('hidden');
          const exclMainText =
            formatMoney(exclMain, ctx.currencySymbol, ctx.country) + ' ' + ctx.htLabel;
          const exclCompareText =
            exclCompare != null
              ? formatMoney(exclCompare, ctx.currencySymbol, ctx.country) + ' ' + ctx.htLabel
              : null;
          setLine(exclEl, exclCompareEl, exclMainText, exclCompareText);
        } else {
          exclRow.setAttribute('hidden', '');
          setLine(exclEl, exclCompareEl, '', null);
        }

        if (inclEl) inclEl.classList.toggle('is-subscription', !!isSub);
      }

      if (purchaseSelect) {
        purchaseSelect.addEventListener('change', render);
      }
      render();

      // Add to cart — defers to the shared window.addToCart helper. The
      // helper only attaches a selling plan when we pass sellingPlanId, so
      // subscription adds first resolve the variant's plan from the Shopify
      // product JSON. No plan on the variant → falls back to a one-time add,
      // same semantics as featured-collection.
      if (formEl) {
        formEl.addEventListener('submit', function (event) {
          event.preventDefault();
          if (!item.id) return;
          const isSub = purchaseSelect && purchaseSelect.value === 'subscription';
          if (addBtn) addBtn.classList.add('is-loading');
          const done = function () {
            if (addBtn) addBtn.classList.remove('is-loading');
          };
          const planPromise = isSub
            ? fetchSellingPlanId(item.productHandle, item.id, ctx.localePrefix)
            : Promise.resolve(null);
          planPromise.then(function (sellingPlanId) {
            const subscription = !!isSub && !!sellingPlanId;
            if (typeof window.addToCart !== 'function') {
              console.error('[new-collection-offer] window.addToCart not available');
              done();
              return;
            }
            const ret = window.addToCart({
              items: [{ id: item.id, quantity: 1, sellingPlanId: subscription ? sellingPlanId : null }],
              source: 'new-collection-offer',
              subscription: subscription
            });
            if (ret && typeof ret.then === 'function') ret.then(done, done);
            else done();
          });
        });
      }

      return node;
    }

    // -----------------------------------------------------------------------
    // AEM intro (same keys featured-collection / flagship-product use).
    // -----------------------------------------------------------------------
    function applyIntro(root) {
      const aem = (window.dataAEM && window.dataAEM['shopify/shopify-homepage']) || null;
      if (!aem) return false;
      const eyebrow = root.querySelector('[data-new-collection-offer-eyebrow]');
      const title = root.querySelector('[data-new-collection-offer-title]');
      const description = root.querySelector('[data-new-collection-offer-description]');
      setText(eyebrow, aem['personal-path-eye'] || 'personal-path-eye');
      setText(title, aem['personal-path-title'] || 'personal-path-title');
      if (description) description.innerHTML = aem['personal-path-description'] || '';
      return true;
    }

    // -----------------------------------------------------------------------
    // AEM offer labels — purchase-type options + add-to-cart button text come
    // from shopify/offers so they localize (same keys featured-collection and
    // main-collection-featured use). Cards are cloned after DMO data lands, so
    // this runs at the end of renderCards and again on aem:data:loaded.
    // -----------------------------------------------------------------------
    function applyOfferLabels(root) {
      const node = window.dataAEM && window.dataAEM['shopify/offers'];
      if (!node) return;
      const setAll = (sel, val) => {
        if (typeof val !== 'string' || !val) return;
        root.querySelectorAll(sel).forEach((el) => { el.textContent = val; });
      };
      setAll('[data-fc-addcart-label]', node['add-to-cart']);
      setAll('[data-fc-onetime-label]', node['one-time-purchase']);
      setAll('[data-fc-subscribe-label]', node['subscribe-earn']);
    }

    // -----------------------------------------------------------------------
    // DMO COLLECTIONS lookup.
    // -----------------------------------------------------------------------
    function getCollectionsItems(data) {
      const offers = data && data.theme && data.theme.productOffer && data.theme.productOffer.offers;
      if (!Array.isArray(offers)) return [];
      const found = offers.find((o) => o && o.type === 'COLLECTIONS');
      if (!found || !found.data || !Array.isArray(found.data.items)) return [];
      return found.data.items;
    }

    function renderCards(root) {
      const wrapper = root.querySelector('[data-new-collection-offer-cards]');
      const template = root.querySelector('[data-new-collection-offer-card-template]');
      if (!wrapper || !template) return false;

      const data = window.data || {};
      const items = getCollectionsItems(data);
      if (!items.length) return false;

      // Prefer the DMO profile's target country over the URL locale — PR sites
      // live under the en-us/es-us locales, so the URL says US while the
      // catalog prices are keyed PR. Same resolution new-bundles and
      // flagship-product use.
      const country = (
        (data.profile && data.profile.targetCountry) ||
        root.getAttribute('data-locale-country') ||
        ''
      ).toUpperCase();
      const ctx = {
        country: country,
        currencySymbol: root.getAttribute('data-currency-symbol') || '',
        htLabel: root.getAttribute('data-ht-label') || 'Excl. VAT',
        subscriptionsEnabled: data.subscriptionsEnabled,
        localePrefix: (function () {
          const m = window.location.pathname.match(/^\/([a-z]{2}-[a-z]{2})(?=\/|$)/i);
          return m ? m[1] + '/' : '';
        })(),
        // Sites with pro2colDownloadDisabled === true never offer the quiz, so
        // the gate has no way to unlock and must not apply — those sites
        // browse and buy like an ungated one. Absent flag means enabled (see
        // DMO/assessment-availability.ts). This runs off the DMO payload, so
        // the flag is already present here.
        gated:
          root.hasAttribute('data-browse-only') &&
          data.pro2colDownloadDisabled !== true &&
          localStorage.getItem('pro2col_assessment_completed') !== 'true',
        quizUrl: buildFindYourAgeUrl()
      };

      // Replace skeletons with real cards.
      wrapper.innerHTML = '';
      items.forEach((item) => {
        if (!item) return;
        const node = buildCard(template, item, ctx);
        wrapper.appendChild(node);
      });

      // Tell the carousel its slides have changed.
      const carousel = root.querySelector('[data-carousel]');
      if (carousel && carousel.swiper && typeof carousel.swiper.update === 'function') {
        carousel.swiper.update();
      }

      // Desktop shows every card at once when the item count fits within
      // slides-to-show, so the nav (arrows + scrollbar) is pointless there.
      // Mobile/tablet show fewer slides and keep it.
      const slidesToShow = parseFloat((carousel && carousel.getAttribute('data-slides-to-show')) || '5') || 5;
      root.classList.toggle('new-collection-offer--nav-hidden-desktop', items.length <= slidesToShow);

      // Localize the purchase-type options + add-to-cart button from AEM.
      applyOfferLabels(root);

      return true;
    }

    // -----------------------------------------------------------------------
    // Bootstrap.
    // -----------------------------------------------------------------------
    function init(root) {
      // AEM intro skeleton — uses the shared helper so timing/timeout match
      // the rest of the theme.
      if (typeof ATTACH === 'function') {
        ATTACH({
          root: root.querySelector('[data-new-collection-offer-intro]'),
          source: 'aem',
          apply: () => applyIntro(root),
          timeoutMs: 60000
        });
        ATTACH({
          root: root.querySelector('[data-new-collection-offer-cards]'),
          source: 'dmo',
          apply: () => renderCards(root),
          timeoutMs: 8000
        });
      } else {
        // Fallback wiring: just listen for both events. They're dispatched on
        // document and don't bubble, so window listeners never fire.
        applyIntro(root);
        renderCards(root);
        document.addEventListener('aem:data:loaded', () => applyIntro(root));
        document.addEventListener('dmo:data:loaded', () => renderCards(root));
      }

      // Re-localize the card labels if AEM resolves after the cards mount.
      document.addEventListener('aem:data:loaded', () => applyOfferLabels(root));
    }

    function boot() {
      const roots = document.querySelectorAll('[data-new-collection-offer]');
      roots.forEach(init);
      // Re-render the cards (which recompute the gated/add-to-cart state) when:
      // - the assessment completes on this same page load (profile-metrics.ts
      //   fires this the moment it sets the flag on /pages/offers),
      // - the page is restored from bfcache (Back from the assessment),
      // - the assessment completes in another tab,
      // so the add-to-cart unlock shows right away without a manual reload.
      document.addEventListener('pro2col:assessment-completed', () => {
        if (window.data) roots.forEach((root) => renderCards(root));
      });
      window.addEventListener('pageshow', (event) => {
        if (event.persisted && window.data) roots.forEach((root) => renderCards(root));
      });
      window.addEventListener('storage', (event) => {
        if (event.key === 'pro2col_assessment_completed' && window.data) roots.forEach((root) => renderCards(root));
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (root.dataset.carouselBound === 'true') return;
      root.dataset.carouselBound = 'true';

      let track = root.querySelector('[data-carousel-track]');
      let slides = root.querySelectorAll('.new-results__slide');
      let prev = root.querySelector('[data-carousel-prev]');
      let next = root.querySelector('[data-carousel-next]');
      let segs = root.querySelectorAll('[data-progress-seg]');
      if (!track || slides.length === 0) return;

      let index = 0;
      let count = slides.length;

      function render() {
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
        for (let i = 0; i < segs.length; i++) {
          segs[i].classList.toggle('is-active', i === index);
        }
      }

      function go(delta) {
        index = (index + delta + count) % count;
        render();
      }

      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });

      // Allow clicking a progress segment to jump to that slide
      for (let i = 0; i < segs.length; i++) {
        segs[i].addEventListener('click', function () { index = i; render(); });
      }

      render();
    }

    // "Get Started" scrolls the page down by the section container's height.
    function initScroll(section) {
      let btn = section.querySelector('[data-new-results-scroll]');
      if (!btn || btn.dataset.scrollBound === 'true') return;
      btn.dataset.scrollBound = 'true';

      btn.addEventListener('click', function () {
        let height = section.getBoundingClientRect().height;
        window.scrollBy({ top: height, left: 0, behavior: 'smooth' });
      });
    }

    // Pull the result values: biologicalAge -> Pro2Age number, pro2Score -> Pro2Score number.
    // URL params win; otherwise fall back to the persisted profile-metrics state.
    function clean(v) {
      return (v || '').replace(/,$/, '').trim();
    }

    function formatDecimal(value) {
      let n = parseFloat(value);
      if (isNaN(n)) return null;
      return String(parseFloat(n.toFixed(2)));
    }

    function getResultData() {
      let p = new URLSearchParams(window.location.search);
      let pro2Score = clean(p.get('pro2Score'));
      let biologicalAge = clean(p.get('biologicalAge'));
      if (pro2Score || biologicalAge) {
        return { pro2Score: pro2Score, biologicalAge: biologicalAge };
      }
      try {
        let stored = JSON.parse(localStorage.getItem('profile-metrics-state') || 'null');
        if (stored) {
          return { pro2Score: clean(stored.pro2Score), biologicalAge: clean(stored.biologicalAge) };
        }
      } catch (e) {}
      return null;
    }

    // Map a pro2Score (0-100) to one of the five status buckets.
    function statusKey(score) {
      let n = parseFloat(score);
      if (isNaN(n)) return null;
      if (n < 20) return 'bad';
      if (n < 40) return 'poor';
      if (n < 60) return 'fair';
      if (n < 80) return 'good';
      return 'excellent';
    }

    // Returns 'faster' | 'same' | 'slower' from biologicalAge vs actual age (URL ?age=).
    function ageCompareKey(bio, age) {
      let b = parseFloat(bio);
      let a = parseFloat(age);
      if (isNaN(b) || isNaN(a)) return null;
      let diff = Math.round((b - a) * 10) / 10;
      if (diff > 0) return { key: 'faster', diff: Math.abs(diff) };
      if (diff < 0) return { key: 'slower', diff: Math.abs(diff) };
      return { key: 'same', diff: 0 };
    }

    function actualAge() {
      let p = new URLSearchParams(window.location.search);
      let urlAge = clean(p.get('age'));
      if (urlAge) return urlAge;
      try {
        let stored = JSON.parse(localStorage.getItem('profile-metrics-state') || 'null');
        if (stored && stored.age) return clean(stored.age);
      } catch (e) {}
      return null;
    }

    function populateValues(section) {
      let data = getResultData();
      if (!data) return;

      let age = formatDecimal(data.biologicalAge);
      let score = formatDecimal(data.pro2Score);

      let ageEl = section.querySelector('[data-result="pro2age"] [data-result-value]');
      let scoreEl = section.querySelector('[data-result="pro2score"] [data-result-value]');

      if (ageEl && age !== null) ageEl.textContent = age;
      if (scoreEl && score !== null) scoreEl.textContent = score;
    }

    // Apply all AEM copy + compute score status + age-comparison line. Safe to
    // call before AEM lands — anything missing is left alone (skeleton stays
    // visible on those elements until the event fires).
    function applyAem(section, aem) {
      let node = aem && aem['shopify/assessment-results'];
      if (!node) return false;

      let set = function (sel, value) {
        if (typeof value !== 'string' || !value) return;
        let el = section.querySelector(sel);
        if (el) el.textContent = value;
      };
      set('[data-aem-intro-title]', node['title'] || 'title');
      set('[data-aem-button-label]', node['button-label'] || 'button-label');
      set('[data-aem-pro2age-title]', node['projected-pro2age'] || 'projected-pro2age');
      set('[data-aem-pro2score-title]', node['pro2score-title'] || 'pro2score-title');
      set('[data-aem-status-label]', node['status-label'] || 'status-label');

      // Age comparison line (faster / same / slower).
      let data = getResultData();
      let cmp = data ? ageCompareKey(data.biologicalAge, actualAge()) : null;
      let ageDescEl = section.querySelector('[data-aem-pro2age-desc]');
      if (ageDescEl && cmp) {
        let line1 = node['age-' + cmp.key + '-line1'] || '';
        let line2 = node['age-' + cmp.key + '-line2'] || '';
        let years = String(cmp.diff);
        let text = (line1 + ' ' + line2).replace(/\{\s*years_diff\s*\}/g, years).trim();
        if (text) ageDescEl.textContent = text;
      }

      // Score status word + motivational copy.
      let key = data ? statusKey(data.pro2Score) : null;
      if (key) {
        let word = node['status-' + key];
        let statusEl = section.querySelector('[data-result-status]');
        if (statusEl) {
          statusEl.textContent = (typeof word === 'string' && word) ? word : 'status-' + key;
          statusEl.className = 'new-results__status-word new-results__status-word--' + key;
        }
        let motiv = node['motivational-' + key];
        let motivEl = section.querySelector('[data-result-motivational]');
        if (motivEl) motivEl.textContent = (typeof motiv === 'string' && motiv) ? motiv : 'motivational-' + key;
      }

      // Background video URL (AEM wins; falls back to a hardcoded DAM asset that
      // exists for every locale when AEM provides no value).
      // AEM returns a relative DAM path (e.g. /content/dam/...). Resolve it against
      // the AEM publishing host, otherwise the browser requests it from the Shopify
      // domain and 404s. Absolute / protocol-relative / data URLs pass through.
      let FALLBACK_VIDEO_URL = '/content/dam/pro2col/assets/marketing-banners/hiking-in-woods.mp4';
      let rawUrl = ((node['video-url'] || '').trim()) || FALLBACK_VIDEO_URL;
      let url = '';
      if (rawUrl) {
        if (/^(https?:)?\/\//i.test(rawUrl) || rawUrl.indexOf('data:') === 0) {
          url = rawUrl;
        } else {
          let base = (window.AEM_PUBLISHING_URL || '').replace(/\/$/, '');
          url = base + (rawUrl.charAt(0) === '/' ? rawUrl : '/' + rawUrl);
        }
      }
      if (url) {
        let media = section.querySelector('.new-results__bg-video');
        let card = section.querySelector('.new-results__card');

        if (media && media.tagName === 'VIDEO') {
          // A <video> is already present (theme `background_video` is set) —
          // just swap its <source> to the AEM asset.
          let src = media.querySelector('source') || media.appendChild(document.createElement('source'));
          src.type = 'video/mp4';
          src.src = url;
          media.load();
          media.play().catch(function () {});
        } else if (card) {
          // No <video> exists yet — the common case, since the video is meant to
          // come from AEM and `background_video` is left blank (page.offer-2.json).
          // The element may be absent entirely, or be the poster <img>. Build the
          // <video> from the AEM url and drop it where the background media goes.
          let video = document.createElement('video');
          video.className = 'new-results__bg-video';
          video.autoplay = true;
          video.loop = true;
          video.muted = true;        // required for autoplay to be allowed
          video.playsInline = true;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          // Reuse the poster <img> as the video poster, if one was rendered.
          if (media && media.tagName === 'IMG' && media.getAttribute('src')) {
            video.setAttribute('poster', media.getAttribute('src'));
          }
          let src = document.createElement('source');
          src.type = 'video/mp4';
          src.src = url;
          video.appendChild(src);

          if (media) {
            card.replaceChild(video, media); // swap out the poster <img>
          } else {
            card.insertBefore(video, card.firstChild); // bg media is the first child
          }
          video.load();
          video.play().catch(function () {});
        }
      }

      section.removeAttribute('data-loading');
      return true;
    }

    // Show the results UI when this visit arrived with fresh assessment params
    // (or the shared flag profile-metrics.ts sets before it strips the URL), and
    // KEEP it shown for the rest of this browsing session so a plain refresh of
    // the offers page doesn't hide it. The params get stripped off the URL on the
    // first load and window.__p2cFreshAssessment is wiped on reload, so without a
    // session marker a refresh would read as a cold arrival and hide everything
    // (the data itself stays in localStorage). sessionStorage is intentionally
    // session-scoped: a new visit / cold arrival in a fresh tab still sees nothing,
    // matching the "returning users see nothing" behaviour.
    // Always shown in the theme editor so the section stays editable.
    var FRESH_SESSION_KEY = 'p2c-fresh-assessment-session';
    function hasFreshAssessment() {
      if (window.Shopify && window.Shopify.designMode) return true;

      let p = new URLSearchParams(window.location.search);
      let freshThisLoad = window.__p2cFreshAssessment === true
        || !!(clean(p.get('pro2Score')) || clean(p.get('biologicalAge')) || clean(p.get('age')));

      try {
        if (freshThisLoad) {
          sessionStorage.setItem(FRESH_SESSION_KEY, '1');
        } else if (sessionStorage.getItem(FRESH_SESSION_KEY) === '1') {
          return true;
        }
      } catch (e) { /* privacy mode / quota — fall back to the per-load signals */ }

      return freshThisLoad;
    }

    function initSection(section) {
      if (!hasFreshAssessment()) {
        section.style.display = 'none';
        return;
      }
      populateValues(section);
      let carousel = section.querySelector('[data-new-results-carousel]');
      if (carousel) initCarousel(carousel);
      initScroll(section);

      if (window.dataAEM) {
        applyAem(section, window.dataAEM);
      } else {
        document.addEventListener('aem:data:loaded', function (e) {
          applyAem(section, (e && e.detail) || window.dataAEM);
        }, { once: true });
      }
    }

    function init() {
      document.querySelectorAll('[data-section-type="new-results"]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      let section = event.target.querySelector('[data-section-type="new-results"]')
        || (event.target.matches && event.target.matches('[data-section-type="new-results"]') ? event.target : null);
      if (section) initSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["privacy-commitments"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-privacy-commitments]');
    if (!root) return;

    const apply = (aem) => {
      const node = aem && aem['shopify/privacy'];
      if (!node) return false;

      let hasContent = false;

      const titleEl = root.querySelector('[data-privacy-commitments-title]');
      const descEl  = root.querySelector('[data-privacy-commitments-description]');

      if (titleEl) {
        titleEl.textContent = (typeof node.title === 'string' && node.title) ? node.title : 'title';
        hasContent = true;
      }
      if (descEl && typeof node.description === 'string' && node.description) {
        descEl.innerHTML = node.description;
        hasContent = true;
      }

      if (Array.isArray(node.items) && node.items.length) {
        const list = root.querySelector('[data-privacy-commitments-items]');
        const template = list && list.querySelector('[data-privacy-commitments-item]');
        if (list && template) {
          const fragment = document.createDocumentFragment();
          node.items.forEach((item) => {
            if (!item || typeof item !== 'object') return;
            const clone = template.cloneNode(true);
            const itemTitle = clone.querySelector('[data-privacy-commitments-item-title]');
            const itemDesc  = clone.querySelector('[data-privacy-commitments-item-description]');
            if (itemTitle && typeof item.title === 'string') itemTitle.textContent = item.title;
            if (itemDesc && typeof item.description === 'string') itemDesc.innerHTML = item.description;
            fragment.appendChild(clone);
          });
          list.replaceChildren(fragment);
          hasContent = true;
        }
      }

      return hasContent;
    };

    if (typeof window.attachSectionLoading === 'function') {
      window.attachSectionLoading({ root, source: 'aem', apply, label: 'privacy-commitments', timeoutMs: 60000 });
    } else if (window.dataAEM) {
      apply(window.dataAEM);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-panels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-product-panels]');
    if (!root) return;

    const tabsEl = root.querySelector('[data-product-panels-tabs]');
    const titleEl = root.querySelector('[data-product-panels-title]');
    const panels = Array.from(root.querySelectorAll('[data-product-panels-panel]'));

    const setActive = (index) => {
      panels.forEach((panel, i) => {
        panel.classList.toggle('product-panels__panel--active', i === index);
      });
      if (tabsEl) {
        tabsEl.querySelectorAll('[data-product-panels-tab]').forEach((btn) => {
          const idx = parseInt(btn.getAttribute('data-product-panels-tab') || '0', 10);
          const isActive = idx === index;
          btn.classList.toggle('product-panels__tab--active', isActive);
          btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }
    };

    if (tabsEl) {
      tabsEl.addEventListener('click', (e) => {
        const target = e.target.closest('[data-product-panels-tab]');
        if (!target) return;
        const idx = parseInt(target.getAttribute('data-product-panels-tab') || '0', 10);
        setActive(idx);
      });
    }

    const ctaButtons = [];

    // Classify a core panel into one of three types from its handle/title.
    // "female" is tested before "male", and "women" before "men", because each
    // contains the other's substring (female contains male; women contains men).
    // Prod handles are female-hormone-panel / male-hormone-panel; AEM/product
    // titles are Women's / Men's. Used for AEM panel matching and the
    // `_blood-core-type` line-item property set on add.
    const classifyType = (value) => {
      const v = (value || '').toLowerCase();
      if (v.indexOf('female') !== -1) return 'women';
      if (v.indexOf('male') !== -1) return 'men';
      if (v.indexOf('women') !== -1) return 'women';
      if (v.indexOf('men') !== -1) return 'men';
      return 'biomarker';
    };

    // Core panel cart rule: the Core Biomarker kit may be combined with ONE
    // hormone panel (Core + Men's or Core + Women's); the two hormone panels are
    // mutually exclusive with each other; every core line is quantity 1.
    // So: a biomarker line in the cart disables the biomarker button, and a
    // hormone line (men or women) in the cart disables both hormone buttons.
    // Group by the `_blood-core-type` property written on add (falling back to
    // the line's handle/title for older lines).
    const groupOf = (type) => (type === 'men' || type === 'women') ? 'hormone' : 'biomarker';
    const syncCoreButtons = async () => {
      const inCart = { biomarker: false, hormone: false };
      try {
        const res = await fetch('/cart.js');
        if (res.ok) {
          const cart = await res.json();
          (Array.isArray(cart.items) ? cart.items : []).forEach((item) => {
            const props = item.properties || {};
            const v = props['_blood-core'];
            const isCore = v === true || (typeof v === 'string' && v.toLowerCase() === 'true');
            if (!isCore) return;
            const rawType = typeof props['_blood-core-type'] === 'string' ? props['_blood-core-type'].toLowerCase() : '';
            const type = (rawType === 'men' || rawType === 'women' || rawType === 'biomarker')
              ? rawType
              : classifyType((item.handle || '') + ' ' + (item.product_title || '') + ' ' + (item.title || ''));
            inCart[groupOf(type)] = true;
          });
        }
      } catch (err) {
        return; // network hiccup — leave buttons as-is
      }
      ctaButtons.forEach((entry) => {
        const btn = entry.btn;
        if (btn.classList.contains('is-loading')) return;
        const disabled = inCart[groupOf(entry.type)];
        btn.disabled = disabled;
        btn.classList.toggle('product-panels__cta--in-cart', disabled);
      });
    };

    // Approach B (PR support): each panel serialized EVERY active variant. Pick the
    // one for the user's real country — window.data.profile.targetCountry (e.g. 'PR'),
    // which the es-us URL can't carry — using the URL locale only as a fallback before
    // DMO data loads. Match by the '_<country>' suffix in the variant title, mirroring
    // the server-side Liquid filter. Updates the variant id, sku and both price labels.
    const resolveCountry = () => {
      const tc = window.data && window.data.profile && window.data.profile.targetCountry;
      if (tc) return String(tc).toUpperCase();
      const m = window.location.pathname.match(/^\/[a-z]{2}-([a-z]{2})(?=\/|$)/i);
      return m ? m[1].toUpperCase() : 'US';
    };
    const applyCountryToPanel = (panel) => {
      const dataEl = panel.querySelector('[data-panel-variants]');
      if (!dataEl) return;
      let all = [];
      try { all = JSON.parse(dataEl.textContent || '[]'); } catch (_e) { return; }
      if (!Array.isArray(all) || all.length === 0) return;
      const suffix = '_' + resolveCountry();
      const matched = all.filter((v) => (v.title || '').toUpperCase().indexOf(suffix) !== -1);
      const v = matched[0] || all[0];
      if (!v) return;
      panel.setAttribute('data-panel-variant-id', v.id);
      const skuEl = panel.querySelector('[data-panel-sku]');
      if (skuEl && v.sku != null) skuEl.textContent = v.sku;
      if (v.price) {
        const priceEl = panel.querySelector('[data-panel-price]');
        if (priceEl) priceEl.textContent = v.price;
        const ctaPriceEl = panel.querySelector('[data-panel-cta-price]');
        if (ctaPriceEl) ctaPriceEl.textContent = v.price;
      }
    };

    panels.forEach((panel) => {
      const btn = panel.querySelector('[data-panel-cta]');
      if (!btn) return;
      applyCountryToPanel(panel);
      if (!window.data) {
        document.addEventListener('dmo:data:loaded', () => applyCountryToPanel(panel), { once: true });
      }
      if (!panel.getAttribute('data-panel-variant-id')) return;
      const type = classifyType(panel.getAttribute('data-product-handle'));
      ctaButtons.push({ btn: btn, type: type });

      btn.addEventListener('click', async () => {
        if (typeof window.addToCart !== 'function') {
          console.error('[product-panels] window.addToCart not available');
          return;
        }
        // Read the variant id at click time so the targetCountry swap (which may
        // land after this handler was attached, on dmo:data:loaded) is respected.
        const variantId = panel.getAttribute('data-panel-variant-id');
        if (!variantId) return;
        btn.disabled = true;
        btn.classList.add('is-loading');
        try {
          await window.addToCart({
            items: [{ id: variantId, quantity: 1, properties: { '_bloodwork': 'true', '_blood-core': 'true', '_blood-core-type': type } }],
            source: 'product-panels',
          });
        } catch (err) {
          console.error('[product-panels] add to cart failed:', err);
        } finally {
          btn.classList.remove('is-loading');
          // Reflect cart state: re-sync every CTA against the new cart contents;
          // a failed add leaves them as they were.
          syncCoreButtons();
        }
      });
    });

    // Reflect cart on load (persists the disabled state across reloads) and on
    // any cart mutation (removing a core item in the drawer re-enables its group).
    syncCoreButtons();
    document.addEventListener('cart:update', () => syncCoreButtons());

    const normalizePanel = (panel) => {
      const out = {};
      if (!panel || typeof panel !== 'object') return out;
      Object.keys(panel).forEach((k) => {
        out[k.replace(/^panel-\d+-/, '')] = panel[k];
      });
      return out;
    };

    const htmlToText = (html) => {
      if (typeof html !== 'string') return '';
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      return (tmp.textContent || '').trim();
    };

    const itemLabels = (panel) => {
      const labels = [];
      let i = 0;
      while (typeof panel['item-' + i + '-label'] === 'string') {
        if (panel['item-' + i + '-label']) labels.push(panel['item-' + i + '-label']);
        i += 1;
      }
      return labels;
    };

    const matchPanel = (handle, list, index) => {
      const title = (p) => String(p.title || '').toLowerCase();
      const type = classifyType(handle);
      if (type === 'women') {
        return list.find((p) => title(p).indexOf('women') !== -1) || list[index];
      }
      if (type === 'men') {
        return list.find((p) => title(p).indexOf('men') !== -1 && title(p).indexOf('women') === -1) || list[index];
      }
      return list.find((p) => title(p).indexOf('men') === -1) || list[index];
    };

    const apply = (aem) => {
      const node = aem && aem['shopify/bloodwork'];
      if (!node || !Array.isArray(node.panels)) return false;

      let hasContent = false;
      const panelData = node.panels.map(normalizePanel);

      if (titleEl) {
        titleEl.textContent = (typeof node.title === 'string' && node.title) ? node.title : 'title';
        hasContent = true;
      }

      panels.forEach((panelEl, index) => {
        const handle = panelEl.getAttribute('data-product-handle');
        const data = matchPanel(handle, panelData, index);
        if (!data) return;

        const descEl = panelEl.querySelector('[data-panel-description]');
        if (descEl && typeof data.description === 'string' && data.description) {
          descEl.textContent = htmlToText(data.description);
          hasContent = true;
        }

        const ctaActionEl = panelEl.querySelector('[data-panel-cta-action]');
        if (ctaActionEl && typeof data.action === 'string' && data.action) {
          ctaActionEl.textContent = data.action;
          hasContent = true;
        }

        if (typeof data.title === 'string' && data.title) {
          const panelTitleEl = panelEl.querySelector('[data-panel-title]');
          if (panelTitleEl) panelTitleEl.textContent = data.title;

          const nameEl = panelEl.querySelector('.product-panels__panel-name');
          if (nameEl) nameEl.textContent = data.title;

          const tabEl = tabsEl && tabsEl.querySelector('[data-product-panels-tab="' + index + '"]');
          if (tabEl) tabEl.textContent = data.title;

          hasContent = true;
        }

        const includedTitleEl = panelEl.querySelector('[data-panel-included-title]');
        if (includedTitleEl && typeof data.included === 'string' && data.included) {
          includedTitleEl.textContent = data.included;
          hasContent = true;
        }

        const itemsEl = panelEl.querySelector('[data-panel-items]');
        const labels = itemLabels(data);
        if (itemsEl && labels.length) {
          itemsEl.innerHTML = '';
          labels.forEach((label) => {
            const li = document.createElement('li');
            li.className = 'product-panels__item';

            const span = document.createElement('span');
            span.className = 'product-panels__item-label';
            span.textContent = label;

            li.appendChild(span);
            itemsEl.appendChild(li);
          });
          hasContent = true;
        }
      });

      return hasContent;
    };

    if (typeof window.attachSectionLoading === 'function') {
      window.attachSectionLoading({ root, source: 'aem', apply, label: 'product-panels', timeoutMs: 60000 });
    } else if (window.dataAEM) {
      apply(window.dataAEM);
    } else {
      document.addEventListener('aem:data:loaded', (e) => apply(e.detail || window.dataAEM), { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["release-notes-pdf"] && !Shopify.designMode) return;
  try {
    
  document.documentElement.classList.add('body--release-notes');
  document.body.classList.add('body--release-notes');

  (function() {
    var isMobile = /Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      || (navigator.maxTouchPoints > 1 && /Macintosh/i.test(navigator.userAgent));

    if (isMobile) {
      var iframe = document.getElementById('release-notes-iframe');
      if (iframe) {
        var pdfUrl = iframe.getAttribute('data-pdf-url');
        iframe.src = 'https://docs.google.com/gview?url=' + encodeURIComponent(pdfUrl) + '&embedded=true';
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-split-banner]');
    if (!root) return;

    const titleEl    = root.querySelector('[data-split-banner-title]');
    const descEl     = root.querySelector('[data-split-banner-description]');
    const mediaEl    = root.querySelector('[data-split-banner-media]');
    const imageEl    = root.querySelector('[data-split-banner-image]');
    const videoEl    = root.querySelector('[data-split-banner-video]');
    const playEl     = root.querySelector('[data-split-banner-play]');
    const ctaEl      = root.querySelector('[data-split-banner-cta]');
    const ctaLabelEl = root.querySelector('[data-split-banner-cta-label]');

    const VIDEO_EXT = /\.(mp4|webm|ogg|ogv|mov|m4v)(\?.*)?$/i;
    const isVideoUrl = (url) => typeof url === 'string' && VIDEO_EXT.test(url);

    // The backend may send the CTA url without a protocol (e.g. "example.com/page").
    // Always resolve it as an absolute https URL, never relative to the current page.
    const normalizeCtaUrl = (url) => {
      const trimmed = String(url).trim();
      if (/^https?:\/\//i.test(trimmed)) return trimmed;
      return 'https://' + trimmed.replace(/^\/+/, '');
    };

    // Browsers only allow autoplay when muted, so the video loops silently and
    // the overlay button lets the visitor restart it from the top with sound.
    if (playEl && videoEl) {
      playEl.addEventListener('click', () => {
        videoEl.currentTime = 0;
        videoEl.muted = false;
        videoEl.controls = true;
        videoEl.play().catch(() => {});
        playEl.hidden = true;
      });
    }

    const resetVideo = () => {
      if (!videoEl) return;
      videoEl.hidden = true;
      videoEl.pause();
      videoEl.muted = true;
      videoEl.controls = false;
      videoEl.removeAttribute('src');
      videoEl.load();
      if (playEl) playEl.hidden = true;
    };

    const apply = (data) => {
      const banner = data && data.theme && (data.theme.secondary || data.theme.splitBanner);
      if (!banner) return false;

      if (titleEl && banner.title) {
        titleEl.textContent = banner.title;
        titleEl.hidden = false;
      }

      if (descEl && banner.body) {
        descEl.textContent = banner.body;
        descEl.hidden = false;
      }

      if (banner.bannerUrl && mediaEl) {
        // The preview re-injects data on every theme change, so reset the
        // unused element each time — otherwise switching media type leaves
        // both the image and the video (and its play button) visible.
        if (isVideoUrl(banner.bannerUrl) && videoEl) {
          videoEl.muted = true;
          videoEl.controls = false;
          videoEl.src = banner.bannerUrl;
          videoEl.hidden = false;
          if (playEl) playEl.hidden = false;
          if (imageEl) {
            imageEl.hidden = true;
            imageEl.removeAttribute('src');
          }
        } else if (imageEl) {
          imageEl.src = banner.bannerUrl;
          if (banner.title) imageEl.alt = banner.title;
          imageEl.hidden = false;
          resetVideo();
        }
        mediaEl.hidden = false;
      }

      if (ctaEl && banner.buttonText && banner.url) {
        ctaEl.href = normalizeCtaUrl(banner.url);
        if (ctaLabelEl) ctaLabelEl.textContent = banner.buttonText;
        ctaEl.hidden = false;
      }

      if (banner.fullWidth === true) {
        root.classList.add('split-banner--full-width');
        root.classList.remove('section--page-width');
      }

      return true;
    };

    if (typeof window.attachSectionLoading === 'function') {
      window.attachSectionLoading({ root, source: 'dmo', apply, label: 'split-banner' });
    } else if (window.data) {
      apply(window.data);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
